import _classCallCheck2 from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass2 from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn2 from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf2 from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits2 from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized2 from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _regeneratorRuntime from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray2 from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/opt/github-actions-runner/_work/login/login/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useState, useCallback, useEffect, Component } from 'react';
import { jsx } from 'react/jsx-runtime';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign$ = function __assign$2() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$.apply(this, arguments);
};

function __awaiter$2(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator$2(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var defaultUserInfo$1 = {
  avatar: '',
  lives: [],
  loggedIn: false,
  seasonCode: '',
  user: {
    userId: 0,
    firstName: '',
    lastName: '',
    role: '',
    shippingCountry: '',
    shippingState: '',
    shippingZipCode: '',
    shippingCity: '',
    subscriptionEndDate: 0,
    subscriptionStartDate: 0,
    subscriptionState: '',
    subscriptionType: '',
    email: '',
    planCode: ''
  }
};
var defaultContext$1 = {
  userInfo: defaultUserInfo$1,
  clearStorage: function clearStorage() {},
  invalidateUserCache: function invalidateUserCache() {}
};

function request$1(_a) {
  var path = _a.path,
      _b = _a.method,
      method = _b === void 0 ? 'GET' : _b,
      body = _a.body,
      _c = _a.json,
      json = _c === void 0 ? true : _c,
      _d = _a.contentType,
      contentType = _d === void 0 ? 'application/json; charset=utf-8' : _d;
  return __awaiter$2(this, void 0, void 0, function () {
    var defaultHeaders, response, status;
    return __generator$2(this, function (_e) {
      switch (_e.label) {
        case 0:
          defaultHeaders = {
            'FFF-Auth': 'V1.1',
            'Content-Type': contentType
          };
          return [4, fetch(path, {
            credentials: 'include',
            headers: _assign$({}, defaultHeaders),
            body: method !== 'GET' ? body : null,
            mode: 'cors',
            method: method
          })];

        case 1:
          response = _e.sent();
          status = response.status;

          switch (status) {
            case 200:
              return [2, json ? response.json() : response.text()];

            case 400:
              return [2, Promise.reject(new Error('Bad request'))];

            case 401:
              return [2, Promise.reject(new Error('Unauthorized'))];

            case 403:
              return [2, Promise.reject(new Error('Forbidden'))];

            case 408:
              return [2, Promise.reject(new Error('Timeout'))];

            case 500:
              return [2, Promise.reject(new Error('API internal error'))];

            case 502:
              return [2, Promise.reject(new Error('Proxy error'))];

            case 503:
              return [2, Promise.reject(new Error('Service unavailable'))];

            case 504:
              return [2, Promise.reject(new Error('Timeout'))];

            default:
              return [2, Promise.reject(new Error("Unhandled HTTP code: ".concat(status)))];
          }

      }
    });
  });
}

function isBrowser$3() {
  return ![typeof window, typeof document].includes('undefined');
}

var getFromStorage$1 = function getFromStorage$1(_a) {
  var key = _a.key,
      _b = _a.defaultItem,
      defaultItem = _b === void 0 ? null : _b;
  if (!isBrowser$3()) return defaultItem;
  var stgItem = sessionStorage.getItem("FFF_".concat(key));
  if (!stgItem) return defaultItem;

  try {
    var _c = JSON.parse(stgItem),
        createAt = _c.createAt,
        durationInMs = _c.durationInMs,
        data = _c.data;

    var currentTime = Date.now();
    var isExpired = durationInMs !== 0 && createAt + durationInMs < currentTime;

    if (!durationInMs || createAt && durationInMs && data && !isExpired) {
      return data;
    }

    removeFromStorage$1({
      key: key
    });
  } catch (error) {
    console.error('Error when deserializing JSON navigation');
  }

  return defaultItem;
};

var setToStorage$1 = function setToStorage$1(_a) {
  var key = _a.key,
      value = _a.value,
      _b = _a.durationInMs,
      durationInMs = _b === void 0 ? 0 : _b;
  var itemWithExpirationTime = {
    createAt: Date.now(),
    durationInMs: durationInMs,
    data: value
  };
  var json = JSON.stringify(itemWithExpirationTime);

  if (isBrowser$3()) {
    sessionStorage.setItem("FFF_".concat(key), json);
  }
};

var removeFromStorage$1 = function removeFromStorage$1(_a) {
  var key = _a.key;

  if (isBrowser$3()) {
    sessionStorage.removeItem("FFF_".concat(key));
  }
};

var clearStorage = function clearStorage() {
  if (isBrowser$3()) {
    sessionStorage.clear();
  }
};

var clearFFFStorage = function clearFFFStorage() {
  if (isBrowser$3()) {
    Object.keys(sessionStorage).forEach(function (key) {
      if (key.startsWith('FFF_')) {
        sessionStorage.removeItem(key);
      }
    });
  }
};

var storage = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFromStorage: getFromStorage$1,
  setToStorage: setToStorage$1,
  removeFromStorage: removeFromStorage$1,
  clearStorage: clearStorage,
  clearFFFStorage: clearFFFStorage
});

var hostname$3 = function hostname$3() {
  return isBrowser$3() ? window.location.hostname : 'fabfitfun.com';
};

var EnvironmentNames$2;

(function (EnvironmentNames) {
  EnvironmentNames["PROD"] = "prod";
  EnvironmentNames["QA"] = "qa";
  EnvironmentNames["DEV"] = "dev";
  EnvironmentNames["LOCAL"] = "local";
})(EnvironmentNames$2 || (EnvironmentNames$2 = {}));

var EnvironmentNames$1$1 = EnvironmentNames$2;

var getEnvUsingWindowLocation$1 = function getEnvUsingWindowLocation$1() {
  if (hostname$3().includes('fabfitfun')) return EnvironmentNames$1$1.PROD;
  if (hostname$3().includes('fff-qa')) return EnvironmentNames$1$1.QA;
  return EnvironmentNames$1$1.DEV;
};

var getEnv$3 = function getEnv$3(getEnvProps) {
  var enF = (getEnvProps === null || getEnvProps === void 0 ? void 0 : getEnvProps.env) || getEnvUsingWindowLocation$1();

  if (enF === EnvironmentNames$1$1.LOCAL) {
    return _assign$(_assign$({}, getEnv$3({
      env: EnvironmentNames$1$1.DEV
    })), {
      name: EnvironmentNames$1$1.LOCAL
    });
  }

  if (enF === EnvironmentNames$1$1.PROD) {
    return {
      name: EnvironmentNames$1$1.PROD,
      REACT_APP_NAVIGATOR_URL: 'https://universal-navigation-api.fabfitfun.com',
      REACT_APP_USER_INFO_URL: 'https://universal-navigation-api.fabfitfun.com/menu/user-data',
      REACT_APP_BASE_URL: 'https://fabfitfun.com',
      REACT_APP_TIMER_URL: 'https://universal-navigation-api.fabfitfun.com/timer',
      REACT_APP_NEW_MEMBER_CAMPAIGN_URL: 'https://customize-api.fabfitfun.com/customize/new-members/self/campaign-state',
      REACT_APP_NEW_MEMBER_API_URL: 'https://new-member-api.fabfitfun.com',
      REACT_APP_BANNER_URL: 'https://homepage-api.fabfitfun.com/megaphone-banners/current',
      REACT_APP_ADDONS_URL: 'https://fabfitfun.com/add-ons',
      REACT_APP_EDIT_URL: 'https://fabfitfun.com/edit'
    };
  }

  return {
    name: enF,
    REACT_APP_NAVIGATOR_URL: "https://universal-navigation-api.fff-".concat(enF, ".com"),
    REACT_APP_USER_INFO_URL: "https://universal-navigation-api.fff-".concat(enF, ".com/menu/user-data"),
    REACT_APP_BASE_URL: "https://fff-".concat(enF, ".com"),
    REACT_APP_TIMER_URL: "https://universal-navigation-api.fff-".concat(enF, ".com/timer"),
    REACT_APP_NEW_MEMBER_CAMPAIGN_URL: "https://customize-api.fff-".concat(enF, ".com/customize/new-members/self/campaign-state"),
    REACT_APP_NEW_MEMBER_API_URL: "https://new-member-api.fff-".concat(enF, ".com"),
    REACT_APP_BANNER_URL: "https://homepage-api.fff-".concat(enF, ".com/megaphone-banners/current"),
    REACT_APP_ADDONS_URL: "https://fff-".concat(enF, ".com/add-ons"),
    REACT_APP_EDIT_URL: "https://fff-".concat(enF, ".com/edit")
  };
};

var userInfoKey$1 = 'user-info-app';
var durationUserInfo$1 = 5 * 60 * 1000;

var fetchUserInfo$1 = function fetchUserInfo$1(_a) {
  var env = _a.env;
  return __awaiter$2(void 0, void 0, void 0, function () {
    var response;
    return __generator$2(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4, request$1({
            path: env.REACT_APP_USER_INFO_URL
          })];

        case 1:
          response = _b.sent();
          return [2, response];
      }
    });
  });
};

var invalidateUserCache = function invalidateUserCache() {
  return removeFromStorage$1({
    key: userInfoKey$1
  });
};

var getUserFromStorage = function getUserFromStorage() {
  return getFromStorage$1({
    key: userInfoKey$1,
    defaultItem: defaultUserInfo$1
  });
};

var getUserInfo$1 = function getUserInfo$1(forceRefresh) {
  if (forceRefresh === void 0) {
    forceRefresh = false;
  }

  return __awaiter$2(void 0, void 0, void 0, function () {
    var userFromSTG, requestUserInfo, err_1;
    return __generator$2(this, function (_a) {
      switch (_a.label) {
        case 0:
          userFromSTG = getFromStorage$1({
            key: userInfoKey$1
          });

          if (!forceRefresh && userFromSTG) {
            return [2, userFromSTG];
          }

          removeFromStorage$1({
            key: userInfoKey$1
          });
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4, fetchUserInfo$1({
            env: getEnv$3()
          })];

        case 2:
          requestUserInfo = _a.sent();

          if (requestUserInfo) {
            setToStorage$1({
              key: userInfoKey$1,
              value: requestUserInfo,
              durationInMs: durationUserInfo$1
            });
            return [2, requestUserInfo];
          }

          return [3, 4];

        case 3:
          err_1 = _a.sent();

          if (err_1.message === 'Unauthorized' || err_1.message === 'Forbidden') {
            removeFromStorage$1({
              key: userInfoKey$1
            });
          } else {
            console.log(err_1, err_1.message);
          }

          return [3, 4];

        case 4:
          return [2, defaultUserInfo$1];
      }
    });
  });
};

var isEqualObject = function isEqualObject(object1, object2) {
  if (!object1 && !object2) return true;
  if (!object1 && object2 || object1 && !object2) return false;
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) return false;

  for (var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++) {
    var key = keys1_1[_i];
    var val1 = object1[key];
    var val2 = object2[key];
    var areObjects = isObject(val1) && isObject(val2);
    if (areObjects && !isEqualObject(val1, val2) || !areObjects && val1 !== val2) return false;
  }

  return true;
};

var isObject = function isObject(object) {
  return object != null && typeof object === 'object';
};

var compare = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isEqualObject: isEqualObject,
  isObject: isObject
});
var UserContext = React.createContext(defaultContext$1);

var UserProvider = function UserProvider(userProviderProps) {
  var children = (userProviderProps || {
    children: null
  }).children;

  var _a = useState(getUserFromStorage()),
      userInfo = _a[0],
      setUserInfo = _a[1];

  var _b = useState(false),
      contextReady = _b[0],
      setContextReady = _b[1];

  var handleSetUserInfo = useCallback(function (newUserInfo) {
    if (!isEqualObject(newUserInfo, userInfo)) {
      setUserInfo(newUserInfo);
    }
  }, []);
  useEffect(function () {
    getUserInfo$1().then(function (newUserinfo) {
      handleSetUserInfo(newUserinfo);
      setContextReady(true);
    }).catch(function (err) {
      console.log(err);
      setContextReady(true);
    });
  }, [handleSetUserInfo]);
  var displayChildren = contextReady && children;
  return jsx(UserContext.Provider, _assign$({
    value: {
      userInfo: userInfo,
      clearStorage: clearFFFStorage,
      invalidateUserCache: invalidateUserCache
    }
  }, {
    children: displayChildren && children
  }));
};

function useUserContext() {
  var context = React.useContext(UserContext);

  if (!context) {
    throw new Error('You must use the User Provider in order to consume this context.');
  }

  return context;
}

var scriptExists = function scriptExists(srcPath) {
  var scripts = document.getElementsByTagName('script');
  var i = scripts.length;
  var flag = false;

  while (i--) {
    if (scripts[i].src === srcPath) {
      flag = true;
      break;
    }
  }

  return flag;
};

var scriptExistsById = function scriptExistsById(scriptId) {
  var script = document.getElementById(scriptId);
  if (script) return script.id === scriptId;
  return false;
};

var scriptExists$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  scriptExists: scriptExists,
  scriptExistsById: scriptExistsById
});

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      console.error(error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return /*#__PURE__*/React.createElement("h3", {
          style: {
            color: "lightcoral",
            textAlign: "center",
            border: "1px solid lightcoral",
            padding: 10
          }
        }, "Something went wrong.");
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(React.Component);

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule$1(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function require(path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var a = Object.defineProperty({}, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function get() {
        return n[k];
      }
    });
  });
  return a;
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var types$1 = createCommonjsModule$1(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Contains default values for the `reactOptions` object.
   */

  exports.defaultReactOptions = {
    useCamelCaseFlagKeys: true
  };
});
var context_1 = createCommonjsModule$1(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * @ignore
   */

  var context = React.createContext({
    flags: {},
    ldClient: undefined
  });
  var
  /**
   * @ignore
   */
  Provider = context.Provider,

  /**
   * @ignore
   */
  Consumer = context.Consumer;
  exports.Provider = Provider;
  exports.Consumer = Consumer;
  exports.default = context;
});

function e(n) {
  return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(n);
}

function n(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}

function t(e, n) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }

  return t;
}

function r(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = null != arguments[r] ? arguments[r] : {};
    r % 2 ? t(o, !0).forEach(function (t) {
      n(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : t(o).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }

  return e;
}

function o(e) {
  function n(e, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = n;
  }

  return n.prototype = new Error(), n.prototype.name = e, n.prototype.constructor = n, n;
}

var i = o("LaunchDarklyUnexpectedResponseError"),
    a = o("LaunchDarklyInvalidEnvironmentIdError"),
    u = o("LaunchDarklyInvalidUserError"),
    s = o("LaunchDarklyInvalidEventKeyError"),
    c = o("LaunchDarklyInvalidArgumentError"),
    l = o("LaunchDarklyFlagFetchError");

function f(e) {
  return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
}

for (var v = Object.freeze({
  __proto__: null,
  LDUnexpectedResponseError: i,
  LDInvalidEnvironmentIdError: a,
  LDInvalidUserError: u,
  LDInvalidEventKeyError: s,
  LDInvalidArgumentError: c,
  LDFlagFetchError: l,
  isHttpErrorRecoverable: f
}), d = [], g = [], p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", m = 0, h = p.length; m < h; ++m) {
  d[m] = p[m], g[p.charCodeAt(m)] = m;
}

function y(e, n, t) {
  for (var r, o, i = [], a = n; a < t; a += 3) {
    r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(d[(o = r) >> 18 & 63] + d[o >> 12 & 63] + d[o >> 6 & 63] + d[63 & o]);
  }

  return i.join("");
}

g["-".charCodeAt(0)] = 62, g["_".charCodeAt(0)] = 63;
var w = Array.isArray,
    b = Object.keys,
    k = Object.prototype.hasOwnProperty,
    E = ["key", "secondary", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];

function S(e) {
  return function (e) {
    for (var n, t = e.length, r = t % 3, o = [], i = 0, a = t - r; i < a; i += 16383) {
      o.push(y(e, i, i + 16383 > a ? a : i + 16383));
    }

    return 1 === r ? (n = e[t - 1], o.push(d[n >> 2] + d[n << 4 & 63] + "==")) : 2 === r && (n = (e[t - 2] << 8) + e[t - 1], o.push(d[n >> 10] + d[n >> 4 & 63] + d[n << 2 & 63] + "=")), o.join("");
  }(function (e) {
    for (var n = [], t = 0; t < e.length; t++) {
      n.push(e.charCodeAt(t));
    }

    return n;
  }(unescape(encodeURIComponent(e))));
}

function D(e) {
  return S(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

function O(e) {
  return JSON.parse(JSON.stringify(e));
}

function P(e, n) {
  return function e(n, t) {
    if (n === t) return !0;

    if (n && t && "object" == typeof n && "object" == typeof t) {
      var r,
          o,
          i,
          a = w(n),
          u = w(t);

      if (a && u) {
        if ((o = n.length) != t.length) return !1;

        for (r = o; 0 != r--;) {
          if (!e(n[r], t[r])) return !1;
        }

        return !0;
      }

      if (a != u) return !1;
      var s = n instanceof Date,
          c = t instanceof Date;
      if (s != c) return !1;
      if (s && c) return n.getTime() == t.getTime();
      var l = n instanceof RegExp,
          f = t instanceof RegExp;
      if (l != f) return !1;
      if (l && f) return n.toString() == t.toString();
      var v = b(n);
      if ((o = v.length) !== b(t).length) return !1;

      for (r = o; 0 != r--;) {
        if (!k.call(t, v[r])) return !1;
      }

      for (r = o; 0 != r--;) {
        if (!e(n[i = v[r]], t[i])) return !1;
      }

      return !0;
    }

    return n != n && t != t;
  }(e, n);
}

function U(e) {
  setTimeout(e, 0);
}

function R(e, n) {
  var t = e.then(function (e) {
    return n && setTimeout(function () {
      n(null, e);
    }, 0), e;
  }, function (e) {
    if (!n) return Promise.reject(e);
    setTimeout(function () {
      n(e, null);
    }, 0);
  });
  return n ? void 0 : t;
}

function j(e) {
  var n = {};

  for (var t in e) {
    x(e, t) && (n[t] = {
      value: e[t],
      version: 0
    });
  }

  return n;
}

function I(e) {
  var n = {};

  for (var t in e) {
    x(e, t) && (n[t] = e[t].value);
  }

  return n;
}

function T(e, n) {
  for (var t, r = n.slice(0), o = [], i = e; r.length > 0;) {
    for (t = []; i > 0;) {
      var a = r.shift();
      if (!a) break;
      (i -= D(JSON.stringify(a)).length) < 0 && t.length > 0 ? r.unshift(a) : t.push(a);
    }

    i = e, o.push(t);
  }

  return o;
}

function N(e) {
  var n = e.version || "3.3.1";
  return e.userAgent + "/" + n;
}

function L(e, n) {
  if (n && !n.sendLDHeaders) return {};
  var t = {
    "X-LaunchDarkly-User-Agent": N(e)
  };
  return n && n.wrapperName && (t["X-LaunchDarkly-Wrapper"] = n.wrapperVersion ? n.wrapperName + "/" + n.wrapperVersion : n.wrapperName), t;
}

function F() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
    n[t] = arguments[t];
  }

  return n.reduce(function (e, n) {
    return r({}, e, {}, n);
  }, {});
}

function x(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}

function C(e) {
  if (!e) return e;
  var n;

  for (var t in E) {
    var o = E[t],
        i = e[o];
    void 0 !== i && "string" != typeof i && ((n = n || r({}, e))[o] = String(i));
  }

  return n || e;
}

Object.freeze({
  __proto__: null,
  btoa: S,
  base64URLEncode: D,
  clone: O,
  deepEquals: P,
  onNextTick: U,
  wrapPromiseCallback: R,
  transformValuesToVersionedValues: j,
  transformVersionedValuesToValues: I,
  chunkUserEventsForUrl: T,
  getLDUserAgentString: N,
  getLDHeaders: L,
  extend: F,
  objectHasOwnProperty: x,
  sanitizeUser: C
});

for (var A = function (e, n) {
  return function (e) {
    var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (n) {
      var t = new Uint8Array(16);

      e.exports = function () {
        return n(t), t;
      };
    } else {
      var r = new Array(16);

      e.exports = function () {
        for (var e, n = 0; n < 16; n++) {
          0 == (3 & n) && (e = 4294967296 * Math.random()), r[n] = e >>> ((3 & n) << 3) & 255;
        }

        return r;
      };
    }
  }(n = {
    exports: {}
  }), n.exports;
}(), q = [], V = 0; V < 256; ++V) {
  q[V] = (V + 256).toString(16).substr(1);
}

var _,
    J,
    z = 0,
    M = 0,
    K = function K(e, n, t) {
  var r = n && t || 0,
      o = n || [],
      i = (e = e || {}).node || _,
      a = void 0 !== e.clockseq ? e.clockseq : J;

  if (null == i || null == a) {
    var u = A();
    null == i && (i = _ = [1 | u[0], u[1], u[2], u[3], u[4], u[5]]), null == a && (a = J = 16383 & (u[6] << 8 | u[7]));
  }

  var s = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
      c = void 0 !== e.nsecs ? e.nsecs : M + 1,
      l = s - z + (c - M) / 1e4;
  if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || s > z) && void 0 === e.nsecs && (c = 0), c >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  z = s, M = c, J = a;
  var f = (1e4 * (268435455 & (s += 122192928e5)) + c) % 4294967296;
  o[r++] = f >>> 24 & 255, o[r++] = f >>> 16 & 255, o[r++] = f >>> 8 & 255, o[r++] = 255 & f;
  var v = s / 4294967296 * 1e4 & 268435455;
  o[r++] = v >>> 8 & 255, o[r++] = 255 & v, o[r++] = v >>> 24 & 15 | 16, o[r++] = v >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;

  for (var d = 0; d < 6; ++d) {
    o[r + d] = i[d];
  }

  return n || function (e, n) {
    var t = n || 0,
        r = q;
    return [r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], "-", r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]], r[e[t++]]].join("");
  }(o);
};

function $(e, n, t) {
  var r = "/a/" + n + ".gif",
      o = F({
    "Content-Type": "application/json"
  }, L(e, t)),
      i = e.httpFallbackPing,
      a = {
    sendChunk: function sendChunk(n, t, a, u) {
      var s = JSON.stringify(n),
          c = a ? null : K();
      return u ? function n(r) {
        var i = a ? o : F({}, o, {
          "X-LaunchDarkly-Event-Schema": "3",
          "X-LaunchDarkly-Payload-ID": c
        });
        return e.httpRequest("POST", t, i, s).promise.then(function (e) {
          if (e) return e.status >= 400 && f(e.status) && r ? n(!1) : function (e) {
            var n = {
              status: e.status
            },
                t = e.header("date");

            if (t) {
              var r = Date.parse(t);
              r && (n.serverTime = r);
            }

            return n;
          }(e);
        }).catch(function () {
          return r ? n(!1) : Promise.reject();
        });
      }(!0).catch(function () {}) : (i && i(t + r + "?d=" + D(s)), Promise.resolve());
    },
    sendEvents: function sendEvents(n, t, r) {
      if (!e.httpRequest) return Promise.resolve();
      var o,
          i = e.httpAllowsPost();
      o = i ? [n] : T(2e3 - t.length, n);

      for (var u = [], s = 0; s < o.length; s++) {
        u.push(a.sendChunk(o[s], t, r, i));
      }

      return Promise.all(u);
    }
  };
  return a;
}

function H() {
  var e = {},
      n = 0,
      t = 0,
      r = {};
  return e.summarizeEvent = function (e) {
    if ("feature" === e.kind) {
      var o = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""),
          i = r[o];
      i ? i.count = i.count + 1 : r[o] = {
        count: 1,
        key: e.key,
        variation: e.variation,
        version: e.version,
        value: e.value,
        default: e.default
      }, (0 === n || e.creationDate < n) && (n = e.creationDate), e.creationDate > t && (t = e.creationDate);
    }
  }, e.getSummary = function () {
    var e = {},
        o = !0;

    for (var i in r) {
      var a = r[i],
          u = e[a.key];
      u || (u = {
        default: a.default,
        counters: []
      }, e[a.key] = u);
      var s = {
        value: a.value,
        count: a.count
      };
      void 0 !== a.variation && null !== a.variation && (s.variation = a.variation), a.version ? s.version = a.version : s.unknown = !0, u.counters.push(s), o = !1;
    }

    return o ? null : {
      startDate: n,
      endDate: t,
      features: e
    };
  }, e.clearSummary = function () {
    n = 0, t = 0, r = {};
  }, e;
}

function B(e) {
  var n = {},
      t = e.allAttributesPrivate,
      r = e.privateAttributeNames || [],
      o = {
    key: !0,
    custom: !0,
    anonymous: !0
  },
      i = {
    key: !0,
    secondary: !0,
    ip: !0,
    country: !0,
    email: !0,
    firstName: !0,
    lastName: !0,
    avatar: !0,
    name: !0,
    anonymous: !0,
    custom: !0
  };
  return n.filterUser = function (e) {
    if (!e) return null;

    var n = e.privateAttributeNames || [],
        a = function a(e, i) {
      return Object.keys(e).reduce(function (a, u) {
        var s = a;
        return i(u) && (function (e) {
          return !o[e] && (t || -1 !== n.indexOf(e) || -1 !== r.indexOf(e));
        }(u) ? s[1][u] = !0 : s[0][u] = e[u]), s;
      }, [{}, {}]);
    },
        u = a(e, function (e) {
      return i[e];
    }),
        s = u[0],
        c = u[1];

    if (e.custom) {
      var l = a(e.custom, function () {
        return !0;
      });
      s.custom = l[0], c = F({}, c, l[1]);
    }

    var f = Object.keys(c);
    return f.length && (f.sort(), s.privateAttrs = f), s;
  }, n;
}

function G(e) {
  return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}

var X = " Please see https://docs.launchdarkly.com/docs/js-sdk-reference#initializing-the-client for instructions on SDK initialization.",
    W = function W(e) {
  return 'Expected application/json content type but got "' + e + '"';
},
    Q = function Q(e) {
  return "network error" + (e ? " (" + e + ")" : "");
},
    Y = function Y(e) {
  return 'Custom event "' + e + '" does not exist';
},
    Z = function Z() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + X;
},
    ee = function ee() {
  return "No environment/client-side ID was specified." + X;
},
    ne = function ne(e) {
  return "Error fetching flag settings: " + G(e);
},
    te = function te() {
  return "No user specified." + X;
},
    re = function re() {
  return "Invalid user specified." + X;
},
    oe = function oe() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + X;
},
    ie = function ie(e, n) {
  return n ? '"' + e + '" is deprecated, please use "' + n + '"' : '"' + e + '" is deprecated';
},
    ae = function ae(e, n, t) {
  return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + n + " - " + (f(e) ? t : "giving up permanently");
},
    ue = function ue() {
  return "Cannot make HTTP requests in this environment." + X;
},
    se = function se(e) {
  return "Opening stream connection to " + e;
},
    ce = function ce(e, n) {
  return "Error on stream connection: " + G(e) + ", will continue retrying every " + n + " milliseconds.";
},
    le = function le(e) {
  return 'Ignoring unknown config option "' + e + '"';
},
    fe = function fe(e, n, t) {
  return 'Config option "' + e + '" should be of type ' + n + ", got " + t + ", using default value";
},
    ve = function ve(e, n) {
  return 'Config option "' + e + '" should be a boolean, got ' + n + ", converting to boolean";
},
    de = function de(e, n, t) {
  return 'Config option "' + e + '" was set to ' + n + ", changing to minimum value of " + t;
},
    ge = function ge(e) {
  return "polling for feature flags at " + e;
},
    pe = function pe(e) {
  return 'received streaming update for flag "' + e + '"';
},
    me = function me(e) {
  return 'received streaming update for flag "' + e + '" but ignored due to version check';
},
    he = function he(e) {
  return 'received streaming deletion for flag "' + e + '"';
},
    ye = function ye(e) {
  return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
},
    we = function we(e) {
  return 'enqueueing "' + e + '" event';
},
    be = function be(e) {
  return "sending " + e + " events";
},
    ke = Object.freeze({
  __proto__: null,
  clientInitialized: function clientInitialized() {
    return "LaunchDarkly client initialized";
  },
  clientNotReady: function clientNotReady() {
    return "LaunchDarkly client is not ready";
  },
  eventCapacityExceeded: function eventCapacityExceeded() {
    return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
  },
  eventWithoutUser: function eventWithoutUser() {
    return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/docs/js-sdk-reference#section-analytics-events";
  },
  invalidContentType: W,
  invalidKey: function invalidKey() {
    return "Event key must be a string";
  },
  localStorageUnavailable: function localStorageUnavailable() {
    return "localStorage is unavailable";
  },
  localStorageUnavailableForUserId: function localStorageUnavailableForUserId() {
    return "localStorage is unavailable, so anonymous user ID cannot be cached";
  },
  networkError: Q,
  unknownCustomEventKey: Y,
  environmentNotFound: Z,
  environmentNotSpecified: ee,
  errorFetchingFlags: ne,
  userNotSpecified: te,
  invalidUser: re,
  bootstrapOldFormat: oe,
  bootstrapInvalid: function bootstrapInvalid() {
    return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
  },
  deprecated: ie,
  httpErrorMessage: ae,
  httpUnavailable: ue,
  identifyDisabled: function identifyDisabled() {
    return "identify() has no effect here; it must be called on the main client instance";
  },
  streamClosing: function streamClosing() {
    return "Closing stream connection";
  },
  streamConnecting: se,
  streamError: ce,
  unknownOption: le,
  wrongOptionType: fe,
  wrongOptionTypeBoolean: ve,
  optionBelowMinimum: de,
  debugPolling: ge,
  debugStreamPing: function debugStreamPing() {
    return "received ping message from stream";
  },
  debugStreamPut: function debugStreamPut() {
    return "received streaming update for all flags";
  },
  debugStreamPatch: pe,
  debugStreamPatchIgnored: me,
  debugStreamDelete: he,
  debugStreamDeleteIgnored: ye,
  debugEnqueueingEvent: we,
  debugPostingEvents: be,
  debugPostingDiagnosticEvent: function debugPostingDiagnosticEvent(e) {
    return "sending diagnostic event (" + e.kind + ")";
  }
});

function Ee(e, n, t, r, o) {
  var i = {};

  function a() {
    var e = "",
        o = r.getUser();
    return o && (e = t || S(JSON.stringify(o))), "ld:" + n + ":" + e;
  }

  return i.loadFlags = function () {
    return e.get(a()).then(function (e) {
      if (null == e) return null;

      try {
        var n = JSON.parse(e);

        if (n) {
          var t = n.$schema;
          void 0 === t || t < 1 ? n = j(n) : delete n.$schema;
        }

        return n;
      } catch (e) {
        return i.clearFlags().then(function () {
          return Promise.reject(e);
        });
      }
    }).catch(function (e) {
      return o.warn("localStorage is unavailable"), Promise.reject(e);
    });
  }, i.saveFlags = function (n) {
    var t = F({}, n, {
      $schema: 1
    });
    return e.set(a(), JSON.stringify(t)).catch(function (e) {
      return o.warn("localStorage is unavailable"), Promise.reject(e);
    });
  }, i.clearFlags = function () {
    return e.clear(a()).catch(function (e) {
      return o.warn("localStorage is unavailable"), Promise.reject(e);
    });
  }, i;
}

function Se(e, n, t, r) {
  var o,
      i = n.streamUrl,
      a = n.logger,
      u = {},
      s = i + "/eval/" + t,
      c = n.useReport,
      l = n.evaluationReasons,
      f = n.streamReconnectDelay,
      v = L(e, n),
      d = !1,
      g = null,
      p = null,
      m = null,
      h = null,
      y = null;

  function w(e) {
    d || (a.warn(ce(e, f)), d = !0), S(!1), E(), b(f);
  }

  function b(e) {
    p || (e ? p = setTimeout(k, e) : k());
  }

  function k() {
    var n;
    p = null;
    var r = "",
        u = {
      headers: v,
      readTimeoutMillis: 3e5
    };

    if (e.eventSourceFactory) {
      for (var f in null != h && (r = "h=" + h), c ? e.eventSourceAllowsReport ? (n = s, u.method = "REPORT", u.headers["Content-Type"] = "application/json", u.body = JSON.stringify(m)) : (n = i + "/ping/" + t, r = "") : n = s + "/" + D(JSON.stringify(m)), l && (r = r + (r ? "&" : "") + "withReasons=true"), n = n + (r ? "?" : "") + r, E(), a.info(se(n)), o = new Date().getTime(), g = e.eventSourceFactory(n, u), y) {
        x(y, f) && g.addEventListener(f, y[f]);
      }

      g.onerror = w;
    }
  }

  function E() {
    g && (a.info("Closing stream connection"), g.close(), g = null);
  }

  function S(e) {
    o && r && r.recordStreamInit(o, !e, new Date().getTime() - o), o = null;
  }

  return u.connect = function (e, n, t) {
    m = e, h = n, y = {};

    var r = function r(e) {
      y[e] = function (n) {
        d = !1, S(!0), t[e] && t[e](n);
      };
    };

    for (var o in t || {}) {
      r(o);
    }

    b();
  }, u.disconnect = function () {
    clearTimeout(p), p = null, E();
  }, u.isConnected = function () {
    return !!(g && e.eventSourceIsActive && e.eventSourceIsActive(g));
  }, u;
}

function De(e, n, t) {
  var r = n.baseUrl,
      o = n.useReport,
      i = n.evaluationReasons,
      u = n.logger,
      s = {},
      c = {};

  function f(t, r) {
    if (!e.httpRequest) return new Promise(function (e, n) {
      n(new l(ue()));
    });
    var o = r ? "REPORT" : "GET",
        i = L(e, n);
    r && (i["Content-Type"] = "application/json");
    var u = c[t];
    u || (u = function (e) {
      var n,
          t,
          r,
          o,
          i = {
        addPromise: function addPromise(i, a) {
          n = i, t && t(), t = a, i.then(function (t) {
            n === i && (r(t), e && e());
          }, function (t) {
            n === i && (o(t), e && e());
          });
        }
      };
      return i.resultPromise = new Promise(function (e, n) {
        r = e, o = n;
      }), i;
    }(function () {
      delete c[t];
    }), c[t] = u);
    var s = e.httpRequest(o, t, i, r),
        f = s.promise.then(function (e) {
      if (200 === e.status) {
        if (e.header("content-type") && "application/json" === e.header("content-type").substring(0, "application/json".length)) return JSON.parse(e.body);
        var n = W(e.header("content-type") || "");
        return Promise.reject(new l(n));
      }

      return Promise.reject(function (e) {
        return 404 === e.status ? new a(Z()) : new l(ne(e.statusText || String(e.status)));
      }(e));
    }, function (e) {
      return Promise.reject(new l(Q(e)));
    });
    return u.addPromise(f, function () {
      s.cancel && s.cancel();
    }), u.resultPromise;
  }

  return s.fetchJSON = function (e) {
    return f(r + e, null);
  }, s.fetchFlagSettings = function (e, n) {
    var a,
        s,
        c,
        l = "";
    return o ? (s = [r, "/sdk/evalx/", t, "/user"].join(""), c = JSON.stringify(e)) : (a = D(JSON.stringify(e)), s = [r, "/sdk/evalx/", t, "/users/", a].join("")), n && (l = "h=" + n), i && (l = l + (l ? "&" : "") + "withReasons=true"), s = s + (l ? "?" : "") + l, u.debug(ge(s)), f(s, c);
  }, s;
}

function Oe(e, n) {
  var t = {
    validateUser: function validateUser(t) {
      if (!t) return Promise.reject(new u(te()));
      var r = O(t);
      return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? (e ? e.get("ld:$anonUserId").catch(function () {
        return null;
      }) : Promise.resolve(null)).then(function (t) {
        if (t) return r.key = t, r;
        var o = K();
        return r.key = o, function (t) {
          return e ? e.set("ld:$anonUserId", t).catch(function () {
            n.warn("localStorage is unavailable, so anonymous user ID cannot be cached");
          }) : Promise.resolve();
        }(o).then(function () {
          return r;
        });
      }) : Promise.reject(new u(re()));
    }
  };
  return t;
}

var Pe = {
  baseUrl: {
    default: "https://app.launchdarkly.com"
  },
  streamUrl: {
    default: "https://clientstream.launchdarkly.com"
  },
  eventsUrl: {
    default: "https://events.launchdarkly.com"
  },
  sendEvents: {
    default: !0
  },
  streaming: {
    type: "boolean"
  },
  sendLDHeaders: {
    default: !0
  },
  inlineUsersInEvents: {
    default: !1
  },
  allowFrequentDuplicateEvents: {
    default: !1
  },
  sendEventsOnlyForVariation: {
    default: !1
  },
  useReport: {
    default: !1
  },
  evaluationReasons: {
    default: !1
  },
  eventCapacity: {
    default: 100,
    minimum: 1
  },
  flushInterval: {
    default: 2e3,
    minimum: 2e3
  },
  samplingInterval: {
    default: 0,
    minimum: 0
  },
  streamReconnectDelay: {
    default: 1e3,
    minimum: 0
  },
  allAttributesPrivate: {
    default: !1
  },
  privateAttributeNames: {
    default: []
  },
  bootstrap: {
    type: "string|object"
  },
  diagnosticRecordingInterval: {
    default: 9e5,
    minimum: 2e3
  },
  diagnosticOptOut: {
    default: !1
  },
  wrapperName: {
    type: "string"
  },
  wrapperVersion: {
    type: "string"
  },
  stateProvider: {
    type: "object"
  },
  autoAliasingOptOut: {
    default: !1
  }
};

function Ue(n, t, r, o) {
  var i = F({
    logger: {
      default: o
    }
  }, Pe, r),
      a = {
    all_attributes_private: "allAttributesPrivate",
    private_attribute_names: "privateAttributeNames",
    samplingInterval: null
  };

  function u(e) {
    U(function () {
      t && t.maybeReportError(new c(e));
    });
  }

  var s = F({}, n || {});
  return function (e) {
    var n = e;
    Object.keys(a).forEach(function (e) {
      if (void 0 !== n[e]) {
        var t = a[e];
        o && o.warn(ie(e, t)), t && (void 0 === n[t] && (n[t] = n[e]), delete n[e]);
      }
    });
  }(s), function (n) {
    var t = F({}, n),
        r = function r(n) {
      if (null === n) return "any";

      if (void 0 !== n) {
        if (Array.isArray(n)) return "array";
        var t = e(n);
        return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
      }
    };

    return Object.keys(n).forEach(function (e) {
      var o = n[e];

      if (null != o) {
        var a = i[e];
        if (void 0 === a) u(le(e));else {
          var s = a.type || r(a.default);

          if ("any" !== s) {
            var c = s.split("|"),
                l = r(o);
            c.indexOf(l) < 0 ? "boolean" === s ? (t[e] = !!o, u(ve(e, l))) : (u(fe(e, s, l)), t[e] = a.default) : "number" === l && void 0 !== a.minimum && o < a.minimum && (u(de(e, o, a.minimum)), t[e] = a.minimum);
          }
        }
      }
    }), t;
  }(s = function (e) {
    var n = F({}, e);
    return Object.keys(i).forEach(function (e) {
      void 0 !== n[e] && null !== n[e] || (n[e] = i[e] && i[e].default);
    }), n;
  }(s));
}

var Re = Object.freeze({
  __proto__: null,
  baseOptionDefs: Pe,
  validate: Ue
}).baseOptionDefs,
    je = function je(e) {
  var n = {
    diagnosticId: K()
  };
  return e && (n.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), n;
};

function Ie(e, n) {
  var t,
      r = ["debug", "info", "warn", "error"];
  t = null != n ? "" === n ? "" : n + " " : "LD: ";
  var o = 0;
  e && (o = "none" === e ? 100 : r.indexOf(e));
  var i = {};

  function a(e, n, i) {
    if (e >= o && console) {
      var a = console[n];

      if (a) {
        var u = e < r.length ? r[e] : "?";
        a.call(console, t + "[" + u + "] " + i);
      }
    }
  }

  return i.debug = function (e) {
    return a(0, "log", e);
  }, i.info = function (e) {
    return a(1, "info", e);
  }, i.warn = function (e) {
    return a(2, "warn", e);
  }, i.error = function (e) {
    return a(3, "error", e);
  }, i;
}

function Te(n, t, o, u, c) {
  var v,
      d,
      g,
      p,
      m = o && o.logger ? o.logger : c && c.logger && c.logger.default || Ie("warn"),
      h = function (e) {
    var n = {},
        t = {};
    return n.on = function (e, n, r) {
      t[e] = t[e] || [], t[e] = t[e].concat({
        handler: n,
        context: r
      });
    }, n.off = function (e, n, r) {
      if (t[e]) for (var o = 0; o < t[e].length; o++) {
        t[e][o].handler === n && t[e][o].context === r && (t[e] = t[e].slice(0, o).concat(t[e].slice(o + 1)));
      }
    }, n.emit = function (e) {
      if (t[e]) for (var n = t[e].slice(0), r = 0; r < n.length; r++) {
        n[r].handler.apply(n[r].context, Array.prototype.slice.call(arguments, 1));
      }
    }, n.getEvents = function () {
      return Object.keys(t);
    }, n.getEventListenerCount = function (e) {
      return t[e] ? t[e].length : 0;
    }, n.maybeReportError = function (n) {
      n && (t.error ? this.emit("error", n) : (e || console).error(n.message));
    }, n;
  }(m),
      y = function (e) {
    var n = !1,
        t = !1,
        r = null,
        o = null,
        i = new Promise(function (n) {
      e.on("ready", function t() {
        e.off("ready", t), n();
      });
    }).catch(function () {});
    return {
      getInitializationPromise: function getInitializationPromise() {
        return o || (n ? Promise.resolve() : t ? Promise.reject(r) : o = new Promise(function (n, t) {
          e.on("initialized", function t() {
            e.off("initialized", t), n();
          }), e.on("failed", function n(r) {
            e.off("failed", n), t(r);
          });
        }));
      },
      getReadyPromise: function getReadyPromise() {
        return i;
      },
      signalSuccess: function signalSuccess() {
        n || t || (n = !0, e.emit("initialized"), e.emit("ready"));
      },
      signalFailure: function signalFailure(o) {
        n || t || (t = !0, r = o, e.emit("failed", o), e.emit("ready")), e.maybeReportError(o);
      }
    };
  }(h),
      w = Ue(o, h, c, m),
      b = w.sendEvents,
      k = n,
      E = w.hash,
      S = $(u, k, w),
      D = w.sendEvents && !w.diagnosticOptOut,
      j = D ? je(k) : null,
      T = D ? function (e) {
    var n, t, r, o;

    function i(e) {
      n = e, t = 0, r = 0, o = [];
    }

    return i(e), {
      getProps: function getProps() {
        return {
          dataSinceDate: n,
          droppedEvents: t,
          eventsInLastBatch: r,
          streamInits: o
        };
      },
      setProps: function setProps(e) {
        n = e.dataSinceDate, t = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
      },
      incrementDroppedEvents: function incrementDroppedEvents() {
        t++;
      },
      setEventsInLastBatch: function setEventsInLastBatch(e) {
        r = e;
      },
      recordStreamInit: function recordStreamInit(e, n, t) {
        var r = {
          timestamp: e,
          failed: n,
          durationMillis: t
        };
        o.push(r);
      },
      reset: i
    };
  }(new Date().getTime()) : null,
      N = D ? function (e, n, t, o, i, a) {
    var u,
        s,
        c = !!e.diagnosticUseCombinedEvent,
        l = "ld:" + o + ":$diagnostics",
        f = i.eventsUrl + "/events/diagnostic/" + o,
        v = i.diagnosticRecordingInterval,
        d = n,
        g = !!i.streaming,
        p = {};

    function m() {
      return {
        sdk: w(),
        configuration: (n = {
          customBaseURI: i.baseUrl !== Re.baseUrl.default,
          customStreamURI: i.streamUrl !== Re.streamUrl.default,
          customEventsURI: i.eventsUrl !== Re.eventsUrl.default,
          eventsCapacity: i.eventCapacity,
          eventsFlushIntervalMillis: i.flushInterval,
          reconnectTimeMillis: i.streamReconnectDelay,
          streamingDisabled: !g,
          allAttributesPrivate: !!i.allAttributesPrivate,
          inlineUsersInEvents: !!i.inlineUsersInEvents,
          diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
          usingSecureMode: !!i.hash,
          bootstrapMode: !!i.bootstrap,
          fetchGoalsDisabled: !i.fetchGoals,
          allowFrequentDuplicateEvents: !!i.allowFrequentDuplicateEvents,
          sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation,
          autoAliasingOptOut: !!i.autoAliasingOptOut
        }, n),
        platform: e.diagnosticPlatformData
      };
      var n;
    }

    function h(e) {
      i.logger && i.logger.debug(ke.debugPostingDiagnosticEvent(e)), t.sendEvents(e, f, !0).then(function () {}).catch(function () {});
    }

    function y() {
      var n, t;
      h((n = new Date().getTime(), t = r({
        kind: c ? "diagnostic-combined" : "diagnostic",
        id: a,
        creationDate: n
      }, d.getProps()), c && (t = r({}, t, {}, m())), d.reset(n), t)), s = setTimeout(y, v), u = new Date().getTime(), c && function () {
        if (e.localStorage) {
          var n = r({}, d.getProps());
          e.localStorage.set(l, JSON.stringify(n), function () {});
        }
      }();
    }

    function w() {
      var n = r({}, e.diagnosticSdkData);
      return i.wrapperName && (n.wrapperName = i.wrapperName), i.wrapperVersion && (n.wrapperVersion = i.wrapperVersion), n;
    }

    return p.start = function () {
      c ? function (n) {
        if (!e.localStorage) return n(!1);
        e.localStorage.get(l).then(function (e) {
          if (e) try {
            var t = JSON.parse(e);
            d.setProps(t), u = t.dataSinceDate;
          } catch (e) {}
          n(!0);
        }).catch(function () {
          n(!1);
        });
      }(function (e) {
        if (e) {
          var n = (u || 0) + v,
              t = new Date().getTime();
          t >= n ? y() : s = setTimeout(y, n - t);
        } else 0 === Math.floor(4 * Math.random()) ? y() : s = setTimeout(y, v);
      }) : (h(r({
        kind: "diagnostic-init",
        id: a,
        creationDate: d.getProps().dataSinceDate
      }, m())), s = setTimeout(y, v));
    }, p.stop = function () {
      s && clearTimeout(s);
    }, p.setStreaming = function (e) {
      g = e;
    }, p;
  }(u, T, S, k, w, j) : null,
      L = Se(u, w, k, T),
      A = w.eventProcessor || function (e, n, t) {
    var r,
        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
        a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
        u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        s = {},
        c = u || $(e, t, n),
        l = n.eventsUrl + "/events/bulk/" + t,
        v = H(),
        d = B(n),
        g = n.inlineUsersInEvents,
        p = n.samplingInterval,
        m = n.eventCapacity,
        h = n.flushInterval,
        y = n.logger,
        w = [],
        b = 0,
        k = !1,
        E = !1;

    function S() {
      return 0 === p || 0 === Math.floor(Math.random() * p);
    }

    function D(e) {
      return !!e.debugEventsUntilDate && e.debugEventsUntilDate > b && e.debugEventsUntilDate > new Date().getTime();
    }

    function O(e) {
      var n = F({}, e);
      return "alias" === e.kind || (g || "identify" === e.kind ? n.user = d.filterUser(e.user) : (n.userKey = e.user.key, delete n.user), "feature" === e.kind && (delete n.trackEvents, delete n.debugEventsUntilDate)), n;
    }

    function P(e) {
      w.length < m ? (w.push(e), E = !1) : (E || (E = !0, y.warn("Exceeded event queue capacity. Increase capacity to avoid dropping events.")), o && o.incrementDroppedEvents());
    }

    return s.enqueue = function (e) {
      if (!k) {
        var n = !1,
            t = !1;

        if (v.summarizeEvent(e), "feature" === e.kind ? S() && (n = !!e.trackEvents, t = D(e)) : n = S(), n && P(O(e)), t) {
          var r = F({}, e, {
            kind: "debug"
          });
          delete r.trackEvents, delete r.debugEventsUntilDate, delete r.variation, P(r);
        }
      }
    }, s.flush = function () {
      if (k) return Promise.resolve();
      var e = w,
          n = v.getSummary();
      return v.clearSummary(), n && (n.kind = "summary", e.push(n)), o && o.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (w = [], y.debug(be(e.length)), c.sendEvents(e, l).then(function (e) {
        e && (e.serverTime && (b = e.serverTime), f(e.status) || (k = !0), e.status >= 400 && U(function () {
          a.maybeReportError(new i(ae(e.status, "event posting", "some events were dropped")));
        }));
      }));
    }, s.start = function () {
      r = setTimeout(function e() {
        s.flush(), r = setTimeout(e, h);
      }, h);
    }, s.stop = function () {
      clearTimeout(r);
    }, s;
  }(u, w, k, T, h, S),
      q = De(u, w, k),
      V = {},
      _ = {},
      J = w.streaming,
      z = !1,
      M = !1,
      K = !0,
      G = w.stateProvider,
      X = function (e, n) {
    var t,
        r = {
      setUser: function setUser(e) {
        var r = t && O(t);
        (t = C(e)) && n && n(O(t), r);
      },
      getUser: function getUser() {
        return t ? O(t) : null;
      }
    };
    return r;
  }(0, function (e, n) {
    (function (e) {
      G || e && Q({
        kind: "identify",
        key: e.key,
        user: e,
        creationDate: new Date().getTime()
      });
    })(e), !w.autoAliasingOptOut && n && n.anonymous && e && !e.anonymous && ue(e, n);
  }),
      W = Oe(u.localStorage, m);

  function Q(e) {
    if (k && !(G && G.enqueueEvent && G.enqueueEvent(e))) {
      if ("alias" !== e.kind) {
        if (!e.user) return void (K && (m.warn("Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/docs/js-sdk-reference#section-analytics-events"), K = !1));
        K = !1;
      }

      !b || M || u.isDoNotTrack() || (m.debug(we(e.kind)), A.enqueue(e));
    }
  }

  function Z(e, n, t, r) {
    var o = X.getUser(),
        i = new Date(),
        a = n ? n.value : null;

    if (!w.allowFrequentDuplicateEvents) {
      var u = JSON.stringify(a) + (o && o.key ? o.key : "") + e,
          s = V[u];
      if (s && i - s < 3e5) return;
      V[u] = i;
    }

    var c = {
      kind: "feature",
      key: e,
      user: o,
      value: a,
      variation: n ? n.variationIndex : null,
      default: t,
      creationDate: i.getTime()
    };
    o && o.anonymous && (c.contextKind = ie(o));
    var l = _[e];
    l && (c.version = l.flagVersion ? l.flagVersion : l.version, c.trackEvents = l.trackEvents, c.debugEventsUntilDate = l.debugEventsUntilDate), (r || l && l.trackReason) && n && (c.reason = n.reason), Q(c);
  }

  function te(e, n, t, r) {
    var o;

    if (_ && x(_, e) && _[e] && !_[e].deleted) {
      var i = _[e];
      o = re(i), null !== i.value && void 0 !== i.value || (o.value = n);
    } else o = {
      value: n,
      variationIndex: null,
      reason: {
        kind: "ERROR",
        errorKind: "FLAG_NOT_FOUND"
      }
    };

    return t && Z(e, o, n, r), o;
  }

  function re(e) {
    return {
      value: e.value,
      variationIndex: void 0 === e.variation ? null : e.variation,
      reason: e.reason || null
    };
  }

  function ie(e) {
    return e.anonymous ? "anonymousUser" : "user";
  }

  function ue(e, n) {
    G || e && n && Q({
      kind: "alias",
      key: e.key,
      contextKind: ie(e),
      previousKey: n.key,
      previousContextKind: ie(n),
      creationDate: new Date().getTime()
    });
  }

  function se() {
    d = !0, X.getUser() && L.connect(X.getUser(), E, {
      ping: function ping() {
        m.debug("received ping message from stream");
        var e = X.getUser();
        q.fetchFlagSettings(e, E).then(function (n) {
          P(e, X.getUser()) && le(n || {});
        }).catch(function (e) {
          h.maybeReportError(new l(ne(e)));
        });
      },
      put: function put(e) {
        var n = JSON.parse(e.data);
        m.debug("received streaming update for all flags"), le(n);
      },
      patch: function patch(e) {
        var n = JSON.parse(e.data),
            t = _[n.key];

        if (!t || !t.version || !n.version || t.version < n.version) {
          m.debug(pe(n.key));
          var r = {},
              o = F({}, n);
          delete o.key, _[n.key] = o;
          var i = re(o);
          r[n.key] = t ? {
            previous: t.value,
            current: i
          } : {
            current: i
          }, fe(r);
        } else m.debug(me(n.key));
      },
      delete: function _delete(e) {
        var n = JSON.parse(e.data);

        if (!_[n.key] || _[n.key].version < n.version) {
          m.debug(he(n.key));
          var t = {};
          _[n.key] && !_[n.key].deleted && (t[n.key] = {
            previous: _[n.key].value
          }), _[n.key] = {
            version: n.version,
            deleted: !0
          }, fe(t);
        } else m.debug(ye(n.key));
      }
    });
  }

  function ce() {
    d && (L.disconnect(), d = !1);
  }

  function le(e) {
    var n = {};
    if (!e) return Promise.resolve();

    for (var t in _) {
      x(_, t) && _[t] && (e[t] && !P(e[t].value, _[t].value) ? n[t] = {
        previous: _[t].value,
        current: re(e[t])
      } : e[t] && !e[t].deleted || (n[t] = {
        previous: _[t].value
      }));
    }

    for (var o in e) {
      x(e, o) && e[o] && (!_[o] || _[o].deleted) && (n[o] = {
        current: re(e[o])
      });
    }

    return _ = r({}, e), fe(n).catch(function () {});
  }

  function fe(e) {
    var n = Object.keys(e);

    if (n.length > 0) {
      var t = {};
      n.forEach(function (n) {
        var r = e[n].current,
            o = r ? r.value : void 0,
            i = e[n].previous;
        h.emit("change:" + n, o, i), t[n] = r ? {
          current: o,
          previous: i
        } : {
          previous: i
        };
      }), h.emit("change", t), h.emit("internal-change", _), w.sendEventsOnlyForVariation || G || n.forEach(function (n) {
        Z(n, e[n].current);
      });
    }

    return v && p ? p.saveFlags(_).catch(function () {
      return null;
    }) : Promise.resolve();
  }

  function ve() {
    var e = J || g && void 0 === J;
    e && !d ? se() : !e && d && ce(), N && N.setStreaming(e);
  }

  function de(e) {
    return "change" === e || "change:" === e.substr(0, "change".length + 1);
  }

  if (u.localStorage && (p = new Ee(u.localStorage, k, E, X, m)), "string" == typeof w.bootstrap && "LOCALSTORAGE" === w.bootstrap.toUpperCase() && (p ? v = !0 : m.warn("localStorage is unavailable")), "object" === e(w.bootstrap) && (_ = function (e) {
    var n = Object.keys(e),
        t = e.$flagsState;
    !t && n.length && m.warn(oe()), !1 === e.$valid && m.warn("LaunchDarkly bootstrap data is not available because the back end could not read the flags.");
    var r = {};
    return n.forEach(function (n) {
      if ("$flagsState" !== n && "$valid" !== n) {
        var o = {
          value: e[n]
        };
        t && t[n] ? o = F(o, t[n]) : o.version = 0, r[n] = o;
      }
    }), r;
  }(w.bootstrap)), G) {
    var ge = G.getInitialState();
    ge ? Pe(ge) : G.on("init", Pe), G.on("update", function (e) {
      e.user && X.setUser(e.user), e.flags && le(e.flags);
    });
  } else (n ? W.validateUser(t).then(function (n) {
    return X.setUser(n), "object" === e(w.bootstrap) ? Te() : v ? p.loadFlags().catch(function () {
      return null;
    }).then(function (e) {
      return null == e ? (_ = {}, q.fetchFlagSettings(X.getUser(), E).then(function (e) {
        return le(e || {});
      }).then(Te).catch(function (e) {
        Ne(new l(ne(e)));
      })) : (_ = e, U(Te), q.fetchFlagSettings(X.getUser(), E).then(function (e) {
        return le(e);
      }).catch(function (e) {
        return h.maybeReportError(e);
      }));
    }) : q.fetchFlagSettings(X.getUser(), E).then(function (e) {
      _ = e || {}, Te();
    }).catch(function (e) {
      _ = {}, Ne(e);
    });
  }) : Promise.reject(new a(ee()))).catch(Ne);

  function Pe(e) {
    k = e.environment, X.setUser(e.user), _ = r({}, e.flags), U(Te);
  }

  function Te() {
    m.info("LaunchDarkly client initialized"), z = !0, ve(), y.signalSuccess();
  }

  function Ne(e) {
    y.signalFailure(e);
  }

  return {
    client: {
      waitForInitialization: function waitForInitialization() {
        return y.getInitializationPromise();
      },
      waitUntilReady: function waitUntilReady() {
        return y.getReadyPromise();
      },
      identify: function identify(e, n, t) {
        return M ? R(Promise.resolve({}), t) : G ? (m.warn("identify() has no effect here; it must be called on the main client instance"), R(Promise.resolve(I(_)), t)) : R((v && p ? p.clearFlags() : Promise.resolve()).then(function () {
          return W.validateUser(e);
        }).then(function (e) {
          return q.fetchFlagSettings(e, n).then(function (t) {
            var r = I(t);
            return X.setUser(e), E = n, t ? le(t).then(function () {
              return r;
            }) : r;
          });
        }).then(function (e) {
          return d && se(), e;
        }).catch(function (e) {
          return h.maybeReportError(e), Promise.reject(e);
        }), t);
      },
      getUser: function getUser() {
        return X.getUser();
      },
      variation: function variation(e, n) {
        return te(e, n, !0, !1).value;
      },
      variationDetail: function variationDetail(e, n) {
        return te(e, n, !0, !0);
      },
      track: function track(e, n, t) {
        if ("string" == typeof e) {
          u.customEventFilter && !u.customEventFilter(e) && m.warn(Y(e));
          var r = X.getUser(),
              o = {
            kind: "custom",
            key: e,
            user: r,
            url: u.getCurrentUrl(),
            creationDate: new Date().getTime()
          };
          r && r.anonymous && (o.contextKind = ie(r)), null != n && (o.data = n), null != t && (o.metricValue = t), Q(o);
        } else h.maybeReportError(new s(Y(e)));
      },
      alias: ue,
      on: function on(e, n, t) {
        de(e) ? (g = !0, z && ve(), h.on(e, n, t)) : h.on.apply(h, arguments);
      },
      off: function off(e) {
        if (h.off.apply(h, arguments), de(e)) {
          var n = !1;
          h.getEvents().forEach(function (e) {
            de(e) && h.getEventListenerCount(e) > 0 && (n = !0);
          }), n || (g = !1, d && void 0 === J && ce());
        }
      },
      setStreaming: function setStreaming(e) {
        var n = null === e ? void 0 : e;
        n !== J && (J = n, ve());
      },
      flush: function flush(e) {
        return R(b ? A.flush() : Promise.resolve(), e);
      },
      allFlags: function allFlags() {
        var e = {};
        if (!_) return e;

        for (var n in _) {
          x(_, n) && (e[n] = te(n, null, !w.sendEventsOnlyForVariation).value);
        }

        return e;
      },
      close: function close(e) {
        if (M) return R(Promise.resolve(), e);

        var n = function n() {
          M = !0, _ = {};
        };

        return R(Promise.resolve().then(function () {
          if (ce(), N && N.stop(), b) return A.stop(), A.flush();
        }).then(n).catch(n), e);
      }
    },
    options: w,
    emitter: h,
    ident: X,
    logger: m,
    requestor: q,
    start: function start() {
      b && (N && N.start(), A.start());
    },
    enqueueEvent: Q,
    getFlagsInternal: function getFlagsInternal() {
      return _;
    },
    getEnvironmentId: function getEnvironmentId() {
      return k;
    },
    internalChangeEventName: "internal-change"
  };
}

function Ne(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}

function Le(e, n) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }

  return t;
}

function Fe(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2 ? Le(Object(t), !0).forEach(function (n) {
      Ne(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Le(Object(t)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }

  return e;
}

var xe = {
  promise: Promise.resolve({
    status: 200,
    header: function header() {
      return null;
    },
    body: null
  })
};

function Ce(e, n, t, r, o) {
  if (o && !function () {
    var e = window.navigator && window.navigator.userAgent;

    if (e) {
      var n = e.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (n) return parseInt(n[2], 10) < 73;
    }

    return !0;
  }()) return xe;
  var i = new window.XMLHttpRequest();

  for (var a in i.open(e, n, !o), t || {}) {
    Object.prototype.hasOwnProperty.call(t, a) && i.setRequestHeader(a, t[a]);
  }

  if (o) return i.send(r), xe;
  var u;
  return {
    promise: new Promise(function (e, n) {
      i.addEventListener("load", function () {
        u || e({
          status: i.status,
          header: function header(e) {
            return i.getResponseHeader(e);
          },
          body: i.responseText
        });
      }), i.addEventListener("error", function () {
        u || n(new Error());
      }), i.send(r);
    }),
    cancel: function cancel() {
      u = !0, i.abort();
    }
  };
}

function Ae(e) {
  var n,
      t = {
    synchronousFlush: !1
  };

  if (window.XMLHttpRequest) {
    var r = e && e.disableSyncEventPost;

    t.httpRequest = function (e, n, o, i) {
      var a = t.synchronousFlush & !r;
      return t.synchronousFlush = !1, Ce(e, n, o, i, a);
    };
  }

  t.httpAllowsPost = function () {
    return void 0 === n && (n = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), n;
  }, t.httpFallbackPing = function (e) {
    new window.Image().src = e;
  };
  var o,
      i = e && e.eventUrlTransformer;
  t.getCurrentUrl = function () {
    return i ? i(window.location.href) : window.location.href;
  }, t.isDoNotTrack = function () {
    var e;
    return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
  };

  try {
    window.localStorage && (t.localStorage = {
      get: function get(e) {
        return new Promise(function (n) {
          n(window.localStorage.getItem(e));
        });
      },
      set: function set(e, n) {
        return new Promise(function (t) {
          window.localStorage.setItem(e, n), t();
        });
      },
      clear: function clear(e) {
        return new Promise(function (n) {
          window.localStorage.removeItem(e), n();
        });
      }
    });
  } catch (e) {
    t.localStorage = null;
  }

  if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (t.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (t.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
    var a = 3e5;
    t.eventSourceFactory = function (e, n) {
      var t = Fe(Fe({}, {
        heartbeatTimeout: a,
        silentTimeout: a,
        skipDefaultHeaders: !0
      }), n);
      return new o(e, t);
    }, t.eventSourceIsActive = function (e) {
      return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
    };
  }

  return t.userAgent = "JSClient", t.version = "2.19.1", t.diagnosticSdkData = {
    name: "js-client-sdk",
    version: "2.19.1"
  }, t.diagnosticPlatformData = {
    name: "JS"
  }, t.diagnosticUseCombinedEvent = !0, t;
}

var qe = /[|\\{}()[\]^$+*?.]/g,
    Ve = function Ve(e) {
  if ("string" != typeof e) throw new TypeError("Expected a string");
  return e.replace(qe, "\\$&");
};

function _e(e, n, t, r) {
  var o,
      i,
      a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? n : n.replace(r, "")).replace(t, "");

  switch (e.kind) {
    case "exact":
      i = n, o = new RegExp("^" + Ve(e.url) + "/?$");
      break;

    case "canonical":
      i = a, o = new RegExp("^" + Ve(e.url) + "/?$");
      break;

    case "substring":
      i = a, o = new RegExp(".*" + Ve(e.substring) + ".*$");
      break;

    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;

    default:
      return !1;
  }

  return o.test(i);
}

function Je(e, n) {
  for (var t = {}, r = null, o = [], i = 0; i < e.length; i++) {
    for (var a = e[i], u = a.urls || [], s = 0; s < u.length; s++) {
      if (_e(u[s], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a.kind ? n("pageview", a) : (o.push(a), n("click_pageview", a));
        break;
      }
    }
  }

  return o.length > 0 && (r = function r(e) {
    for (var t = function (e, n) {
      for (var t = [], r = 0; r < n.length; r++) {
        for (var o = e.target, i = n[r], a = i.selector, u = document.querySelectorAll(a); o && u.length > 0;) {
          for (var s = 0; s < u.length; s++) {
            o === u[s] && t.push(i);
          }

          o = o.parentNode;
        }
      }

      return t;
    }(e, o), r = 0; r < t.length; r++) {
      n("click", t[r]);
    }
  }, document.addEventListener("click", r)), t.dispose = function () {
    document.removeEventListener("click", r);
  }, t;
}

function ze(e, n) {
  var t,
      r,
      o = {};

  function i() {
    r && r.dispose(), t && t.length && (r = Je(t, a));
  }

  function a(n, t) {
    var r = e.ident.getUser(),
        o = {
      kind: n,
      key: t.key,
      data: null,
      url: window.location.href,
      user: r,
      creationDate: new Date().getTime()
    };
    return r && r.anonymous && (o.contextKind = "anonymousUser"), "click" === n && (o.selector = t.selector), e.enqueueEvent(o);
  }

  return o.goalKeyExists = function (e) {
    if (!t) return !0;

    for (var n = 0; n < t.length; n++) {
      if ("custom" === t[n].kind && t[n].key === e) return !0;
    }

    return !1;
  }, e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function (e) {
    e && e.length > 0 && (r = Je(t = e, a), function (e, n) {
      var t,
          r = window.location.href;

      function o() {
        (t = window.location.href) !== r && (r = t, n());
      }

      !function e(n, t) {
        n(), setTimeout(function () {
          e(n, t);
        }, t);
      }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(300, i)), n();
  }).catch(function (t) {
    e.emitter.maybeReportError(new v.LDUnexpectedResponseError((t && t.message, t.message))), n();
  }), o;
}

var Me = {
  fetchGoals: {
    default: !0
  },
  hash: {
    type: "string"
  },
  eventProcessor: {
    type: "object"
  },
  eventUrlTransformer: {
    type: "function"
  },
  disableSyncEventPost: {
    default: !1
  }
};

function Ke(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      r = Ae(t),
      o = Te(e, n, t, r, Me),
      i = o.client,
      a = o.options,
      u = o.emitter,
      s = new Promise(function (e) {
    var n = u.on("goalsReady", function () {
      u.off("goalsReady", n), e();
    });
  });

  if (i.waitUntilGoalsReady = function () {
    return s;
  }, a.fetchGoals) {
    var c = ze(o, function () {
      return u.emit("goalsReady");
    });
    r.customEventFilter = c.goalKeyExists;
  } else u.emit("goalsReady");

  "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();

  var l = function l() {
    r.synchronousFlush = !0, i.flush().catch(function () {}), r.synchronousFlush = !1;
  };

  return window.addEventListener("beforeunload", l), window.addEventListener("unload", l), i;
}

var $e = Ie,
    He = "2.19.1";
var Be = {
  initialize: function initialize(e, n) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return console && console.warn && console.warn(ke.deprecated("default export", "named LDClient export")), Ke(e, n, t);
  },
  version: "2.19.1"
};
var ldclient_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Be,
  createConsoleLogger: $e,
  initialize: Ke,
  version: He
});
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */

var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */

var rsAstralRange = "\\ud800-\\udfff",
    rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23",
    rsComboSymbolsRange = "\\u20d0-\\u20f0",
    rsDingbatRange = "\\u2700-\\u27bf",
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = "\\u2000-\\u206f",
    rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = "\\ufe0e\\ufe0f",
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */

var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = "\\ud83c[\\udffb-\\udfff]",
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */

var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
/** Used to match apostrophes. */

var reApos = RegExp(rsApos, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */

var reComboMark = RegExp(rsCombo, 'g');
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/** Used to match complex or compound words. */

var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')', rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr, rsUpper + '+' + rsOptUpperContr, rsDigits, rsEmoji].join('|'), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */

var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',
  '\xc1': 'A',
  '\xc2': 'A',
  '\xc3': 'A',
  '\xc4': 'A',
  '\xc5': 'A',
  '\xe0': 'a',
  '\xe1': 'a',
  '\xe2': 'a',
  '\xe3': 'a',
  '\xe4': 'a',
  '\xe5': 'a',
  '\xc7': 'C',
  '\xe7': 'c',
  '\xd0': 'D',
  '\xf0': 'd',
  '\xc8': 'E',
  '\xc9': 'E',
  '\xca': 'E',
  '\xcb': 'E',
  '\xe8': 'e',
  '\xe9': 'e',
  '\xea': 'e',
  '\xeb': 'e',
  '\xcc': 'I',
  '\xcd': 'I',
  '\xce': 'I',
  '\xcf': 'I',
  '\xec': 'i',
  '\xed': 'i',
  '\xee': 'i',
  '\xef': 'i',
  '\xd1': 'N',
  '\xf1': 'n',
  '\xd2': 'O',
  '\xd3': 'O',
  '\xd4': 'O',
  '\xd5': 'O',
  '\xd6': 'O',
  '\xd8': 'O',
  '\xf2': 'o',
  '\xf3': 'o',
  '\xf4': 'o',
  '\xf5': 'o',
  '\xf6': 'o',
  '\xf8': 'o',
  '\xd9': 'U',
  '\xda': 'U',
  '\xdb': 'U',
  '\xdc': 'U',
  '\xf9': 'u',
  '\xfa': 'u',
  '\xfb': 'u',
  '\xfc': 'u',
  '\xdd': 'Y',
  '\xfd': 'y',
  '\xff': 'y',
  '\xc6': 'Ae',
  '\xe6': 'ae',
  '\xde': 'Th',
  '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  "\u0100": 'A',
  "\u0102": 'A',
  "\u0104": 'A',
  "\u0101": 'a',
  "\u0103": 'a',
  "\u0105": 'a',
  "\u0106": 'C',
  "\u0108": 'C',
  "\u010A": 'C',
  "\u010C": 'C',
  "\u0107": 'c',
  "\u0109": 'c',
  "\u010B": 'c',
  "\u010D": 'c',
  "\u010E": 'D',
  "\u0110": 'D',
  "\u010F": 'd',
  "\u0111": 'd',
  "\u0112": 'E',
  "\u0114": 'E',
  "\u0116": 'E',
  "\u0118": 'E',
  "\u011A": 'E',
  "\u0113": 'e',
  "\u0115": 'e',
  "\u0117": 'e',
  "\u0119": 'e',
  "\u011B": 'e',
  "\u011C": 'G',
  "\u011E": 'G',
  "\u0120": 'G',
  "\u0122": 'G',
  "\u011D": 'g',
  "\u011F": 'g',
  "\u0121": 'g',
  "\u0123": 'g',
  "\u0124": 'H',
  "\u0126": 'H',
  "\u0125": 'h',
  "\u0127": 'h',
  "\u0128": 'I',
  "\u012A": 'I',
  "\u012C": 'I',
  "\u012E": 'I',
  "\u0130": 'I',
  "\u0129": 'i',
  "\u012B": 'i',
  "\u012D": 'i',
  "\u012F": 'i',
  "\u0131": 'i',
  "\u0134": 'J',
  "\u0135": 'j',
  "\u0136": 'K',
  "\u0137": 'k',
  "\u0138": 'k',
  "\u0139": 'L',
  "\u013B": 'L',
  "\u013D": 'L',
  "\u013F": 'L',
  "\u0141": 'L',
  "\u013A": 'l',
  "\u013C": 'l',
  "\u013E": 'l',
  "\u0140": 'l',
  "\u0142": 'l',
  "\u0143": 'N',
  "\u0145": 'N',
  "\u0147": 'N',
  "\u014A": 'N',
  "\u0144": 'n',
  "\u0146": 'n',
  "\u0148": 'n',
  "\u014B": 'n',
  "\u014C": 'O',
  "\u014E": 'O',
  "\u0150": 'O',
  "\u014D": 'o',
  "\u014F": 'o',
  "\u0151": 'o',
  "\u0154": 'R',
  "\u0156": 'R',
  "\u0158": 'R',
  "\u0155": 'r',
  "\u0157": 'r',
  "\u0159": 'r',
  "\u015A": 'S',
  "\u015C": 'S',
  "\u015E": 'S',
  "\u0160": 'S',
  "\u015B": 's',
  "\u015D": 's',
  "\u015F": 's',
  "\u0161": 's',
  "\u0162": 'T',
  "\u0164": 'T',
  "\u0166": 'T',
  "\u0163": 't',
  "\u0165": 't',
  "\u0167": 't',
  "\u0168": 'U',
  "\u016A": 'U',
  "\u016C": 'U',
  "\u016E": 'U',
  "\u0170": 'U',
  "\u0172": 'U',
  "\u0169": 'u',
  "\u016B": 'u',
  "\u016D": 'u',
  "\u016F": 'u',
  "\u0171": 'u',
  "\u0173": 'u',
  "\u0174": 'W',
  "\u0175": 'w',
  "\u0176": 'Y',
  "\u0177": 'y',
  "\u0178": 'Y',
  "\u0179": 'Z',
  "\u017B": 'Z',
  "\u017D": 'Z',
  "\u017A": 'z',
  "\u017C": 'z',
  "\u017E": 'z',
  "\u0132": 'IJ',
  "\u0133": 'ij',
  "\u0152": 'Oe',
  "\u0153": 'oe',
  "\u0149": "'n",
  "\u017F": 'ss'
};
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }

  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }

  return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function asciiToArray(string) {
  return string.split('');
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */


function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */


function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */


var deburrLetter = basePropertyOf(deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */

function hasUnicode(string) {
  return reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */


function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */


function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}
/** Used for built-in method references. */


var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Built-in value references. */

var Symbol$1 = root.Symbol;
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */


function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */


function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */


function createCaseFirst(methodName) {
  return function (string) {
    string = toString(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */


function createCompounder(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */


var camelCase = createCompounder(function (result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */

function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */


function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */


var upperFirst = createCaseFirst('toUpperCase');
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */

function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }

  return string.match(pattern) || [];
}

var lodash_camelcase = camelCase;
var utils = createCommonjsModule$1(function (module, exports) {
  var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var lodash_camelcase_1 = __importDefault(lodash_camelcase);
  /**
   * Transforms a set of flags so that their keys are camelCased. This function ignores
   * flag keys which start with `$`.
   *
   * @param rawFlags A mapping of flag keys and their values
   * @return A transformed `LDFlagSet` with camelCased flag keys
   */


  exports.camelCaseKeys = function (rawFlags) {
    var flags = {};

    for (var rawFlag in rawFlags) {
      // Exclude system keys
      if (rawFlag.indexOf('$') !== 0) {
        flags[lodash_camelcase_1.default(rawFlag)] = rawFlags[rawFlag]; // tslint:disable-line:no-unsafe-any
      }
    }

    return flags;
  };
  /**
   * Gets the flags to pass to the provider from the changeset.
   *
   * @param changes the `LDFlagChangeset` from the ldClient onchange handler.
   * @param targetFlags if targetFlags are specified, changes to other flags are ignored and not returned in the
   * flattened `LDFlagSet`
   * @param reactOptions reactOptions.useCamelCaseFlagKeys determines whether to change the flag keys to camelCase
   * @return an `LDFlagSet` with the current flag values from the LDFlagChangeset filtered by `targetFlags`. The returned
   * object may be empty `{}` if none of the targetFlags were changed.
   */


  exports.getFlattenedFlagsFromChangeset = function (changes, targetFlags, reactOptions) {
    var flattened = {};

    for (var key in changes) {
      if (!targetFlags || targetFlags[key] !== undefined) {
        // tslint:disable-next-line:no-unsafe-any
        var flagKey = reactOptions.useCamelCaseFlagKeys ? lodash_camelcase_1.default(key) : key;
        flattened[flagKey] = changes[key].current;
      }
    }

    return flattened;
  };
  /**
   * @deprecated The `camelCaseKeys.camelCaseKeys` property will be removed in a future version,
   * please update your code to use the `camelCaseKeys` function directly.
   */
  // tslint:disable-next-line deprecation


  exports.camelCaseKeys.camelCaseKeys = exports.camelCaseKeys;
  exports.default = {
    camelCaseKeys: exports.camelCaseKeys,
    getFlattenedFlagsFromChangeset: exports.getFlattenedFlagsFromChangeset
  };
});
var _args = [["launchdarkly-react-client-sdk@2.22.2", "/opt/github-actions-runner/_work/global-footer/global-footer"]];
var _from = "launchdarkly-react-client-sdk@2.22.2";
var _id = "launchdarkly-react-client-sdk@2.22.2";
var _inBundle = false;
var _integrity = "sha512-tnv4GCZdq+Os46HnzxVxA0el0rRBNZO4fJ3WdQazJbuQCO9qutcCs74uGSi9NcDy3OqRYMfGZUPVlUQUS/CiEQ==";
var _location = "/launchdarkly-react-client-sdk";
var _phantomChildren = {};
var _requested = {
  type: "version",
  registry: true,
  raw: "launchdarkly-react-client-sdk@2.22.2",
  name: "launchdarkly-react-client-sdk",
  escapedName: "launchdarkly-react-client-sdk",
  rawSpec: "2.22.2",
  saveSpec: null,
  fetchSpec: "2.22.2"
};
var _requiredBy = ["/"];
var _resolved = "https://registry.npmjs.org/launchdarkly-react-client-sdk/-/launchdarkly-react-client-sdk-2.22.2.tgz";
var _spec = "2.22.2";
var _where = "/opt/github-actions-runner/_work/global-footer/global-footer";
var author = {
  name: "LaunchDarkly",
  email: "team@launchdarkly.com"
};
var bugs = {
  url: "https://github.com/launchdarkly/react-client-sdk/issues"
};
var dependencies = {
  "launchdarkly-js-client-sdk": "2.19.1",
  "lodash.camelcase": "^4.3.0",
  uuid: "^3.3.2"
};
var description = "LaunchDarkly SDK for React";
var devDependencies = {
  "@testing-library/jest-dom": "^4.1.0",
  "@testing-library/react": "^11.2.6",
  "@types/enzyme": "^3.10.3",
  "@types/jest": "^25.2.3",
  "@types/lodash.camelcase": "^4.3.6",
  "@types/prop-types": "^15.7.2",
  "@types/react": "^17.0.3",
  "@types/react-dom": "^17.0.3",
  "@types/react-test-renderer": "^17.0.1",
  "@types/uuid": "^3.4.5",
  enzyme: "^3.10.0",
  "enzyme-adapter-react-16": "^1.14.0",
  jest: "^26.0.1",
  "jest-junit": "^6.3.0",
  prettier: "^1.18.2",
  "prop-types": "^15.7.2",
  react: "^17.0.0",
  "react-dom": "^17.0.0",
  "react-test-renderer": "^17.0.2",
  rimraf: "^3.0.0",
  "ts-jest": "^26.0.0",
  tslint: "^5.19.0",
  "tslint-config-prettier": "^1.18.0",
  "tslint-plugin-prettier": "^2.0.1",
  typescript: "~3.8.3"
};
var homepage = "https://github.com/launchdarkly/react-client-sdk";
var keywords = ["launchdarkly", "launch", "darkly", "react", "sdk", "bindings"];
var license = "Apache-2.0";
var main = "lib/index.js";
var name = "launchdarkly-react-client-sdk";
var peerDependencies = {
  react: "^16.6.3 || ^17.0.0",
  "react-dom": "^16.8.4 || ^17.0.0"
};
var repository = {
  type: "git",
  url: "git://github.com/launchdarkly/react-client-sdk.git"
};
var scripts = {
  build: "rimraf lib/* && tsc && mv lib/src/* lib && rimraf lib/package.json lib/src lib/*.test.*",
  "check-typescript": "tsc",
  "link-dev": "./link-dev.sh",
  lint: "tslint -p tsconfig.json 'src/**/*.ts*'",
  "lint:all": "npm run lint",
  prepublishOnly: "npm run build",
  prettier: "prettier --write 'src/*.@(js|ts|tsx|json|css)'",
  test: "jest",
  "test:junit": "jest --ci --reporters=default --reporters=jest-junit"
};
var types = "lib/index.d.ts";
var version = "2.22.2";
var package_json_1 = {
  _args: _args,
  _from: _from,
  _id: _id,
  _inBundle: _inBundle,
  _integrity: _integrity,
  _location: _location,
  _phantomChildren: _phantomChildren,
  _requested: _requested,
  _requiredBy: _requiredBy,
  _resolved: _resolved,
  _spec: _spec,
  _where: _where,
  author: author,
  bugs: bugs,
  dependencies: dependencies,
  description: description,
  devDependencies: devDependencies,
  homepage: homepage,
  keywords: keywords,
  license: license,
  main: main,
  name: name,
  peerDependencies: peerDependencies,
  repository: repository,
  scripts: scripts,
  types: types,
  version: version
};
var launchdarkly_js_client_sdk_1 = /*@__PURE__*/getAugmentedNamespace(ldclient_es);
var initLDClient_1 = createCommonjsModule$1(function (module, exports) {
  var __assign = commonjsGlobal$1 && commonjsGlobal$1.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  var __awaiter = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }

    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };

  var __generator = commonjsGlobal$1 && commonjsGlobal$1.__generator || function (thisArg, body) {
    var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
        f,
        y,
        t,
        g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;

    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }

    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");

      while (_) {
        try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];

          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;

            case 4:
              _.label++;
              return {
                value: op[1],
                done: false
              };

            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;

            case 7:
              op = _.ops.pop();

              _.trys.pop();

              continue;

            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }

              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }

              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }

              if (t && _.label < t[2]) {
                _.label = t[2];

                _.ops.push(op);

                break;
              }

              if (t[2]) _.ops.pop();

              _.trys.pop();

              continue;
          }

          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      }

      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Internal function to initialize the `LDClient`.
   *
   * @param clientSideID Your project and environment specific client side ID
   * @param user A LaunchDarkly user object
   * @param options LaunchDarkly initialization options
   * @param targetFlags If specified, `launchdarkly-react-client-sdk` will only request and listen to these flags.
   *
   * @see `ProviderConfig` for more details about the parameters
   * @return An initialized client and flags
   */

  var initLDClient = function initLDClient(clientSideID, user, reactOptions, options, targetFlags) {
    if (user === void 0) {
      user = {
        anonymous: true
      };
    }

    if (reactOptions === void 0) {
      reactOptions = types$1.defaultReactOptions;
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var allOptions, ldClient;
      return __generator(this, function (_a) {
        allOptions = __assign({
          wrapperName: 'react-client-sdk',
          wrapperVersion: package_json_1.version
        }, options);
        ldClient = launchdarkly_js_client_sdk_1.initialize(clientSideID, user, allOptions);
        return [2
        /*return*/
        , new Promise(function (resolve) {
          ldClient.on('ready', function () {
            var rawFlags = {};

            if (targetFlags) {
              for (var flag in targetFlags) {
                rawFlags[flag] = ldClient.variation(flag, targetFlags[flag]);
              }
            } else {
              rawFlags = ldClient.allFlags();
            }

            var flags = reactOptions.useCamelCaseFlagKeys ? utils.camelCaseKeys(rawFlags) : rawFlags;
            resolve({
              flags: flags,
              ldClient: ldClient
            });
          });
        })];
      });
    });
  };

  exports.default = initLDClient;
});
var provider = createCommonjsModule$1(function (module, exports) {
  var __extends = commonjsGlobal$1 && commonjsGlobal$1.__extends || function () {
    var _extendStatics = function extendStatics(d, b) {
      _extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics(d, b);
    };

    return function (d, b) {
      _extendStatics(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  var __assign = commonjsGlobal$1 && commonjsGlobal$1.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  var __awaiter = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }

    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };

  var __generator = commonjsGlobal$1 && commonjsGlobal$1.__generator || function (thisArg, body) {
    var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
        f,
        y,
        t,
        g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;

    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }

    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");

      while (_) {
        try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];

          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;

            case 4:
              _.label++;
              return {
                value: op[1],
                done: false
              };

            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;

            case 7:
              op = _.ops.pop();

              _.trys.pop();

              continue;

            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }

              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }

              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }

              if (t && _.label < t[2]) {
                _.label = t[2];

                _.ops.push(op);

                break;
              }

              if (t[2]) _.ops.pop();

              _.trys.pop();

              continue;
          }

          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      }

      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  };

  var __importStar = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
      if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
  };

  var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React$1 = __importStar(React);

  var initLDClient_1$1 = __importDefault(initLDClient_1);
  /**
   * The `LDProvider` is a component which accepts a config object which is used to
   * initialize `launchdarkly-js-client-sdk`.
   *
   * This Provider does three things:
   * - It initializes the ldClient instance by calling `launchdarkly-js-client-sdk` initialize on `componentDidMount`
   * - It saves all flags and the ldClient instance in the context API
   * - It subscribes to flag changes and propagate them through the context API
   *
   * Because the `launchdarkly-js-client-sdk` in only initialized on `componentDidMount`, your flags and the
   * ldClient are only available after your app has mounted. This can result in a flicker due to flag changes at
   * startup time.
   *
   * This component can be used as a standalone provider. However, be mindful to only include the component once
   * within your application. This provider is used inside the `withLDProviderHOC` and can be used instead to initialize
   * the `launchdarkly-js-client-sdk`. For async initialization, check out the `asyncWithLDProvider` function
   */


  var LDProvider =
  /** @class */
  function (_super) {
    __extends(LDProvider, _super);

    function LDProvider(props) {
      var _this = _super.call(this, props) || this;

      _this.getReactOptions = function () {
        return __assign(__assign({}, types$1.defaultReactOptions), _this.props.reactOptions);
      };

      _this.subscribeToChanges = function (ldClient) {
        var targetFlags = _this.props.flags;
        ldClient.on('change', function (changes) {
          var flattened = utils.getFlattenedFlagsFromChangeset(changes, targetFlags, _this.getReactOptions());

          if (Object.keys(flattened).length > 0) {
            _this.setState(function (_a) {
              var flags = _a.flags;
              return {
                flags: __assign(__assign({}, flags), flattened)
              };
            });
          }
        });
      };

      _this.initLDClient = function () {
        return __awaiter(_this, void 0, void 0, function () {
          var _a, clientSideID, flags, options, user, reactOptions, _b, fetchedFlags, ldClient;

          return __generator(this, function (_c) {
            switch (_c.label) {
              case 0:
                _a = this.props, clientSideID = _a.clientSideID, flags = _a.flags, options = _a.options, user = _a.user;
                reactOptions = this.getReactOptions();
                return [4
                /*yield*/
                , initLDClient_1$1.default(clientSideID, user, reactOptions, options, flags)];

              case 1:
                _b = _c.sent(), fetchedFlags = _b.flags, ldClient = _b.ldClient;
                this.setState({
                  flags: fetchedFlags,
                  ldClient: ldClient
                });
                this.subscribeToChanges(ldClient);
                return [2
                /*return*/
                ];
            }
          });
        });
      };

      var options = props.options;
      _this.state = {
        flags: {},
        ldClient: undefined
      };

      if (options) {
        var bootstrap = options.bootstrap;

        if (bootstrap && bootstrap !== 'localStorage') {
          var useCamelCaseFlagKeys = _this.getReactOptions().useCamelCaseFlagKeys;

          var flags = useCamelCaseFlagKeys ? utils.camelCaseKeys(bootstrap) : bootstrap;
          _this.state = {
            flags: flags,
            ldClient: undefined
          };
        }
      }

      return _this;
    }

    LDProvider.prototype.componentDidMount = function () {
      return __awaiter(this, void 0, void 0, function () {
        var _a, user, deferInitialization;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, user = _a.user, deferInitialization = _a.deferInitialization;

              if (deferInitialization && !user) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , this.initLDClient()];

            case 1:
              _b.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    LDProvider.prototype.componentDidUpdate = function (prevProps) {
      return __awaiter(this, void 0, void 0, function () {
        var _a, user, deferInitialization, userJustLoaded;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, user = _a.user, deferInitialization = _a.deferInitialization;
              userJustLoaded = !prevProps.user && user;
              if (!(deferInitialization && userJustLoaded)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , this.initLDClient()];

            case 1:
              _b.sent();

              _b.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    LDProvider.prototype.render = function () {
      return React$1.createElement(context_1.Provider, {
        value: this.state
      }, this.props.children);
    };

    return LDProvider;
  }(React$1.Component);

  exports.default = LDProvider;
});
var withLDProvider_1 = createCommonjsModule$1(function (module, exports) {
  var __extends = commonjsGlobal$1 && commonjsGlobal$1.__extends || function () {
    var _extendStatics2 = function extendStatics(d, b) {
      _extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics2(d, b);
    };

    return function (d, b) {
      _extendStatics2(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  var __assign = commonjsGlobal$1 && commonjsGlobal$1.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  var __importStar = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
      if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
  };

  var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React$1 = __importStar(React);

  var provider_1 = __importDefault(provider);
  /**
   * `withLDProvider` is a function which accepts a config object which is used to
   * initialize `launchdarkly-js-client-sdk`.
   *
   * This HOC handles passing configuration to the `LDProvider`, which does the following:
   * - It initializes the ldClient instance by calling `launchdarkly-js-client-sdk` initialize on `componentDidMount`
   * - It saves all flags and the ldClient instance in the context API
   * - It subscribes to flag changes and propagate them through the context API
   *
   * The difference between `withLDProvider` and `asyncWithLDProvider` is that `withLDProvider` initializes
   * `launchdarkly-js-client-sdk` at `componentDidMount`. This means your flags and the ldClient are only available after
   * your app has mounted. This can result in a flicker due to flag changes at startup time.
   *
   * `asyncWithLDProvider` initializes `launchdarkly-js-client-sdk` at the entry point of your app prior to render.
   * This means that your flags and the ldClient are ready at the beginning of your app. This ensures your app does not
   * flicker due to flag changes at startup time.
   *
   * @param config - The configuration used to initialize LaunchDarkly's JS SDK
   * @return A function which accepts your root React component and returns a HOC
   */


  function withLDProvider(config) {
    return function withLDProviderHoc(WrappedComponent) {
      var userReactOptions = config.reactOptions;

      var reactOptions = __assign(__assign({}, types$1.defaultReactOptions), userReactOptions);

      var providerProps = __assign(__assign({}, config), {
        reactOptions: reactOptions
      });

      return (
        /** @class */
        function (_super) {
          __extends(class_1, _super);

          function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
          }

          class_1.prototype.render = function () {
            return React$1.createElement(provider_1.default, __assign({}, providerProps), React$1.createElement(WrappedComponent, __assign({}, this.props)));
          };

          return class_1;
        }(React$1.Component)
      );
    };
  }

  exports.withLDProvider = withLDProvider;
  exports.default = withLDProvider;
});
var asyncWithLDProvider_1 = createCommonjsModule$1(function (module, exports) {
  var __assign = commonjsGlobal$1 && commonjsGlobal$1.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  var __awaiter = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }

    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };

  var __generator = commonjsGlobal$1 && commonjsGlobal$1.__generator || function (thisArg, body) {
    var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
        f,
        y,
        t,
        g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;

    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }

    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");

      while (_) {
        try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];

          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;

            case 4:
              _.label++;
              return {
                value: op[1],
                done: false
              };

            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;

            case 7:
              op = _.ops.pop();

              _.trys.pop();

              continue;

            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }

              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }

              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }

              if (t && _.label < t[2]) {
                _.label = t[2];

                _.ops.push(op);

                break;
              }

              if (t[2]) _.ops.pop();

              _.trys.pop();

              continue;
          }

          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      }

      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  };

  var __importStar = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
      if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
  };

  var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var react_1 = __importStar(React);

  var initLDClient_1$1 = __importDefault(initLDClient_1);
  /**
   * This is an async function which initializes LaunchDarkly's JS SDK (`launchdarkly-js-client-sdk`)
   * and awaits it so all flags and the ldClient are ready before the consumer app is rendered.
   *
   * The difference between `withLDProvider` and `asyncWithLDProvider` is that `withLDProvider` initializes
   * `launchdarkly-js-client-sdk` at componentDidMount. This means your flags and the ldClient are only available after
   * your app has mounted. This can result in a flicker due to flag changes at startup time.
   *
   * `asyncWithLDProvider` initializes `launchdarkly-js-client-sdk` at the entry point of your app prior to render.
   * This means that your flags and the ldClient are ready at the beginning of your app. This ensures your app does not
   * flicker due to flag changes at startup time.
   *
   * `asyncWithLDProvider` accepts a config object which is used to initialize `launchdarkly-js-client-sdk`.
   * It returns a provider which is a React FunctionComponent which:
   * - saves all flags and the ldClient instance in the context API
   * - subscribes to flag changes and propagate them through the context API
   *
   * @param config - The configuration used to initialize LaunchDarkly's JS SDK
   */


  function asyncWithLDProvider(config) {
    return __awaiter(this, void 0, void 0, function () {
      var clientSideID, user, flags, options, userReactOptions, reactOptions, _a, fetchedFlags, ldClient, LDProvider;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            clientSideID = config.clientSideID, user = config.user, flags = config.flags, options = config.options, userReactOptions = config.reactOptions;
            reactOptions = __assign(__assign({}, types$1.defaultReactOptions), userReactOptions);
            return [4
            /*yield*/
            , initLDClient_1$1.default(clientSideID, user, reactOptions, options, flags)];

          case 1:
            _a = _b.sent(), fetchedFlags = _a.flags, ldClient = _a.ldClient;

            LDProvider = function LDProvider(_a) {
              var children = _a.children;

              var _b = react_1.useState({
                flags: fetchedFlags,
                ldClient: ldClient
              }),
                  ldData = _b[0],
                  setLDData = _b[1];

              react_1.useEffect(function () {
                if (options) {
                  var bootstrap = options.bootstrap;

                  if (bootstrap && bootstrap !== 'localStorage') {
                    var bootstrappedFlags_1 = reactOptions.useCamelCaseFlagKeys ? utils.camelCaseKeys(bootstrap) : bootstrap;
                    setLDData(function (prev) {
                      return __assign(__assign({}, prev), {
                        flags: bootstrappedFlags_1
                      });
                    });
                  }
                }

                ldClient.on('change', function (changes) {
                  var flattened = utils.getFlattenedFlagsFromChangeset(changes, flags, reactOptions);

                  if (Object.keys(flattened).length > 0) {
                    setLDData(function (prev) {
                      return __assign(__assign({}, prev), {
                        flags: __assign(__assign({}, prev.flags), flattened)
                      });
                    });
                  }
                });
              }, []);
              return react_1.default.createElement(context_1.Provider, {
                value: ldData
              }, children);
            };

            return [2
            /*return*/
            , LDProvider];
        }
      });
    });
  }

  exports.default = asyncWithLDProvider;
});
var withLDConsumer_1 = createCommonjsModule$1(function (module, exports) {
  var __assign = commonjsGlobal$1 && commonjsGlobal$1.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  var __importStar = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
      if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React$1 = __importStar(React);
  /**
   * withLDConsumer is a function which accepts an optional options object and returns a function
   * which accepts your React component. This function returns a HOC with flags
   * and the ldClient instance injected via props.
   *
   * @param options - If you need only the `ldClient` instance and not flags, then set `{ clientOnly: true }`
   * to only pass the ldClient prop to your component. Defaults to `{ clientOnly: false }`.
   * @return A HOC with flags and the `ldClient` instance injected via props
   */


  function withLDConsumer(options) {
    if (options === void 0) {
      options = {
        clientOnly: false
      };
    }

    return function withLDConsumerHoc(WrappedComponent) {
      return function (props) {
        return React$1.createElement(context_1.Consumer, null, function (_a) {
          var flags = _a.flags,
              ldClient = _a.ldClient;

          if (options.clientOnly) {
            return React$1.createElement(WrappedComponent, __assign({
              ldClient: ldClient
            }, props));
          }

          return React$1.createElement(WrappedComponent, __assign({
            flags: flags,
            ldClient: ldClient
          }, props));
        });
      };
    };
  }

  exports.default = withLDConsumer;
});
var useFlags_1 = createCommonjsModule$1(function (module, exports) {
  var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var context_1$1 = __importDefault(context_1);
  /**
   * `useFlags` is a custom hook which returns all feature flags. It uses the `useContext` primitive
   * to access the LaunchDarkly context set up by `withLDProvider`. As such you will still need to
   * use the `withLDProvider` HOC at the root of your app to initialize the React SDK and populate the
   * context with `ldClient` and your flags.
   *
   * @return All the feature flags configured in your LaunchDarkly project
   */


  var useFlags = function useFlags() {
    var flags = React.useContext(context_1$1.default).flags;
    return flags;
  };

  exports.default = useFlags;
});
var useLDClient_1 = createCommonjsModule$1(function (module, exports) {
  var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var context_1$1 = __importDefault(context_1); // tslint:disable:max-line-length

  /**
   * `useLDClient` is a custom hook which returns the underlying [LaunchDarkly JavaScript SDK client object](https://launchdarkly.github.io/js-client-sdk/interfaces/_launchdarkly_js_client_sdk_.ldclient.html).
   * Like the `useFlags` custom hook, `useLDClient` also uses the `useContext` primitive to access the LaunchDarkly
   * context set up by `withLDProvider`. You will still need to use the `withLDProvider` HOC
   * to initialise the react sdk to use this custom hook.
   *
   * @return The `launchdarkly-js-client-sdk` `LDClient` object
   */
  // tslint:enable:max-line-length


  var useLDClient = function useLDClient() {
    var ldClient = React.useContext(context_1$1.default).ldClient;
    return ldClient;
  };

  exports.default = useLDClient;
});
var lib = createCommonjsModule$1(function (module, exports) {
  var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var provider_1 = __importDefault(provider);

  exports.LDProvider = provider_1.default;

  var withLDProvider_1$1 = __importDefault(withLDProvider_1);

  exports.withLDProvider = withLDProvider_1$1.default;

  var asyncWithLDProvider_1$1 = __importDefault(asyncWithLDProvider_1);

  exports.asyncWithLDProvider = asyncWithLDProvider_1$1.default;

  var withLDConsumer_1$1 = __importDefault(withLDConsumer_1);

  exports.withLDConsumer = withLDConsumer_1$1.default;

  var useFlags_1$1 = __importDefault(useFlags_1);

  exports.useFlags = useFlags_1$1.default;

  var useLDClient_1$1 = __importDefault(useLDClient_1);

  exports.useLDClient = useLDClient_1$1.default;
  exports.camelCaseKeys = utils.camelCaseKeys;
});
var classnames = createCommonjsModule$1(function (module) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign$2 = function __assign$1() {
  _assign$2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$2.apply(this, arguments);
};

function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator$1(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var defaultUserInfo = {
  avatar: '',
  lives: [],
  loggedIn: false,
  seasonCode: '',
  user: {
    userId: 0,
    firstName: '',
    lastName: '',
    role: '',
    shippingCountry: '',
    shippingState: '',
    shippingZipCode: '',
    shippingCity: '',
    subscriptionEndDate: 0,
    subscriptionStartDate: 0,
    subscriptionState: '',
    subscriptionType: '',
    email: '',
    planCode: ''
  }
};
var defaultContext = {
  userInfo: defaultUserInfo,
  clearStorage: function clearStorage() {},
  invalidateUserCache: function invalidateUserCache() {}
};

function request(_a) {
  var path = _a.path,
      _b = _a.method,
      method = _b === void 0 ? 'GET' : _b,
      body = _a.body,
      _c = _a.json,
      json = _c === void 0 ? true : _c,
      _d = _a.contentType,
      contentType = _d === void 0 ? 'application/json; charset=utf-8' : _d;
  return __awaiter(this, void 0, void 0, function () {
    var defaultHeaders, response, status;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          defaultHeaders = {
            'FFF-Auth': 'V1.1',
            'Content-Type': contentType
          };
          return [4, fetch(path, {
            credentials: 'include',
            headers: _assign({}, defaultHeaders),
            body: method !== 'GET' ? body : null,
            mode: 'cors',
            method: method
          })];

        case 1:
          response = _e.sent();
          status = response.status;

          switch (status) {
            case 200:
              return [2, json ? response.json() : response.text()];

            case 400:
              return [2, Promise.reject(new Error('Bad request'))];

            case 401:
              return [2, Promise.reject(new Error('Unauthorized'))];

            case 403:
              return [2, Promise.reject(new Error('Forbidden'))];

            case 408:
              return [2, Promise.reject(new Error('Timeout'))];

            case 500:
              return [2, Promise.reject(new Error('API internal error'))];

            case 502:
              return [2, Promise.reject(new Error('Proxy error'))];

            case 503:
              return [2, Promise.reject(new Error('Service unavailable'))];

            case 504:
              return [2, Promise.reject(new Error('Timeout'))];

            default:
              return [2, Promise.reject(new Error("Unhandled HTTP code: ".concat(status)))];
          }

      }
    });
  });
}

function isBrowser$1() {
  return ![typeof window, typeof document].includes('undefined');
}

var getFromStorage = function getFromStorage(_a) {
  var key = _a.key,
      _b = _a.defaultItem,
      defaultItem = _b === void 0 ? null : _b;
  if (!isBrowser$1()) return defaultItem;
  var stgItem = sessionStorage.getItem("FFF_".concat(key));
  if (!stgItem) return defaultItem;

  try {
    var _c = JSON.parse(stgItem),
        createAt = _c.createAt,
        durationInMs = _c.durationInMs,
        data = _c.data;

    var currentTime = Date.now();
    var isExpired = durationInMs !== 0 && createAt + durationInMs < currentTime;

    if (!durationInMs || createAt && durationInMs && data && !isExpired) {
      return data;
    }

    removeFromStorage({
      key: key
    });
  } catch (error) {
    console.error('Error when deserializing JSON navigation');
  }

  return defaultItem;
};

var setToStorage = function setToStorage(_a) {
  var key = _a.key,
      value = _a.value,
      _b = _a.durationInMs,
      durationInMs = _b === void 0 ? 0 : _b;
  var itemWithExpirationTime = {
    createAt: Date.now(),
    durationInMs: durationInMs,
    data: value
  };
  var json = JSON.stringify(itemWithExpirationTime);

  if (isBrowser$1()) {
    sessionStorage.setItem("FFF_".concat(key), json);
  }
};

var removeFromStorage = function removeFromStorage(_a) {
  var key = _a.key;

  if (isBrowser$1()) {
    sessionStorage.removeItem("FFF_".concat(key));
  }
};

var hostname$1 = function hostname$1() {
  return isBrowser$1() ? window.location.hostname : 'fabfitfun.com';
};

var EnvironmentNames;

(function (EnvironmentNames) {
  EnvironmentNames["PROD"] = "prod";
  EnvironmentNames["QA"] = "qa";
  EnvironmentNames["DEV"] = "dev";
  EnvironmentNames["LOCAL"] = "local";
})(EnvironmentNames || (EnvironmentNames = {}));

var EnvironmentNames$1 = EnvironmentNames;

var getEnvUsingWindowLocation = function getEnvUsingWindowLocation() {
  if (hostname$1().includes('fabfitfun')) return EnvironmentNames$1.PROD;
  if (hostname$1().includes('fff-qa')) return EnvironmentNames$1.QA;
  return EnvironmentNames$1.DEV;
};

var getEnv$1 = function getEnv$1(getEnvProps) {
  var enF = (getEnvProps === null || getEnvProps === void 0 ? void 0 : getEnvProps.env) || getEnvUsingWindowLocation();

  if (enF === EnvironmentNames$1.LOCAL) {
    return _assign(_assign({}, getEnv$1({
      env: EnvironmentNames$1.DEV
    })), {
      name: EnvironmentNames$1.LOCAL
    });
  }

  if (enF === EnvironmentNames$1.PROD) {
    return {
      name: EnvironmentNames$1.PROD,
      REACT_APP_NAVIGATOR_URL: 'https://universal-navigation-api.fabfitfun.com',
      REACT_APP_USER_INFO_URL: 'https://universal-navigation-api.fabfitfun.com/menu/user-data',
      REACT_APP_BASE_URL: 'https://fabfitfun.com',
      REACT_APP_TIMER_URL: 'https://universal-navigation-api.fabfitfun.com/timer',
      REACT_APP_NEW_MEMBER_CAMPAIGN_URL: 'https://customize-api.fabfitfun.com/customize/new-members/self/campaign-state',
      REACT_APP_NEW_MEMBER_API_URL: 'https://new-member-api.fabfitfun.com',
      REACT_APP_BANNER_URL: 'https://homepage-api.fabfitfun.com/megaphone-banners/current',
      REACT_APP_ADDONS_URL: 'https://fabfitfun.com/add-ons',
      REACT_APP_EDIT_URL: 'https://fabfitfun.com/edit'
    };
  }

  return {
    name: enF,
    REACT_APP_NAVIGATOR_URL: "https://universal-navigation-api.fff-".concat(enF, ".com"),
    REACT_APP_USER_INFO_URL: "https://universal-navigation-api.fff-".concat(enF, ".com/menu/user-data"),
    REACT_APP_BASE_URL: "https://fff-".concat(enF, ".com"),
    REACT_APP_TIMER_URL: "https://universal-navigation-api.fff-".concat(enF, ".com/timer"),
    REACT_APP_NEW_MEMBER_CAMPAIGN_URL: "https://customize-api.fff-".concat(enF, ".com/customize/new-members/self/campaign-state"),
    REACT_APP_NEW_MEMBER_API_URL: "https://new-member-api.fff-".concat(enF, ".com"),
    REACT_APP_BANNER_URL: "https://homepage-api.fff-".concat(enF, ".com/megaphone-banners/current"),
    REACT_APP_ADDONS_URL: "https://fff-".concat(enF, ".com/add-ons"),
    REACT_APP_EDIT_URL: "https://fff-".concat(enF, ".com/edit")
  };
};

var userInfoKey = 'user-info-app';
var durationUserInfo = 5 * 60 * 1000;

var fetchUserInfo = function fetchUserInfo(_a) {
  var env = _a.env;
  return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4, request({
            path: env.REACT_APP_USER_INFO_URL
          })];

        case 1:
          response = _b.sent();
          return [2, response];
      }
    });
  });
};

var getUserInfo = function getUserInfo(forceRefresh) {
  if (forceRefresh === void 0) {
    forceRefresh = false;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var userFromSTG, requestUserInfo, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          userFromSTG = getFromStorage({
            key: userInfoKey
          });

          if (!forceRefresh && userFromSTG) {
            return [2, userFromSTG];
          }

          removeFromStorage({
            key: userInfoKey
          });
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4, fetchUserInfo({
            env: getEnv$1()
          })];

        case 2:
          requestUserInfo = _a.sent();

          if (requestUserInfo) {
            setToStorage({
              key: userInfoKey,
              value: requestUserInfo,
              durationInMs: durationUserInfo
            });
            return [2, requestUserInfo];
          }

          return [3, 4];

        case 3:
          err_1 = _a.sent();

          if (err_1.message === 'Unauthorized' || err_1.message === 'Forbidden') {
            removeFromStorage({
              key: userInfoKey
            });
          } else {
            console.log(err_1, err_1.message);
          }

          return [3, 4];

        case 4:
          return [2, defaultUserInfo];
      }
    });
  });
};

React.createContext(defaultContext);

var getParamFromUrl = function getParamFromUrl(param) {
  if (!isBrowser$1()) return '';
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var paramValue = urlParams.get(param);
  return paramValue || '';
};

var isBrowser$2 = function isBrowser$2() {
  return ![typeof window, typeof document].includes('undefined');
};

var loadSegment = function loadSegment(_a) {
  var token = _a.token;

  if (!isBrowser$2()) {
    return false;
  } // eslint-disable-next-line no-multi-assign


  var analytics = window.analytics = window.analytics || [];

  if (!analytics.initialize && !analytics.invoked) {
    analytics.invoked = !0;
    analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware']; // eslint-disable-next-line func-names

    analytics.factory = function (e) {
      // eslint-disable-next-line func-names
      return function () {
        // eslint-disable-next-line prefer-rest-params
        var t = Array.prototype.slice.call(arguments);
        t.unshift(e);
        analytics.push(t);
        return analytics;
      };
    };

    for (var e = 0; e < analytics.methods.length; e++) {
      var key = analytics.methods[e];
      analytics[key] = analytics.factory(key);
    } // eslint-disable-next-line func-names


    analytics.load = function (_a) {
      var _b;

      var key = _a.key,
          e = _a.e;

      if (!isBrowser$2()) {
        return true;
      }

      var t = document.createElement('script');
      t.type = 'text/javascript';
      t.async = !0;
      t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
      var n = document.getElementsByTagName('script')[0];
      (_b = n === null || n === void 0 ? void 0 : n.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(t, n); // eslint-disable-next-line no-underscore-dangle

      analytics._loadOptions = e;
      return true;
    };

    analytics.SNIPPET_VERSION = '4.13.1';
    analytics.load({
      key: token
    });
    return true;
  }

  return false;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */


var js_cookie = createCommonjsModule(function (module, exports) {
  (function (factory) {
    var registeredInModuleLoader;
    {
      module.exports = factory();
      registeredInModuleLoader = true;
    }

    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();

      api.noConflict = function () {
        window.Cookies = OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};

      for (; i < arguments.length; i++) {
        var attributes = arguments[i];

        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }

      return result;
    }

    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }

    function init(converter) {
      function api() {}

      function set(key, value, attributes) {
        if (typeof document === 'undefined') {
          return;
        }

        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
        } // We're using "expires" because "max-age" is not supported by IE


        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          var result = JSON.stringify(value);

          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }

          stringifiedAttributes += '; ' + attributeName;

          if (attributes[attributeName] === true) {
            continue;
          } // Considers RFC 6265 section 5.2:
          // ...
          // 3.  If the remaining unparsed-attributes contains a %x3B (";")
          //     character:
          // Consume the characters of the unparsed-attributes up to,
          // not including, the first %x3B (";") character.
          // ...


          stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }

        return document.cookie = key + '=' + value + stringifiedAttributes;
      }

      function get(key, json) {
        if (typeof document === 'undefined') {
          return;
        }

        var jar = {}; // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.

        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var i = 0;

        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var cookie = parts.slice(1).join('=');

          if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }

          try {
            var name = decode(parts[0]);
            cookie = (converter.read || converter)(cookie, name) || decode(cookie);

            if (json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }

            jar[name] = cookie;

            if (key === name) {
              break;
            }
          } catch (e) {}
        }

        return key ? jar[key] : jar;
      }

      api.set = set;

      api.get = function (key) {
        return get(key, false
        /* read as raw */
        );
      };

      api.getJSON = function (key) {
        return get(key, true
        /* read as json */
        );
      };

      api.remove = function (key, attributes) {
        set(key, '', extend(attributes, {
          expires: -1
        }));
      };

      api.defaults = {};
      api.withConverter = init;
      return api;
    }

    return init(function () {});
  });
});
/*!@license
 * UAParser.js v0.7.28
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

var uaParser = createCommonjsModule(function (module, exports) {
  (function (window, undefined$1) {
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '0.7.28',
        EMPTY = '',
        UNKNOWN = '?',
        FUNC_TYPE = 'function',
        UNDEF_TYPE = 'undefined',
        OBJ_TYPE = 'object',
        STR_TYPE = 'string',
        MAJOR = 'major',
        // deprecated
    MODEL = 'model',
        NAME = 'name',
        TYPE = 'type',
        VENDOR = 'vendor',
        VERSION = 'version',
        ARCHITECTURE = 'architecture',
        CONSOLE = 'console',
        MOBILE = 'mobile',
        TABLET = 'tablet',
        SMARTTV = 'smarttv',
        WEARABLE = 'wearable',
        EMBEDDED = 'embedded',
        UA_MAX_LENGTH = 255; ///////////
    // Helper
    //////////

    var util = {
      extend: function extend(regexes, extensions) {
        var mergedRegexes = {};

        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }

        return mergedRegexes;
      },
      has: function has(str1, str2) {
        return typeof str1 === STR_TYPE ? str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1 : false;
      },
      lowerize: function lowerize(str) {
        return str.toLowerCase();
      },
      major: function major(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined$1;
      },
      trim: function trim(str, len) {
        str = str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    }; ///////////////
    // Map helper
    //////////////

    var mapper = {
      rgx: function rgx(ua, arrays) {
        var i = 0,
            j,
            k,
            p,
            q,
            matches,
            match; // loop through all regexes maps

        while (i < arrays.length && !matches) {
          var regex = arrays[i],
              // even sequence (0,2,4,..)
          props = arrays[i + 1]; // odd sequence (1,3,5,..)

          j = k = 0; // try matching uastring with regexes

          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);

            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p]; // check if given property is actually array

                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length == 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length == 3) {
                    // check whether function or regex
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length == 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }

          i += 2;
        }
      },
      str: function str(_str, map) {
        for (var i in map) {
          // check if array
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (util.has(map[i][j], _str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (util.has(map[i], _str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }

        return _str;
      }
    }; ///////////////
    // String map
    //////////////

    var maps = {
      browser: {
        // Safari < 3.0
        oldSafari: {
          version: {
            '1.0': '/8',
            '1.2': '/1',
            '1.3': '/3',
            '2.0': '/412',
            '2.0.2': '/416',
            '2.0.3': '/417',
            '2.0.4': '/419',
            '?': '/'
          }
        },
        oldEdge: {
          version: {
            '0.1': '12.',
            '21': '13.',
            '31': '14.',
            '39': '15.',
            '41': '16.',
            '42': '17.',
            '44': '18.'
          }
        }
      },
      os: {
        windows: {
          version: {
            'ME': '4.90',
            'NT 3.11': 'NT3.51',
            'NT 4.0': 'NT4.0',
            '2000': 'NT 5.0',
            'XP': ['NT 5.1', 'NT 5.2'],
            'Vista': 'NT 6.0',
            '7': 'NT 6.1',
            '8': 'NT 6.2',
            '8.1': 'NT 6.3',
            '10': ['NT 6.4', 'NT 10.0'],
            'RT': 'ARM'
          }
        }
      }
    }; //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ], [VERSION, [NAME, 'Edge']], [// breaking change (reserved for next major release):
      ///edge\/([\w\.]+)/i                                                  // Old Edge (Trident)
      //], [[VERSION, mapper.str, maps.browser.oldEdge.version], [NAME, 'Edge']], [
      // Presto based
      /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
      /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i // Opera
      ], [NAME, VERSION], [/opios[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [VERSION, [NAME, 'Opera Mini']], [/\sopr\/([\w\.]+)/i // Opera Webkit
      ], [VERSION, [NAME, 'Opera']], [// Mixed
      /(kindle)\/([\w\.]+)/i, // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
      /(ba?idubrowser)[\/\s]?([\w\.]+)/i, // Baidu Browser
      /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
      // Webkit/KHTML based
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i, // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i, // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
      /(weibo)__([\d\.]+)/i // Weibo
      ], [NAME, VERSION], [/(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
      ], [VERSION, [NAME, 'UCBrowser']], [/(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i // WeChat Desktop for Windows Built-in Browser
      ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
      ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
      ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i // IE11
      ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
      ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ], [[NAME, /(.+)/, '$1 Secure Browser'], VERSION], [/focus\/([\w\.]+)/i // Firefox Focus
      ], [VERSION, [NAME, 'Firefox Focus']], [/opt\/([\w\.]+)/i // Opera Touch
      ], [VERSION, [NAME, 'Opera Touch']], [/coc_coc_browser\/([\w\.]+)/i // Coc Coc Browser
      ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
      ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
      ], [VERSION, [NAME, 'Opera Coast']], [/xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, 'MIUI Browser']], [/fxios\/([\w\.-]+)/i // Firefox for iOS
      ], [VERSION, [NAME, 'Firefox']], [/(qihu|qhbrowser|qihoobrowser|360browser)/i // 360
      ], [[NAME, '360 Browser']], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 Browser'], VERSION], [// Oculus/Samsung/Sailfish Browser
      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, ' '], VERSION], [/\s(electron)\/([\w\.]+)\ssafari/i, // Electron-based App
      /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i, // Tesla
      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
      ], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i, // SouGouBrowser
      /(LBBROWSER)/i // LieBao Browser
      ], [NAME], [// WebView
      /;fbav\/([\w\.]+);/i // Facebook App for iOS & Android with version
      ], [VERSION, [NAME, 'Facebook']], [/FBAN\/FBIOS|FB_IAB\/FB4A/i // Facebook App for iOS & Android without version
      ], [[NAME, 'Facebook']], [/safari\s(line)\/([\w\.]+)/i, // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
      /(chromium|instagram)[\/\s]([\w\.-]+)/i // Chromium/Instagram
      ], [NAME, VERSION], [/\bgsa\/([\w\.]+)\s.*safari\//i // Google Search Appliance on iOS
      ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
      ], [VERSION, [NAME, 'Chrome Headless']], [/\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, 'Chrome WebView'], VERSION], [/droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i // Android Browser
      ], [VERSION, [NAME, 'Android Browser']], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i // Mobile Safari
      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, mapper.str, maps.browser.oldSafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
      /(navigator|netscape)\/([\w\.-]+)/i // Netscape
      ], [[NAME, 'Netscape'], VERSION], [/ile\svr;\srv:([\w\.]+)\).+firefox/i // Firefox Reality
      ], [VERSION, [NAME, 'Firefox Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
      /(swiftfox)/i, // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i, // Other Firefox-based
      /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i, // Mozilla
      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
      /(links)\s\(([\w\.]+)/i, // Links
      /(gobrowser)\/?([\w\.]*)/i, // GoBrowser
      /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
      /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
      ], [NAME, VERSION]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|armv?8e?l?)\b/i // ARM64
      ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ], [[ARCHITECTURE, 'armhf']], [// PocketPC mistakenly identified as PowerPC
      /windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, util.lowerize]]],
      device: [[//////////////////////////
      // MOBILES & TABLETS
      // Ordered by popularity
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i], [MODEL, [VENDOR, 'Samsung'], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i, /\ssamsung[\s-]([\w-]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, 'Samsung'], [TYPE, MOBILE]], [// Apple
      /\((ip(?:hone|od)[\s\w]*);/i // iPod/iPhone
      ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/\((ipad);[\w\s\),;-]+apple/i, // iPad
      /applecoremedia\/[\w\.]+\s\((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [// Huawei
      /\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i, /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [// Xiaomi
      /\b(poco[\s\w]+)(?:\sbuild|\))/i, // Xiaomi POCO
      /\b;\s(\w+)\sbuild\/hm\1/i, // Xiaomi Hongmi 'numeric' models
      /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i, // Xiaomi Hongmi
      /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i, // Xiaomi Redmi
      /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i // Xiaomi Mi
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [/\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i // Mi Pad tablets
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [// OPPO
      /;\s(\w+)\sbuild.+\soppo/i, /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [// Vivo
      /\svivo\s(\w+)(?:\sbuild|\))/i, /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [// Realme
      /\s(rmx[12]\d{3})(?:\sbuild|;)/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [// Motorola
      /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i, /\smot(?:orola)?[\s-](\w*)/i, /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [/\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [// LG
      /((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [/(lm-?f100[nv]?|nexus\s[45])/i, /lg[e;\s\/-]+((?!browser|netcast)\w+)/i, /\blg(\-?[\d\w]+)\sbuild/i], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [// Lenovo
      /(ideatab[\w\-\s]+)/i, /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i // Lenovo tablets
      ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [// Nokia
      /(?:maemo|nokia).*(n900|lumia\s\d+)/i, /nokia[\s_-]?([\w\.-]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [// Google
      /droid.+;\s(pixel\sc)[\s)]/i // Google Pixel C
      ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [/droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i // Google Pixel
      ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [// Sony
      /droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [/sony\stablet\s[ps]\sbuild\//i, /(?:sony)?sgp\w+(?:\sbuild\/|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, 'Sony'], [TYPE, TABLET]], [// OnePlus
      /\s(kb2005|in20[12]5|be20[12][59])\b/i, /\ba000(1)\sbuild/i, // OnePlus
      /\boneplus\s(a\d{4})[\s)]/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [// Amazon
      /(alexa)webm/i, /(kf[a-z]{2}wi)(\sbuild\/|\))/i, // Kindle Fire without Silk
      /(kf[a-z]+)(\sbuild\/|\)).+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i // Fire Phone
      ], [[MODEL, 'Fire Phone'], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [// BlackBerry
      /\((playbook);[\w\s\),;-]+(rim)/i // BlackBerry PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10;\s(\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [// Asus
      /(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i], [MODEL, [VENDOR, 'ASUS'], [TYPE, TABLET]], [/\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i], [MODEL, [VENDOR, 'ASUS'], [TYPE, MOBILE]], [// HTC
      /(nexus\s9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i, // HTC
      // ZTE
      /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [// Acer
      /droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [// Meizu
      /droid.+;\s(m[1-5]\snote)\sbuild/i, /\bmz-([\w-]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [// MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp)\s([\w\s]+\w)/i, // HP iPAQ
      /(asus)-?(\w+)/i, // Asus
      /(microsoft);\s(lumia[\s\w]+)/i, // Microsoft Lumia
      /(lenovo)[_\s-]?([\w-]+)/i, // Lenovo
      /linux;.+(jolla);/i, // Jolla
      /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos)\s(gamepad2?)/i, // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
      /(kindle)\/([\w\.]+)/i, // Kindle
      /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
      /(dell)\s(strea[kpr\s\d]*[\dko])/i, // Dell Streak
      /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i, // Le Pan Tablets
      /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i, // Trinity Tablets
      /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i, // Gigaset Tablets
      /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i // Vodafone
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(surface\sduo)\s/i // Surface Duo
      ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, TABLET]], [/droid\s[\d\.]+;\s(fp\du?)\sbuild/i], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/\s(u304aa)\sbuild/i // AT&T
      ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/sie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/[;\/]\s?(rct\w+)\sbuild/i // RCA Tablets
      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/[;\/\s](venue[\d\s]{2,7})\sbuild/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i // Verizon Tablet
      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/[;\/]\s(tm\d{3}\w+)\sbuild/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/;\s(k88)\sbuild/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/;\s(nx\d{3}j)\sbuild/i // ZTE Nubia
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/[;\/]\s?(gen\d{3})\sbuild.*49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/[;\/]\s?(zur\d{3})\sbuild/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/[;\/]\s?((zeki)?tb.*\b)\sbuild/i // Zeki Tablets
      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/[;\/]\s([yr]\d{2})\sbuild/i, /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i // Dragon Touch Tablet
      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/[;\/]\s?(ns-?\w{0,9})\sbuild/i // Insignia Tablets
      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i // NextBook Tablets
      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones
      /[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i // LvTel Phones
      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/;\s(ph-1)\s/i], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [// Essential PH-1
      /[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i // Envizen Tablets
      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/[;\/]\s?tu_(1491)\sbuild/i // Rotor Tablets
      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w\s]+)\sbuild/i // Nvidia Shield Tablets
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint)\s(\w+)/i // Sprint Phones
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [/droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ], [MODEL, [VENDOR, 'Zebra'], [TYPE, TABLET]], [/droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, 'Zebra'], [TYPE, MOBILE]], [///////////////////
      // CONSOLES
      ///////////////////
      /\s(ouya)\s/i, // Ouya
      /(nintendo)\s([wids3utch]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+;\s(shield)\sbuild/i // Nvidia
      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation\s[345portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [/[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i // Samsung
      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [/(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i // LG SmartTV
      ], [[VENDOR, 'LG'], [TYPE, SMARTTV]], [/(apple)\s?tv/i // Apple TV
      ], [VENDOR, [MODEL, 'Apple TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
      ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [/droid.+aft([\w])(\sbuild\/|\))/i // Fire TV
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
      ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i // SmartTV from Unidentified Vendors
      ], [[TYPE, SMARTTV]], [///////////////////
      // WEARABLES
      ///////////////////
      /((pebble))app\/[\d\.]+\s/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+;\s(glass)\s\d/i // Google Glass
      ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [/droid\s[\d\.]+;\s(wt63?0{2,3})\)/i], [MODEL, [VENDOR, 'Zebra'], [TYPE, WEARABLE]], [///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i // Tesla
      ], [VENDOR, [TYPE, EMBEDDED]], [////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i // Android Phones from Unidentified Vendors
      ], [MODEL, [TYPE, MOBILE]], [/droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ], [MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
      /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
      ], [[TYPE, util.lowerize]], [/(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
      ], [MODEL, [VENDOR, 'Generic']], [/(phone)/i], [[TYPE, MOBILE]]],
      engine: [[/windows.+\sedge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, 'EdgeHTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i, // Flow
      /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
      /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[// Windows
      /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
      /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, // Windows Phone
      /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [// iOS/macOS
      /ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i, // iOS
      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i // Mac OS
      ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Mobile OSes                                                      // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
      /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
      /(tizen|kaios)[\/\s]([\w\.]+)/i, // Tizen/KaiOS
      /\((series40);/i // Series 40
      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
      ], [VERSION, [NAME, 'BlackBerry']], [/(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i // Symbian
      ], [VERSION, [NAME, 'Symbian']], [/mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
      ], [[NAME, 'Firefox OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ], [VERSION, [NAME, 'webOS']], [// Google Chromecast
      /crkey\/([\d\.]+)/i // Google Chromecast
      ], [VERSION, [NAME, 'Chromecast']], [/(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
      ], [[NAME, 'Chromium OS'], VERSION], [// Console
      /(nintendo|playstation)\s([wids345portablevuch]+)/i, // Nintendo/Playstation
      /(xbox);\s+xbox\s([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)
      // GNU/Linux based
      /(mint)[\/\s\(\)]?(\w*)/i, // Mint
      /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
      /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i, // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
      // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
      /(hurd|linux)\s?([\w\.]*)/i, // Hurd/Linux
      /(gnu)\s?([\w\.]*)/i, // GNU
      // BSD based
      /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
      /(haiku)\s(\w+)/i // Haiku
      ], [NAME, VERSION], [// Other
      /(sunos)\s?([\w\.\d]*)/i // Solaris
      ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, // Solaris
      /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, // AIX
      /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
      /(unix)\s?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    }; /////////////////
    // Constructor
    ////////////////

    var UAParser = function UAParser(ua, extensions) {
      if (typeof ua === 'object') {
        extensions = ua;
        ua = undefined$1;
      }

      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }

      var _ua = ua || (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);

      var _rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

      this.getBrowser = function () {
        var _browser = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_browser, _ua, _rgxmap.browser);
        _browser.major = util.major(_browser.version); // deprecated

        return _browser;
      };

      this.getCPU = function () {
        var _cpu = {
          architecture: undefined$1
        };
        mapper.rgx.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };

      this.getDevice = function () {
        var _device = {
          vendor: undefined$1,
          model: undefined$1,
          type: undefined$1
        };
        mapper.rgx.call(_device, _ua, _rgxmap.device);
        return _device;
      };

      this.getEngine = function () {
        var _engine = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };

      this.getOS = function () {
        var _os = {
          name: undefined$1,
          version: undefined$1
        };
        mapper.rgx.call(_os, _ua, _rgxmap.os);
        return _os;
      };

      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };

      this.getUA = function () {
        return _ua;
      };

      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? util.trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };

      this.setUA(_ua);
      return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
      NAME: NAME,
      MAJOR: MAJOR,
      // deprecated
      VERSION: VERSION
    };
    UAParser.CPU = {
      ARCHITECTURE: ARCHITECTURE
    };
    UAParser.DEVICE = {
      MODEL: MODEL,
      VENDOR: VENDOR,
      TYPE: TYPE,
      CONSOLE: CONSOLE,
      MOBILE: MOBILE,
      SMARTTV: SMARTTV,
      TABLET: TABLET,
      WEARABLE: WEARABLE,
      EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
      NAME: NAME,
      VERSION: VERSION
    };
    UAParser.OS = {
      NAME: NAME,
      VERSION: VERSION
    }; ///////////
    // Export
    //////////
    // check js environment

    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = UAParser;
      }

      exports.UAParser = UAParser;
    } // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.

    var $ = typeof window !== 'undefined' && (window.jQuery || window.Zepto);

    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();

      $.ua.get = function () {
        return parser.getUA();
      };

      $.ua.set = function (uastring) {
        parser.setUA(uastring);
        var result = parser.getResult();

        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === 'object' ? window : commonjsGlobal);
});

var hostname$2 = function hostname$2() {
  return isBrowser$2() ? window.location.hostname : 'fabfitfun.com';
};

var getEnv$2 = function getEnv$2() {
  if (hostname$2().includes('fabfitfun')) {
    return {
      name: 'prod',
      originUrl: 'fabfitfun.com',
      segmentToken: '7kbHDCgVdd'
    };
  }

  if (hostname$2().includes('fff-staging')) {
    return {
      name: 'staging',
      originUrl: 'fff-staging.com',
      segmentToken: 'vVhAGbpFsr2EJsYiB1e4y0IMnzMl10T8'
    };
  }

  if (hostname$2().includes('fff-qa')) {
    return {
      name: 'qa',
      originUrl: 'fff-qa.com',
      segmentToken: '13meRIwJgrTiyjmcHpuNKjg4DztAEF8L'
    };
  }

  return {
    name: 'dev',
    originUrl: 'fff-dev.com',
    segmentToken: 'hNqaG11W3uumnIjKGU7cwCx6vduBrmc8'
  };
};

var SESSION_INFO_KEY = 'sm_session_info';
/* eslint-disable no-bitwise */

var getGenericTrackingData = function getGenericTrackingData() {
  var sessionInfo = js_cookie.getJSON(SESSION_INFO_KEY);

  if (!sessionInfo) {
    var sessionId = getUuid();
    var sessionCreationDate = new Date();
    js_cookie.set(SESSION_INFO_KEY, {
      sessionId: sessionId,
      sessionCreationDate: sessionCreationDate
    }, {
      domain: getEnv$2().originUrl,
      path: '/',
      expires: 1 / 24 / 2
    });
    return {
      device: getDevice(),
      sessionId: sessionId,
      sessionCreationDate: sessionCreationDate
    };
  }

  return {
    device: getDevice(),
    sessionId: sessionInfo.sessionId,
    sessionCreationDate: sessionInfo.sessionCreationDate
  };
};

var getDevice = function getDevice() {
  var deviceRegex = [[/(Intel Mac OS|PPC Mac OS)/i], [[uaParser.DEVICE.VENDOR, 'Apple'], [uaParser.DEVICE.TYPE, 'Desktop']], [/(Windows NT|Linux i686)/i], [[uaParser.DEVICE.TYPE, 'Desktop']], [/(Linux armv7l|Mobile)/i], [[uaParser.DEVICE.TYPE, 'Mobile Web']], [/(Tablet|iPad)/i], [[uaParser.DEVICE.TYPE, 'Tablet Web']]];
  var parser = new uaParser(undefined, {
    device: deviceRegex
  });
  var type = parser.getResult().device.type;
  return type;
}; // Matches legacy session IDs


var getUuid = function getUuid() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

var warnMessages = {
  TRACK_NAME_IS_REQUIRED: 'trackName parameter is required',
  ANALYTICS_IS_NOT_INITIALIZED: 'windows analytics is not initialized',
  ELEMENT_PARAMETER_IS_REQUIRED: 'elementName parameter is required',
  CTA_NAME_IS_REQUIRED: 'cta_name parameter is required'
};
/* eslint-disable no-console */

var trackNameIsRequired = function trackNameIsRequired() {
  return console.warn(warnMessages.TRACK_NAME_IS_REQUIRED);
};

var analyticsIsNotInitialized = function analyticsIsNotInitialized() {
  return console.warn(warnMessages.ANALYTICS_IS_NOT_INITIALIZED);
};

var elementParameterIsRequired = function elementParameterIsRequired() {
  return console.warn(warnMessages.ELEMENT_PARAMETER_IS_REQUIRED);
};

var formatReferrerQueryStringValues = function formatReferrerQueryStringValues(value) {
  var referrerQueryString = {
    my_account: 'MY ACCOUNT',
    global_footer: 'FOOTER',
    footer_link: 'FOOTER LINK',
    footer: 'FOOTER',
    my_box: 'MY BOX',
    homepage: 'HOMEPAGE',
    customize: 'CUSTOMIZE',
    global_nav: 'GLOBAL NAV',
    global_banner: 'GLOBAL BANNER',
    homepage_popup: 'HOMEPAGE POPUP',
    cancel_flow: 'CANCEL FLOW',
    my_account_cta: 'MY ACCOUNT CTA'
  };
  return referrerQueryString[value];
};

var propsToTitleCase = function propsToTitleCase(properties) {
  var titleCasedProperties = {};
  var keys = Object.keys(properties);
  keys.forEach(function (key) {
    if (typeof properties[key] === 'string') {
      titleCasedProperties[key] = toTitleCase(properties[key]);
    } else {
      titleCasedProperties[key] = properties[key];
    }
  });
  return titleCasedProperties;
};

var toTitleCase = function toTitleCase(str) {
  return str.toLowerCase().replace(/(?:^|[\s-_])\w/g, function (match) {
    return match.toUpperCase();
  });
};

var REFERRER_QUERY_STRING = 'referrer';

var getExperienceField = function getExperienceField() {
  var referrerValue = getParamFromUrl(REFERRER_QUERY_STRING);
  var queryValue = formatReferrerQueryStringValues(referrerValue);

  if (!queryValue) {
    return;
  } // eslint-disable-next-line consistent-return


  return toTitleCase(queryValue);
};

var trackInfo = function trackInfo(_a) {
  var fffAnalytics = _a.fffAnalytics,
      _b = _a.properties,
      properties = _b === void 0 ? {} : _b;
  return _assign$2(_assign$2(_assign$2({}, fffAnalytics.sessionInfo), {
    experience: (properties === null || properties === void 0 ? void 0 : properties.experience) ? toTitleCase(properties.experience) : getExperienceField()
  }), propsToTitleCase(properties));
};

var ReferrerQueryString = {
  myAccount: 'my_account',
  globalFooter: 'global_footer',
  footerLink: 'footer_link',
  footer: 'footer',
  myBox: 'my_box',
  homepage: 'homepage',
  customize: 'customize',
  globalNav: 'global_nav',
  globalBanner: 'global_banner',
  homepagePopup: 'homepage_popup',
  cancelFlow: 'cancel_flow',
  myAccountCta: 'my_account_cta'
};
var fffAnalytics;

if (isBrowser$2()) {
  // eslint-disable-next-line no-multi-assign
  fffAnalytics = window.fffAnalytics = window.fffAnalytics || {
    segmentToken: getEnv$2().segmentToken,
    userData: {},
    sessionInfo: getGenericTrackingData(),
    init: false
  };
}

var initialize = function initialize() {
  return __awaiter$1(void 0, void 0, void 0, function () {
    var _a;

    return __generator$1(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (!fffAnalytics) return [2
          /*return*/
          ];
          if (!fffAnalytics.init) fffAnalytics.init = loadSegment({
            token: fffAnalytics.segmentToken
          });
          fffAnalytics.sessionInfo = getGenericTrackingData();
          _a = fffAnalytics;
          return [4
          /*yield*/
          , getUserInfo()];

        case 1:
          _a.userData = _b.sent();
          return [2
          /*return*/
          ];
      }
    });
  });
};

var trackElement = function trackElement(_a) {
  var elementName = _a.elementName,
      _b = _a.properties,
      properties = _b === void 0 ? {} : _b,
      _c = _a.options,
      options = _c === void 0 ? {} : _c,
      _d = _a.callback,
      callback = _d === void 0 ? function () {
    return null;
  } : _d;
  return __awaiter$1(void 0, void 0, void 0, function () {
    return __generator$1(this, function (_e) {
      switch (_e.label) {
        case 0:
          if (!elementName) return [2
          /*return*/
          , elementParameterIsRequired()];
          return [4
          /*yield*/
          , track({
            trackName: 'Clicked Element',
            properties: _assign$2({
              element_name: elementName
            }, properties),
            options: options,
            callback: callback
          })];

        case 1:
          _e.sent();

          return [2
          /*return*/
          ];
      }
    });
  });
};

var track = function track(_a) {
  var trackName = _a.trackName,
      _b = _a.properties,
      properties = _b === void 0 ? {} : _b,
      _c = _a.options,
      options = _c === void 0 ? {} : _c,
      _d = _a.callback,
      callback = _d === void 0 ? function () {
    return null;
  } : _d;
  return __awaiter$1(void 0, void 0, void 0, function () {
    var localStorageUserInfo, trackProperties;
    return __generator$1(this, function (_e) {
      switch (_e.label) {
        case 0:
          if (!trackName) return [2
          /*return*/
          , trackNameIsRequired()];
          if (!isBrowser$2() || !window.analytics) return [2
          /*return*/
          , analyticsIsNotInitialized()];
          return [4
          /*yield*/
          , getUserInfo()];

        case 1:
          localStorageUserInfo = _e.sent();
          fffAnalytics.userData = localStorageUserInfo;
          trackProperties = trackInfo({
            fffAnalytics: fffAnalytics,
            localStorageUserInfo: localStorageUserInfo,
            properties: properties
          });
          window.analytics.track(trackName, trackProperties, options, callback);
          return [2
          /*return*/
          ];
      }
    });
  });
};

function isBrowser() {
  return ![typeof window, typeof document].includes('undefined');
}

var PROD = 'prod';
var STAGING = 'staging';
var QA = 'qa';
var DEV = 'dev'; //const LOAD = 'load';

function getEnv() {
  var _ref3 = isBrowser() ? window.location : {
    hostname: 'fabfitfun.com'
  },
      hostname = _ref3.hostname;

  if (hostname.includes('fabfitfun')) {
    return PROD;
  }

  if (hostname.includes('fff-staging')) {
    return STAGING;
  }

  if (hostname.includes('fff-qa')) {
    return QA;
  }

  return DEV;
}

function getLDClientId() {
  var env = getEnv();

  switch (env) {
    case PROD:
      return '5f90aeab892e740961596bba';

    case STAGING:
      return '5f90b058892e740961596c0a';

    case QA:
      return '5f90b04bd1a56a0983a8cef8';

    default:
      return '5f90b008892e740961596c05';
  }
}

function getHostName() {
  var env = getEnv();

  switch (env) {
    case PROD:
      return 'fabfitfun';

    case STAGING:
      return 'fff-staging';

    case QA:
      return 'fff-qa';

    default:
      return 'fff-dev';
  }
}

function getOneTrustHash() {
  var env = getEnv();

  if (env === PROD) {
    return '091bf775-529d-4036-a445-3a322675c69c';
  }

  return 'a6170136-4755-4592-826f-3c85fc8fb6a7-test';
}

function getPactSafeVars() {
  var env = getEnv();

  if (env === PROD) {
    return {
      pactSafeGTBGroup: '16492',
      pactSafeSGTFGroup: '16494',
      pactSafeEmailOptInGroup: '16495',
      pactSafeReactivateMyMembershipGroup: '16493',
      pactSafeSid: 'f5cccf06-b9d2-4d67-a249-32d6e0182582'
    };
  }

  return {
    pactSafeGTBGroup: '16266',
    pactSafeSGTFGroup: '16267',
    pactSafeEmailOptInGroup: '16269',
    pactSafeReactivateMyMembershipGroup: '16270',
    pactSafeSid: '72097bf3-0831-44ad-b21b-744afe8e4a3d'
  };
}

function getZendesk() {
  var env = getEnv();

  switch (env) {
    case PROD:
      return '6f223498-a3ca-4a4e-bda0-678a2af96c01';

    case STAGING:
      return '6f223498-a3ca-4a4e-bda0-678a2af96c01';

    case QA:
      return '6f223498-a3ca-4a4e-bda0-678a2af96c01';

    default:
      return '6f223498-a3ca-4a4e-bda0-678a2af96c01';
  }
}
/* eslint-disable prefer-promise-reject-errors */


var LOCATION = 'footer';
var defaultHeaders = {
  'FFF-Auth': 'V1.1',
  'Content-Type': 'application/json; charset=utf-8'
};
var hostname = getHostName();

function getShippingAddress() {
  return _getShippingAddress.apply(this, arguments);
}

function _getShippingAddress() {
  _getShippingAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch("https://user.".concat(hostname, ".com/users/shipping-address"), {
              credentials: 'include',
              headers: _objectSpread({}, defaultHeaders),
              data: {
                activatedOn: true
              },
              mode: 'cors',
              method: 'GET'
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", null);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _getShippingAddress.apply(this, arguments);
}

function getBoxState() {
  return _getBoxState.apply(this, arguments);
}

function _getBoxState() {
  _getBoxState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetch("https://box.".concat(hostname, ".com/boxes/self/box-state"), {
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 3:
            response = _context3.sent;

            if (!response.ok) {
              _context3.next = 9;
              break;
            }

            _context3.next = 7;
            return response.json();

          case 7:
            data = _context3.sent;
            return _context3.abrupt("return", Promise.resolve(data === null || data === void 0 ? void 0 : data.boxState));

          case 9:
            // eslint-disable-next-line no-console
            console.error('Could not get box-state', response);
            Promise.reject(new Error());
            _context3.next = 17;
            break;

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0);
            // eslint-disable-next-line no-console
            console.error('Could not get box-state', _context3.t0);
            Promise.reject(new Error());

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 13]]);
  }));
  return _getBoxState.apply(this, arguments);
}

function getFooterContent() {
  return _getFooterContent.apply(this, arguments);
}

function _getFooterContent() {
  _getFooterContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", getContent('global-footer-v2', 'default'));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getFooterContent.apply(this, arguments);
}

function getContent(_x, _x2) {
  return _getContent.apply(this, arguments);
}

function _getContent() {
  _getContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(schemaName, contentId) {
    var finalContentId, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            finalContentId = contentId || 'default';
            _context5.prev = 1;
            _context5.next = 4;
            return fetch("https://content.".concat(hostname, ".com/contents/self/").concat(schemaName, "/").concat(finalContentId), {
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              },
              method: 'GET'
            });

          case 4:
            response = _context5.sent;

            if (!response.ok) {
              _context5.next = 11;
              break;
            }

            _context5.t0 = Promise;
            _context5.next = 9;
            return response.json();

          case 9:
            _context5.t1 = _context5.sent.data;
            return _context5.abrupt("return", _context5.t0.resolve.call(_context5.t0, _context5.t1));

          case 11:
            // eslint-disable-next-line no-console
            console.error("error to obtain schemaName ".concat(schemaName, " contentId ").concat(finalContentId), response);
            Promise.reject({});
            _context5.next = 19;
            break;

          case 15:
            _context5.prev = 15;
            _context5.t2 = _context5["catch"](1);
            // eslint-disable-next-line no-console
            console.error("error to obtain schemaName ".concat(schemaName, " contentId ").concat(finalContentId), _context5.t2);
            Promise.reject({});

          case 19:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 15]]);
  }));
  return _getContent.apply(this, arguments);
}

var sendEmailToIterable = function sendEmailToIterable(email) {
  track({
    trackName: 'GTB Email Capture',
    properties: {
      email: email,
      form_location: LOCATION
    }
  });
  var pactSafeVars = getPactSafeVars();

  if (isBrowser()) {
    window.fffPactSafe.init(pactSafeVars.pactSafeSid);
    window.fffPactSafe.signContractsForGroup(email, pactSafeVars.pactSafeEmailOptInGroup);
  }
};

function getSubscriptionPlans() {
  return _getSubscriptionPlans.apply(this, arguments);
} // @flow


function _getSubscriptionPlans() {
  _getSubscriptionPlans = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetch("https://localization-api.".concat(hostname, ".com/api/1/subscription/plans"), {
              credentials: 'include',
              headers: _objectSpread({}, defaultHeaders),
              mode: 'cors',
              method: 'GET'
            });

          case 3:
            response = _context6.sent;

            if (!response.ok) {
              _context6.next = 10;
              break;
            }

            _context6.t0 = Promise;
            _context6.next = 8;
            return response.json();

          case 8:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", _context6.t0.resolve.call(_context6.t0, _context6.t1));

          case 10:
            _context6.next = 15;
            break;

          case 12:
            _context6.prev = 12;
            _context6.t2 = _context6["catch"](0);
            Promise.reject(_context6.t2);

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 12]]);
  }));
  return _getSubscriptionPlans.apply(this, arguments);
}

var emptyShippingAddress = function emptyShippingAddress() {
  return {
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    isLogin: false
  };
};

var addressDurationInMs = 10 * 60 * 1000; //10 minutes;

var addressKey = 'address-with-login-Info';

var getAddressFromStorage = function getAddressFromStorage() {
  var addressWithLoginInfo = storage.getFromStorage({
    key: addressKey
  });
  return addressWithLoginInfo || emptyShippingAddress();
};

function useShippingAddress(callUser) {
  var _useState3 = useState(_objectSpread({}, getAddressFromStorage())),
      _useState4 = _slicedToArray2(_useState3, 2),
      shippingAddress = _useState4[0],
      setShippingAddress = _useState4[1];

  useEffect(function () {
    // eslint-disable-next-line consistent-return
    function setShippingAddressState() {
      return _setShippingAddressState.apply(this, arguments);
    }

    function _setShippingAddressState() {
      _setShippingAddressState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var savedAddress, addressDetailsResponse, addressWithLoginInfo, addressDetails;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                savedAddress = storage.getFromStorage({
                  key: addressKey
                });

                if (!savedAddress) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", savedAddress);

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return getShippingAddress();

              case 6:
                addressDetailsResponse = _context.sent;
                addressWithLoginInfo = _objectSpread({}, emptyShippingAddress());

                if (!addressDetailsResponse.ok) {
                  _context.next = 16;
                  break;
                }

                _context.next = 11;
                return addressDetailsResponse.json();

              case 11:
                addressDetails = _context.sent;
                addressWithLoginInfo = _objectSpread({}, callUser ? addressDetails : emptyShippingAddress(), {
                  isLogin: true
                });
                storage.setToStorage({
                  key: addressKey,
                  value: addressWithLoginInfo,
                  durationInMs: addressDurationInMs
                });
                _context.next = 17;
                break;

              case 16:
                storage.removeFromStorage({
                  key: addressKey
                });

              case 17:
                setShippingAddress(addressWithLoginInfo);
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](3);
                // eslint-disable-next-line no-console
                console.log(_context.t0);
                storage.removeFromStorage({
                  key: addressKey
                });

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 20]]);
      }));
      return _setShippingAddressState.apply(this, arguments);
    }

    if (callUser === true) {
      setShippingAddressState();
    }
  }, [callUser]);
  return shippingAddress;
}

function loadOneTrust() {
  if (!isBrowser()) {
    return false;
  }

  var oneTrustHash = getOneTrustHash();
  var autoBlockScriptSrc = "https://cdn.cookielaw.org/consent/".concat(oneTrustHash, "/OtAutoBlock.js");
  var stubScriptSrc = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

  if (!scriptExists$1.scriptExists(autoBlockScriptSrc)) {
    var autoBlockScript = document.createElement('script');
    autoBlockScript.src = autoBlockScriptSrc;
    autoBlockScript.type = 'text/javascript';
    document.head.appendChild(autoBlockScript);
  }

  if (!scriptExists$1.scriptExists(stubScriptSrc)) {
    var stubScript = document.createElement('script');
    stubScript.src = stubScriptSrc;
    stubScript.type = 'text/javascript';
    stubScript.setAttribute('data-domain-script', 'a6170136-4755-4592-826f-3c85fc8fb6a7-test');
    document.head.appendChild(stubScript);
  }

  if (!window.OptanonWrapper) {
    var optWrapperScript = document.createElement('script');
    optWrapperScript.text = 'function OptanonWrapper() {}';
    optWrapperScript.type = 'text/javascript';
    document.head.appendChild(optWrapperScript);
  }

  return true;
}

function loadPactSafe() {
  if (!isBrowser()) {
    return false;
  }

  var envUrl = getHostName();
  var protocol = window.location.href.split('/')[0];
  var scriptSrc = "".concat(protocol, "//abtesting.").concat(envUrl, ".com/Shared/assets/js/fffPactSafe.min.js");

  if (!scriptExists$1.scriptExists(scriptSrc)) {
    var blockScript = document.createElement('script');
    blockScript.src = scriptSrc;
    blockScript.type = 'text/javascript';
    document.head.appendChild(blockScript);
  }

  return true;
}

var gladlyScript = "\n    !function(c,n,r,t){if(!c[r]){var i,d,p=[];\n    d=\"PROD\"!==t&&t?\"STAGING\"===t?\"https://cdn.gladly.qa/gladly/chat-sdk/widget.js\":\n    t:\"https://cdn.gladly.com/chat-sdk/widget.js\",c[r]={init:function(){i=arguments;\n    var e={then:function(t){return p.push({type:\"t\",next:t}),e},\n    catch:function(t){return p.push({type:\"c\",next:t}),e}};return e}},\n    c.onHelpAppHostReady=function(t){if(delete c.onHelpAppHostReady,(c[r]=t).loaderCdn=d,i)\n    for(var e=t.init.apply(t,i),n=0;n<p.length;n++)\n    {var a=p[n];e=\"t\"===a.type?e.then(a.next):e.catch(a.next)}},\n    function(){try{var t=n.getElementsByTagName(\"script\")[0],e=n.createElement(\"script\");\n    e.async=!0,e.src=d+\"?q=\"+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}}\n    (window,document,'Gladly','PROD')\n  ";
var gladlyAndAdaStyle = "\n<style>\n.show-button {\n  display: block !important;\n}\n\n/* \n  You can position the custom Gladly button in the lower right corner\n  */\n#custom-gladly-chat-button {\n  position: fixed;\n  padding: 10px;\n  right: 20px;\n  bottom: 10px;\n}\n\n/* \n  By default we hide the Ada and Gladly buttons\n*/\n#ada-button-frame {\n  display: none;\n}\n#custom-gladly-chat-button {\n  display: none;\n}\n#custom-gladly-chat-button #with-active-chat {\n  display: none;\n}\n#gladlyChat_container .minimizedChatButton.minimizedChatButtonSelector {\n  display: none !important;\n}\n</style>";
var gladlyAndAdaScript = "\nfunction setLastChatOpened(name) {\n  sessionStorage.setItem('lastChatOpened', name);\n}\n\nfunction hideAda() {\n  window.adaEmbed.getInfo().then((info) => {\n    if (info.isChatOpen) {\n      window.adaEmbed.toggle();\n      const adaButton = document.querySelector('#ada-button-frame');\n      adaButton.classList.remove('show-button');\n    }\n  });\n}\n\nfunction displayAda() {\n  window.adaEmbed.getInfo().then((info) => {\n    if (!info.isChatOpen) {\n      const adaButton = document.querySelector('#ada-button-frame');\n      window.adaEmbed.toggle();\n      adaButton.classList.add('show-button');\n      setLastChatOpened('ada');\n    }\n  });\n}\n\nfunction checkLastChatOpened() {\n  let lastChatOpened = sessionStorage.getItem('lastChatOpened');\n\n  if (lastChatOpened === 'gladly') {\n    startGladly();\n  } else {\n    const adaButton = document.querySelector(\"#ada-button-frame\");\n    adaButton.classList.add(\"show-button\");\n  }\n}\n\nfunction startGladly(firstName, email) {\n  if (window.gladlyInit) {\n    window.Gladly.show();\n    setLastChatOpened('gladly');\n    return;\n  }\n\n  window.Gladly.init({\n    appId: 'fabfitfun.com-ada',\n    autoShowButton: false,\n  }).then(() => {\n    window.gladlyInit = true;\n\n    const lastChatOpened = sessionStorage.getItem('lastChatOpened');\n    if (lastChatOpened !== 'gladly') {\n      window.Gladly.clearUser().then(() => {\n        const user = {\n          name: firstName,\n          email,\n        };\n        window.Gladly.setUser(user);\n      });\n    }\n\n    window.Gladly.show();\n    setLastChatOpened('gladly');\n    hideAda();\n\n    window.Gladly.on('sidekick:closed', () => {\n      const gladlyButton = document.getElementById('custom-gladly-chat-button');\n      if (window.liveChatEnded) {\n        gladlyButton.classList.remove('show-button');\n        displayAda();\n        window.adaEmbed.toggle();\n      } else {\n        gladlyButton.classList.add('show-button');\n      }\n    });\n\n    window.Gladly.on('conversation:ended', () => {\n      window.liveChatEnded = true;\n    });\n\n    window.Gladly.on('conversation:started', () => {\n      window.liveChatEnded = false;\n    });\n\n    window.Gladly.on('sidekick:opened', () => {\n      hideAda();\n    });\n  }).catch((error) => {\n    displayAda();\n    console.log('error:', error);\n  });\n}\n\n  window.adaSettings = {\n    adaReadyCallback: () => {\n      !function(c,n,r,t){if(!c[r]){var i,d,p=[];d=\"PROD\"!==t&&t?\"STAGING\"===\n      t?\"https://cdn.gladly.qa/gladly/chat-sdk/widget.js\":t:\n      \"https://cdn.gladly.com/chat-sdk/widget.js\",\n      c[r]={init:function(){i=arguments;var e={then:function(t){return \n        p.push({type:\"t\",next:t}),e},catch:function(t){return p.push({type:\"c\",next:t}),e}};\n        return e}},c.__onHelpAppHostReady__=function(t)\n        {if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)for(var e=t.init.apply(t,i),n=0;\n          n<p.length;n++){var a=p[n];e=\"t\"===a.type?e.then(a.next):e.catch(a.next)}},\n          function(){try{var t=n.getElementsByTagName(\"script\")[0],e=n.createElement(\"script\");\n          e.async=!0,e.src=d+\"?q=\"+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}}\n(window,document,'Gladly','PROD')\n\n          setTimeout(function () {\n            checkLastChatOpened();\n         }, 500);\n    },\n    eventCallbacks: {\n      \"custom_handoff\": event => {\n       const first_name = event.user_data.global.firstname;\n        const email = event.user_data.global.email;\n\n        startGladly(first_name, email);\n      }\n    }\n  }";
var zendeskScriptId = 'ze-snippet';
var adaScriptId = '__ada';
var gladlyScriptId = '__gladly';
var gladlyAndAdaScriptId = '__gladlyAndAda';

var loadZendesk = function loadZendesk() {
  var zenKey = getZendesk();
  var scriptSrc = "https://static.zdassets.com/ekr/snippet.js?key=".concat(zenKey);

  if (!scriptExists$1.scriptExists(scriptSrc)) {
    var blockScript = document.createElement('script');
    blockScript.id = zendeskScriptId;
    blockScript.src = scriptSrc;
    blockScript.type = 'text/javascript';
    document.head.appendChild(blockScript);
  }

  return true;
};

var loadGladlyChat = function loadGladlyChat() {
  var blockScript = document.createElement('script');
  blockScript.innerHTML = gladlyScript;
  blockScript.id = gladlyScriptId;
  blockScript.type = 'text/javascript';
  document.head.appendChild(blockScript);
  window.gladlyConfig = {
    appId: 'fabfitfun.com'
  };
  return true;
};

var loadGladlyAndAdaChat = function loadGladlyAndAdaChat() {
  document.head.insertAdjacentHTML('beforeend', gladlyAndAdaStyle);
  window.gladlyInit = false;
  window.liveChatEnded = false;
  var scriptSrc = 'https://static.ada.support/embed2.js';

  if (!scriptExists$1.scriptExists(scriptSrc)) {
    var blockScript = document.createElement('script');
    blockScript.id = adaScriptId;
    blockScript.setAttribute('data-handle', 'fff');
    blockScript.src = scriptSrc;
    blockScript.type = 'text/javascript';
    document.head.appendChild(blockScript);
  }

  var gladlyAdaScript = document.createElement('script');
  gladlyAdaScript.innerHTML = gladlyAndAdaScript;
  gladlyAdaScript.id = gladlyAndAdaScriptId;
  gladlyAdaScript.type = 'text/javascript';
  document.body.appendChild(gladlyAdaScript);
  var chatButton = document.createElement('button');

  var handleChatButton = function handleChatButton() {
    if (window.Gladly) {
      window.Gladly.show();
      chatButton.classList.remove('show-button');
    }
  };

  chatButton.innerHTML = 'Chat';
  chatButton.id = 'custom-gladly-chat-button';
  chatButton.onclick = handleChatButton;
  document.body.appendChild(chatButton);
};

var removeScriptIfPresent = function removeScriptIfPresent(scriptId) {
  var element = document.getElementById(adaScriptId);

  if (element) {
    // eslint-disable-next-line no-console
    console.log("removing scriptId ".concat(scriptId));
    element.parentNode.removeChild(element);
  }
};

var loadChat = function loadChat(chatConfig) {
  if (!isBrowser()) {
    return false;
  }

  if (!chatConfig) {
    // eslint-disable-next-line no-console
    console.log('chatConfig is not present');
    return false;
  }

  var excludePages = chatConfig.excludesPages || [];
  var currentPath = window.location && window.location.pathname ? window.location.pathname : '';

  if (currentPath.endsWith('/')) {
    currentPath = currentPath.substr(0, currentPath.length - 1);
  }

  if (currentPath.length === 0) {
    currentPath = '/homepage';
  }

  if (excludePages.includes(currentPath)) {
    // eslint-disable-next-line no-console
    console.log('No chat loaded');
    return false;
  }

  var pagesWithAlternativeChat = chatConfig.pagesWithAlternativeChat || [];
  var useAlternative = pagesWithAlternativeChat.includes(currentPath);
  var defaultChatId = chatConfig.defaultChatId || '';

  if (defaultChatId === 'zendesk' && !useAlternative) {
    console.log('Zendesk chat loaded');
    removeScriptIfPresent(adaScriptId);
    removeScriptIfPresent(gladlyScriptId);
    return loadZendesk();
  }

  if (defaultChatId === 'gladly' && !useAlternative || defaultChatId !== 'gladly' && useAlternative) {
    console.log('Gladly chat loaded');
    removeScriptIfPresent(zendeskScriptId);
    removeScriptIfPresent(gladlyAndAdaScriptId);
    return loadGladlyChat();
  }

  if (defaultChatId === 'gladlyAndAda' && !useAlternative || defaultChatId !== 'gladlyAndAda' && useAlternative) {
    console.log('Gladly and Ada chat loaded');
    removeScriptIfPresent(zendeskScriptId);
    removeScriptIfPresent(gladlyScriptId);
    return loadGladlyAndAdaChat();
  } // eslint-disable-next-line no-console


  console.log('No chat loaded');
  return false;
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$9 = ".fff-shared-footer-container {\n  background-color: #ffffff;\n  box-sizing: border-box;\n  width: 100%;\n  display: block;\n  font-family: \"Nunito Sans\", sans-serif;\n  white-space: nowrap;\n}\n.fff-shared-footer-top-border {\n  height: 1px;\n  background-image: linear-gradient(\n    to left,\n    #ffffff,\n    #dddddd 19%,\n    #d0d0d0 52%,\n    #e6e6e6 83%,\n    #ffffff\n  );\n  margin-bottom: 40px;\n}\n.is-not-login .fff-shared-footer-top-border {\n  margin-bottom: 37px;\n}\n.fff-shared-footer-container-top {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding-bottom: 30px;\n  overflow: hidden;\n  padding-top: 8px;\n  display: flex;\n  justify-content: center;\n}\n.fff-shared-footer-container-top > div {\n  flex: 1 auto;\n}\n.fff-shared-footer-container-mobile .fff-shared-footer-container-top {\n  width: auto;\n  padding: 0;\n}\n.fff-shared-footer-container-mobile {\n  padding: 0;\n  margin: auto;\n}\n.fff-shared-footer-top-section-col {\n  margin: -5px 0 40px 20px;\n  text-align: left;\n  display: flex;\n}\n.is-not-login .fff-shared-footer-top-section-col {\n  margin: 0px 0 40px 12px;\n}\n.fff-shared-footer-container-mobile .fff-shared-footer-top-section-col {\n  margin: 0;\n}\n.fff-shared-Footer-linkFooter .fff-shared-footer-links {\n  font-weight: 400;\n  text-decoration: none;\n  transition: text-decoration 0.2s;\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 14px;\n  line-height: 1.76;\n  color: #4a4a4a;\n  padding: 0;\n  display: block;\n  cursor: pointer;\n}\n.fff-shared-Footer-linkFooter .fff-shared-footer-links:hover {\n  text-decoration: underline;\n}\n.fff-shared-Footer-linkFooter .fff-shared-footer-links:active {\n  color: #fb6a66;\n  text-decoration: underline;\n}\n.fff-shared-footer-legal {\n  max-width: 100%;\n  flex-wrap: wrap;\n}\n.fff-shared-footer-legal .fff-shared-footer-links {\n  padding: 0 15px;\n  text-decoration: none;\n}\n.fff-shared-footer-container-mobile .fff-shared-footer-links {\n  padding-bottom: 14px;\n}\n.fff-shared-legal .fff-shared-footer-legal-separator {\n  margin: auto 10px;\n}\n\n.fff-shared-footer-customerCare-bt {\n  border: 1px solid #000;\n  box-sizing: border-box;\n  letter-spacing: 1px;\n  margin: 0 auto;\n  padding: 12px 0;\n  text-decoration: none;\n  transition: background-color 0.2s;\n  height: 48px;\n  width: 238px;\n  display: block;\n}\n.fff-shared-footer-container-mobile .fff-shared-footer-customerCare-mobile {\n  margin: 0 12px;\n}\n.fff-shared-footer-container-mobile .fff-shared-footer-customerCare-bt {\n  width: 100%;\n}\n.fff-shared-footer-customerCare {\n  text-align: center;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  font-size: 16px;\n}\n.fff-shared-footer-customerCare :hover {\n  background: #eee;\n  cursor: pointer;\n}\n.fff-shared-footer-customerCare :active {\n  color: #fb6a66;\n}\n\n.fff-shared-Footer-link-container {\n  padding-top: 8px;\n}\n\n.fff-shared-footer-inner-container-link {\n  box-sizing: border-box;\n  transition: height 0.5s;\n  padding: 0 20px;\n  overflow: hidden;\n}\n\n.fff-shared-footer-inner-container-link:last-child {\n  padding-left: 18px;\n  max-width: 100px;\n  overflow: visible;\n}\n\n.fff-shared-footer-container-mobile.is-not-login\n  .fff-shared-footer-inner-container-link:last-child {\n  padding-left: 0;\n  max-width: 100px;\n  overflow: visible;\n}\n\n.is-not-login .fff-shared-footer-inner-container-link:last-child {\n  padding-right: 0;\n  padding-left: 17px;\n}\n\n.fff-shared-footer-inner-container-link.border-b {\n  border-bottom: 1px solid #eee;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-inner-container-link {\n  padding: 0;\n}\n\n.fff-shared-footer-header-link {\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 700 !important;\n  line-height: 1.5;\n  color: #000000;\n  padding: 0 0 6px 0;\n  background: none;\n  border: none;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-header-link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 55px;\n  box-shadow: inset 0 -1px 0 0 #e8e8e8, inset 0 1px 0 0 #e8e8e8;\n  background-color: #ffffff;\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 14px;\n  line-height: 1.29;\n  color: #4a4a4a;\n  font-weight: 400 !important;\n  text-align: left;\n  padding: 0 20px 0 30px;\n}\n\n.fff-shared-footer-container-mobile.is-not-login\n  .fff-shared-footer-header-link {\n  height: 42px;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-header-link::after {\n  font-family: 'Font Awesome 5 Pro';\n  font-size: 13px;\n  font-weight: 300;\n  color: #4a4a4a;\n  content: '\\f054';\n}\n\n.fff-shared-footer-container-mobile\n  .fff-shared-footer-inner-container-link.is-active\n  .fff-shared-footer-header-link::after {\n  content: '\\f078';\n}\n\n.fff-shared-footer-container-mobile .fff-shared-Footer-linkFooter {\n  box-shadow: inset 0 1px 0 0 #e8e8e8;\n  background-color: #f9f9f9;\n  text-align: left;\n  padding: 0 30px;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-Footer-linkFooter a {\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.29;\n  color: #222222;\n  padding: 15px 0;\n}\n\n.fff-shared-footer-container-mobile\n  .fff-shared-footer-inner-container-link.border-b {\n  border: none;\n  background-color: #f9f9f9;\n}\n\n.bottom-legal-footer-container {\n  background-color: #f7f7f7;\n  padding: 16px 0;\n}\n\n.fff-shared-footer-container-mobile .bottom-legal-footer-container {\n  padding-bottom: 0;\n}\n\n.bottom-legal-footer-container .copyright-text {\n  white-space: normal;\n}\n\n/* Overrides for OneTrust CSS */\n.bottom-legal-footer-container #ot-sdk-btn.ot-sdk-show-settings,\n.bottom-legal-footer-container #ot-sdk-btn.optanon-show-settings {\n  color: inherit;\n  border: inherit;\n  height: inherit;\n  white-space: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  transition: inherit;\n  padding: 0 15px;\n}\n\n.bottom-legal-footer-container #ot-sdk-btn.ot-sdk-show-settings:hover,\n.bottom-legal-footer-container #ot-sdk-btn.optanon-show-settings:hover {\n  color: #fa9c98;\n  text-decoration: none;\n  background-color: inherit;\n}\n\n.fff-shared-footer-container-mobile #ot-sdk-btn.ot-sdk-show-settings,\n.fff-shared-footer-container-mobile #ot-sdk-btn.optanon-show-settings {\n  padding-bottom: 14px;\n  font-size: 10px;\n}\n\n.fff-shared-footer-container .fff-logo {\n  width: 60px;\n  height: 60px;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-top-border {\n  margin-bottom: 12px;\n}\n\n.fff-shared-footer-container-mobile .fff-logo {\n  width: 42px;\n  height: 42px;\n}\n\n.fff-shared-footer-container-mobile.is-not-login\n  .fff-shared-footer-header-link {\n  text-align: center;\n  display: block;\n  color: #4a4a4a;\n}\n\n.fff-shared-footer-container-mobile.is-not-login\n  .fff-shared-footer-header-link::after {\n  content: '';\n}\n\n.fff-shared-footer-container-mobile.is-not-login\n  .fff-shared-footer-header-link {\n  padding: 0 20px 0 20px;\n}\n.fff-shared-footer-container-mobile .fff-logo-container {\n  margin: 0 auto 6px auto;\n}\n\n.fff-logo-container {\n  flex: 0 !important;\n  margin-left: 1px;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1080px) {\n  .fff-shared-footer-container-top {\n    padding-bottom: 19px;\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .fff-shared-footer-container-top-logged {\n    padding-bottom: 0;\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .fff-shared-footer-container .fff-logo {\n    margin-top: 5px;\n  }\n  .is-not-login .fff-shared-footer-top-section-col {\n    margin: 0 auto 40px 34px;\n  }\n  .fff-shared-footer-top-section-col {\n    margin: 0 12px 40px 21px;\n  }\n  .fff-shared-footer-top-section-col-loged {\n    margin: 0 12px 25px 21px;\n    justify-content: space-between;\n  }\n}\n\n@media only screen and (max-width: 1080px) {\n  .fff-shared-footer-inner-container-link:last-child,\n  .fff-shared-footer-container-mobile.is-not-login .fff-shared-footer-inner-container-link:last-child\n  {\n    max-width: unset;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .fff-shared-footer-inner-container-link:last-child {\n    overflow: hidden;\n  }\n  .fff-shared-footer-container-top {\n    flex-direction: column;\n  }\n  .fff-shared-footer-top-section-col {\n    text-align: center;\n    display: block;\n  }\n  .fff-shared-footer-inner-container-link {\n    padding: 16px;\n  }\n\n  .fff-shared-footer-header-link {\n    cursor: pointer;\n    font-weight: 400;\n  }\n}\n";
styleInject(css_248z$9);
var img$7 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg version='1.1' width='65px' height='65px' viewBox='0 0 65.0 65.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cclipPath id='i0'%3e%3cpath d='M32.5%2c0 C50.4492544%2c0 65%2c14.5507456 65%2c32.5 C65%2c50.4492544 50.4492544%2c65 32.5%2c65 C14.5507456%2c65 0%2c50.4492544 0%2c32.5 C0%2c14.5507456 14.5507456%2c0 32.5%2c0 Z'%3e%3c/path%3e%3c/clipPath%3e%3clinearGradient id='i1' x1='0px' y1='32.5px' x2='65px' y2='32.5px' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%232D68FF' offset='0%25'%3e%3c/stop%3e%3cstop stop-color='%23215AEA' offset='25.5035635%25'%3e%3c/stop%3e%3cstop stop-color='%23174CD6' offset='49.8843619%25'%3e%3c/stop%3e%3cstop stop-color='%230A3EC1' offset='74.5787166%25'%3e%3c/stop%3e%3cstop stop-color='%230030AC' offset='100%25'%3e%3c/stop%3e%3c/linearGradient%3e%3cclipPath id='i2'%3e%3cpath d='M4.97619048%2c0 C7.72446459%2c0 9.95238095%2c2.22791636 9.95238095%2c4.97619048 C9.95238095%2c7.72446459 7.72446459%2c9.95238095 4.97619048%2c9.95238095 C2.22791636%2c9.95238095 0%2c7.72446459 0%2c4.97619048 C0%2c2.22791636 2.22791636%2c0 4.97619048%2c0 Z'%3e%3c/path%3e%3c/clipPath%3e%3cclipPath id='i3'%3e%3cpath d='M30.9417882%2c0.0283570137 C31.3801836%2c-0.0583107917 31.8343492%2c0.0559736432 32.1795117%2c0.339812854 C32.5246742%2c0.623652064 32.7245287%2c1.04719132 32.7241696%2c1.4940713 C32.7087186%2c2.24510522 32.1619024%2c2.87926009 31.421312%2c3.00502368 C28.1814608%2c3.5955387 24.9095819%2c3.99432726 21.6227405%2c4.19930939 C20.9767916%2c4.24197993 20.3766839%2c4.547961 19.9627612%2c5.04569457 C19.5488384%2c5.54342815 19.3574001%2c6.18926483 19.4332167%2c6.83216654 L19.7136929%2c9.33835701 C20.1585777%2c13.2539498 21.0698004%2c17.102347 22.4279786%2c20.8016903 L24.2375024%2c25.6421665 C24.3763381%2c26.0162754 24.3586394%2c26.4305364 24.1884016%2c26.7914406 C24.0181637%2c27.1523449 23.7097369%2c27.4294699 23.3327405%2c27.5602618 C23.1683425%2c27.6246053 22.9935615%2c27.6583349 22.8170263%2c27.6597856 C22.2311889%2c27.6490373 21.706538%2c27.2945434 21.4779786%2c26.7550237 L21.0165501%2c25.7688332 C19.568931%2c22.6564523 18.2208358%2c19.5169284 16.9903596%2c16.3231189 C16.8904805%2c16.0653854 16.6424837%2c15.8955238 16.3660739%2c15.8955238 C16.0896641%2c15.8955238 15.8416673%2c16.0653854 15.7417882%2c16.3231189 C14.511312%2c19.5169284 13.1632167%2c22.6745475 11.7155977%2c25.7597856 L11.2722643%2c26.6645475 L11.2153273%2c26.7967682 C10.8814846%2c27.4801953 10.0762478%2c27.8104126 9.3496453%2c27.5376427 C8.57763012%2c27.2478247 8.18673207%2c26.3870389 8.47655006%2c25.6150237 L10.2860739%2c20.7745475 C11.6486909%2c17.0765407 12.5600416%2c13.2276027 13.0003596%2c9.31121416 L13.2898834%2c6.82311892 C13.3683471%2c6.17782981 13.1783744%2c5.52863203 12.7644189%2c5.02743801 C12.3504635%2c4.52624398 11.7488512%2c4.21703518 11.1003596%2c4.17216654 C7.78578952%2c3.96549596 4.48655847%2c3.56064526 1.22035959%2c2.95978559 C0.8307482%2c2.88949163 0.485384459%2c2.66641281 0.261094651%2c2.34017309 C0.0368048427%2c2.01393337 -0.0478095865%2c1.61158939 0.0260738731%2c1.22264273 C0.0940772362%2c0.831850906 0.316638514%2c0.484929175 0.643506671%2c0.260207317 C0.970374828%2c0.0354854591 1.37398815%2c-0.0480878463 1.76321673%2c0.0283570137 C11.4077484%2c1.81074821 21.2972565%2c1.81074821 30.9417882%2c0.0283570137 Z'%3e%3c/path%3e%3c/clipPath%3e%3cclipPath id='i4'%3e%3cpath d='M28.5%2c0 C44.2339132%2c0.0149633132 56.9850367%2c12.7660868 57%2c28.5 C57%2c44.2401154 44.2401154%2c57 28.5%2c57 C12.7598846%2c57 0%2c44.2401154 0%2c28.5 C0%2c12.7598846 12.7598846%2c0 28.5%2c0 Z M28.5%2c2.71428571 C14.2589432%2c2.71428571 2.71428571%2c14.2589432 2.71428571%2c28.5 C2.71428571%2c42.7410568 14.2589432%2c54.2857143 28.5%2c54.2857143 C42.7327917%2c54.2657804 54.2657804%2c42.7327917 54.2857143%2c28.5 C54.2857143%2c14.2589432 42.7410568%2c2.71428571 28.5%2c2.71428571 Z'%3e%3c/path%3e%3c/clipPath%3e%3c/defs%3e%3cg clip-path='url(%23i0)'%3e%3cpolygon points='0%2c0 65%2c0 65%2c65 0%2c65 0%2c0' stroke='none' fill='url(%23i1)'%3e%3c/polygon%3e%3c/g%3e%3cg transform='translate(4.0 4.0)'%3e%3cg transform='translate(21.45995260818634 14.551724073161868) rotate(-44.99999999999999)'%3e%3cg clip-path='url(%23i2)'%3e%3cpolygon points='-1.13686838e-13%2c0 9.95238095%2c0 9.95238095%2c9.95238095 -1.13686838e-13%2c9.95238095 -1.13686838e-13%2c0' stroke='none' fill='white'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3cg transform='translate(12.142973745962639 20.129738224404537)'%3e%3cg clip-path='url(%23i3)'%3e%3cpolygon points='7.25114413e-16%2c-2.77555756e-16 32.7241701%2c-2.77555756e-16 32.7241701%2c27.6597856 7.25114413e-16%2c27.6597856 7.25114413e-16%2c-2.77555756e-16' stroke='none' fill='white'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3cg clip-path='url(%23i4)'%3e%3cpolygon points='0%2c0 57%2c0 57%2c57 0%2c57 0%2c0' stroke='none' fill='white' opacity='85%25'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
var css_248z$8 = ".UserWay-module_userWayContainer__3Xjs- {\n  display: flex;\n  justify-content: center;\n  align-self: center;\n  border-top: 1px solid #e8e8e8;\n}\n\n.UserWay-module_userWayContainer__3Xjs- .UserWay-module_userWayImage__1GNCY {\n  margin: 9px 0 9px 0;\n  height: 48px;\n  width: 48px;\n}\n\n@media screen and (min-width: 768px) {\n  .UserWay-module_userWayContainer__3Xjs- {\n    position: relative;\n    display: flex;\n    margin: 10px 0 0 0;\n    border-top: none;\n    justify-content: center;\n  }\n\n  .UserWay-module_userWayContainer__3Xjs- .UserWay-module_userWayImage__1GNCY{\n    margin: 0;\n    height: 65px;\n    width: 65px;\n  }\n}\n\n@media screen and (min-width: 1080px) {\n  .UserWay-module_userWayContainer__3Xjs- {\n    margin: 0 10px 0 0;\n    justify-content: flex-end;\n  }\n}\n";
var styles = {
  "userWayContainer": "UserWay-module_userWayContainer__3Xjs-",
  "userWayImage": "UserWay-module_userWayImage__1GNCY"
};
styleInject(css_248z$8);

var UserWay = function UserWay() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.userWayContainer
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.userWayImage,
    id: "accessibilityWidget",
    alt: "accessibility",
    src: img$7
  }));
};

var SWAP_ITEM_ID = 'm-0-4';

var filterSwapElement = function filterSwapElement(links) {
  return links.filter(function (link) {
    return link.id !== SWAP_ITEM_ID;
  });
};

var LinkFooter = /*#__PURE__*/function (_Component) {
  _inherits2(LinkFooter, _Component);

  function LinkFooter() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck2(this, LinkFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _possibleConstructorReturn2(this, (_getPrototypeOf3 = _getPrototypeOf2(LinkFooter)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized2(_assertThisInitialized2(_this2)), "state", {
      activeMenuId: 0
    });

    _defineProperty(_assertThisInitialized2(_assertThisInitialized2(_this2)), "handleClickHeader", function (e, category) {
      var buildPath = _this2.props.buildPath;

      if (!category.links && isBrowser()) {
        window.location.replace(buildPath(category.route, category.subdomain, category.prodOnly));
        return;
      }

      var header = e.target.getAttribute('headername');

      _this2.setState(function (_ref4) {
        var activeMenuId = _ref4.activeMenuId;
        return {
          activeMenuId: activeMenuId === header ? 0 : header
        };
      });
    });

    return _this2;
  }

  _createClass2(LinkFooter, [{
    key: "render",
    value: function render() {
      var _userInfo$user;

      var _this$props = this.props,
          categories = _this$props.categories,
          isMobile = _this$props.isMobile,
          isLogin = _this$props.isLogin,
          buildPath = _this$props.buildPath,
          userInfo = _this$props.userInfo,
          subscriptionPlans = _this$props.subscriptionPlans,
          hideSwap = _this$props.hideSwap;
      var activeMenuId = this.state.activeMenuId;
      var handleClickHeader = this.handleClickHeader;
      var linkContainerStyles = classnames({
        'fff-shared-footer-top-section-col': true,
        'fff-shared-footer-top-section-col-loged': isLogin
      });

      var getInnerLinkStyle = function getInnerLinkStyle(header) {
        return classnames({
          'fff-shared-Footer-linkFooter': true,
          'fff-shared-Footer-link-container': isMobile
        });
      };

      var innerContainerLinkStyle = function innerContainerLinkStyle(header) {
        return classnames({
          'border-b': isMobile,
          'fff-shared-footer-inner-container-link': true,
          'fff-shared-footer-inner-container-link-login': isLogin,
          'o-hidden': true,
          'is-active': header === activeMenuId
        });
      };

      var headerLinkStyle = classnames({
        'fff-shared-footer-header-link': true
      });
      var plan = subscriptionPlans && subscriptionPlans[userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.planCode];

      var getInnerContainerLinkStyles = function getInnerContainerLinkStyles(header, links) {
        var linkHeight = isLogin ? 54 : 42;
        return isMobile ? {
          height: header === activeMenuId ? 48 * links.length + 60 : linkHeight
        } : {};
      };

      var clickListener = function clickListener(buildedPath, trakingName, label) {
        if (label === 'Swap for Credit') {
          var _plan$boxPrice;

          var path = "".concat(buildedPath, "?referrer=").concat(ReferrerQueryString.footerLink);
          track({
            trackName: 'Swap Started',
            properties: {
              swap_amount: plan === null || plan === void 0 ? void 0 : (_plan$boxPrice = plan.boxPrice) === null || _plan$boxPrice === void 0 ? void 0 : _plan$boxPrice.amount,
              plan_code: userInfo.planCode,
              cta_name: label,
              experience: 'Footer Link'
            },
            callback: function callback() {
              window.location.href = path;
            }
          });
        } else if (trakingName) {
          trackElement({
            elementName: trakingName,
            callback: function callback() {
              window.location.href = buildedPath;
            }
          });
        }
      };

      return /*#__PURE__*/React.createElement("div", {
        className: linkContainerStyles
      }, isMobile && /*#__PURE__*/React.createElement(UserWay, null), categories.map(function (category) {
        var label = category.label;
        var _category$header = category.header,
            header = _category$header === void 0 ? label : _category$header,
            id = category.id,
            links = category.links;
        var filteredLinks = hideSwap ? filterSwapElement(links) : links;
        return /*#__PURE__*/React.createElement("div", {
          key: id,
          className: innerContainerLinkStyle(header),
          style: getInnerContainerLinkStyles(header, links)
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: headerLinkStyle,
          headername: header,
          onClick: function onClick(e) {
            return handleClickHeader(e, category);
          }
        }, header), /*#__PURE__*/React.createElement("div", {
          id: header.toLowerCase().split(' ').join('-'),
          className: getInnerLinkStyle()
        }, (filteredLinks || []).map(function (_ref5) {
          var id = _ref5.id,
              label = _ref5.label,
              route = _ref5.route,
              subdomain = _ref5.subdomain,
              prodOnly = _ref5.prodOnly,
              trakingName = _ref5.trakingName;
          return /*#__PURE__*/React.createElement("a", {
            key: id,
            className: "fff-shared-footer-links footer-child-link",
            alt: label,
            href: trakingName ? undefined : buildPath(route, subdomain, prodOnly),
            onClick: function onClick() {
              return clickListener(buildPath(route, subdomain, prodOnly), trakingName, label);
            }
          }, label);
        })));
      }));
    }
  }]);

  return LinkFooter;
}(Component);

var css_248z$7 = ".fff-shared-footer-legal {\n  max-width: 1037px;\n  flex-wrap: wrap;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.fff-shared-footer-legal .fff-shared-footer-links {\n  padding: 0 15px;\n  text-decoration: none;\n  line-height: 15px;\n}\n\n.legal-footer-text-only {\n  cursor: default;\n}\n\n.legal-footer-items {\n  align-self: center;\n  padding: 0 12px;\n  text-decoration: none;\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 15px;\n  letter-spacing: normal;\n  text-align: center;\n  color: #222222;\n}\n\n.legal-footer-items:visited {\n  color: #222222;\n}\n\n.legal-footer-items:first-child {\n  padding: 0 12px 0 0;\n}\n\n.legal-footer-items:last-child {\n  padding: 0 0 0 12px;\n  margin: 0 0 0 12px;\n}\n\n.bottom-legal-footer-container {\n  display: flex;\n  justify-content: center;\n  background-color: #e8e8e8;\n  padding: 19px 0 14px 0;\n}\n\n.bottom-legal-footer-container .copyright-text {\n  white-space: normal;\n}\n\n/* Overrides for OneTrust CSS */\n.bottom-legal-footer-container #ot-sdk-btn.ot-sdk-show-settings,\n.bottom-legal-footer-container #ot-sdk-btn.optanon-show-settings {\n  color: inherit;\n  border: inherit;\n  height: inherit;\n  white-space: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  transition: inherit;\n  padding: 0 15px;\n}\n\n.bottom-legal-footer-container #ot-sdk-btn.ot-sdk-show-settings:hover,\n.bottom-legal-footer-container #ot-sdk-btn.optanon-show-settings:hover {\n  color: #222222;\n  text-decoration: none;\n  background-color: inherit;\n}\n\n.fff-shared-Footer-linkFooter .fff-shared-footer-links {\n  color: #4a4a4a;\n  font-size: 14px;\n  font-weight: 400;\n  text-decoration: none;\n  transition: text-decoration 0.2s;\n}\n\n.fff-shared-Footer-linkFooter .fff-shared-footer-links:hover {\n  text-decoration: underline;\n}\n\n.fff-shared-Footer-linkFooter .fff-shared-footer-links:active {\n  color: #fb6a66;\n  text-decoration: underline;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-links {\n  padding-bottom: 14px;\n}\n\n.fff-shared-legal .fff-shared-footer-legal-separator {\n  margin: auto 10px;\n}\n\n.fff-shared-footer-container-mobile #ot-sdk-btn.ot-sdk-show-settings,\n.fff-shared-footer-container-mobile #ot-sdk-btn.optanon-show-settings {\n  padding-bottom: 14px;\n  font-size: 9px !important;\n}\n\n.order-0 {\n  order: 1;\n}\n\n.order-1 {\n  order: 2;\n}\n\n.order-2 {\n  order: 3;\n}\n\n.order-3 {\n  order: 4;\n}\n\n.order-4 {\n  order: 5;\n}\n\n.order-last {\n  order: 6;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1080px) {\n  .fff-shared-footer-legal {\n    max-width: 670px;\n  }\n\n  .bottom-legal-footer-container {\n    display: block;\n    padding: 13px 0 14px 0;\n  }\n\n  .legal-footer-items {\n    line-height: 15px;\n  }\n\n  .tablet-legal-footer {\n    line-height: 15px;\n    margin: 0 auto 9px auto;\n    justify-content: space-between;\n  }\n\n  .tablet-legal-second-line {\n    justify-content: center;\n    margin: 0 auto 0 auto;\n    max-width: 372px;\n  }\n}\n\n@media (max-width: 767px) {\n  .fff-shared-footer-legal {\n    flex-direction: column;\n  }\n\n  .fff-shared-footer-container-mobile .bottom-legal-footer-container {\n    padding: 15px 0 22px 0;\n  }\n\n  .legal-footer-items {\n    padding: 0 0 12px 0;\n    font-size: 9px;\n    line-height: 12px;\n    color: #000;\n  }\n\n  .legal-footer-items:first-child {\n    padding: 0 0 12px 0;\n  }\n\n  .legal-footer-items:last-child {\n    margin: 0;\n    padding: 0 0 21px 0;\n  }\n\n  .order-0 {\n    order: 1;\n  }\n\n  .order-1 {\n    order: 5;\n  }\n\n  .order-2 {\n    order: 2;\n  }\n\n  .order-3 {\n    order: 3;\n  }\n\n  .order-4 {\n    order: 4;\n  }\n\n  .order-last {\n    order: 6;\n  }\n}\n";
styleInject(css_248z$7);
var footerContentKey = 'footer-content';
var cacheDurationInMs$3 = 15 * 60 * 1000; //15 minutes

var useFooterContent = function useFooterContent() {
  var _useState5 = useState(storage.getFromStorage({
    key: footerContentKey
  })),
      _useState6 = _slicedToArray2(_useState5, 2),
      footerContent = _useState6[0],
      setFooterContent = _useState6[1];

  useEffect(function () {
    var footerCache = storage.getFromStorage({
      key: footerContentKey
    });

    if (footerCache) {
      if (!compare.isEqualObject(footerContent, footerCache)) {
        setFooterContent(footerCache);
      }
    } else {
      getFooterContent().then(function (content) {
        setFooterContent(content);
        storage.setToStorage({
          key: footerContentKey,
          value: content,
          durationInMs: cacheDurationInMs$3
        });
      });
    }
  }, [footerContent]);
  return {
    footerContent: footerContent,
    defaultYear: new Date().getFullYear().toString()
  };
};

var LEGAL_ID = 'l-0';

var LegalFooter = function LegalFooter(props) {
  var _useFooterContent2 = useFooterContent(),
      defaultYear = _useFooterContent2.defaultYear;

  var legals = props.legals,
      buildPath = props.buildPath,
      shippingState = props.shippingState,
      isLogin = props.isLogin,
      isTablet = props.isTablet;
  var footerLinkStyles = classnames({
    pointer: legals.find(function (x) {
      return x.id !== LEGAL_ID;
    })
  });
  var footerStyles = classnames({
    'tablet-legal-second-line': isTablet
  });
  var tabletStyles = classnames({
    'tablet-legal-footer': isTablet
  });

  var clickListener = function clickListener(buildedPath, trakingName) {
    if (trakingName) {
      trackElement({
        elementName: trakingName,
        callback: function callback() {
          return window.location.replace(buildedPath);
        }
      });
    }
  };

  var aTag = function aTag(legal, index) {
    return legal.route ? /*#__PURE__*/React.createElement("a", {
      className: "legal-footer-items order-".concat(index, " ").concat(footerLinkStyles),
      alt: legal.label ? legal.label.replace('defaultYear', defaultYear) : '',
      key: legal.id,
      href: legal.trakingName ? undefined : buildPath(legal.route, legal.subdomain, legal.prodOnly),
      onClick: function onClick() {
        return clickListener(buildPath(legal.route, legal.subdomain, legal.prodOnly), legal.trakingName);
      }
    }, legal.label ? legal.label.replace('defaultYear', defaultYear) : '', /*#__PURE__*/React.createElement("span", {
      className: "fff-shared-footer-legal-separator"
    }, legal.separator)) : /*#__PURE__*/React.createElement("div", {
      key: legal.id,
      className: "legal-footer-items order-".concat(index, " legal-footer-text-only")
    }, legal.label ? legal.label.replace('defaultYear', defaultYear) : '');
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "bottom-legal-footer-container"
  }, isTablet && /*#__PURE__*/React.createElement("div", {
    id: "first",
    className: "fff-shared-footer-legal ".concat(tabletStyles)
  }, legals.filter(function (link) {
    return link.group === 1;
  }).map(function (legal, index) {
    return aTag(legal, index);
  })), /*#__PURE__*/React.createElement("div", {
    id: "second",
    className: "fff-shared-footer-legal ".concat(footerStyles)
  }, legals.filter(function (link) {
    return isTablet && link.group === 2 || !isTablet;
  }).map(function (legal, index) {
    return aTag(legal, index);
  }), (shippingState === 'CA' || !isLogin) &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  React.createElement("a", {
    id: "ot-sdk-btn",
    className: "ot-sdk-show-settings legal-footer-items order-last ".concat(footerLinkStyles)
  }, "Do Not Sell My Personal Information")));
};

var css_248z$6 = ".fff-shared-footer-sm-icons {\n  width: 42px;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n  margin: 0px 2px 0px 2px;\n}\n.fff-shared-footer-sm-icons:hover {\n  opacity: 1;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-sm-container {\n  padding: 6px 16px;\n  box-shadow: inset 0 1px 0 0 #e8e8e8;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-sm-container .d-block {\n  height: 42px;\n  width: 100%;\n  padding: 0 20px;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  transform: translate(9px, 1px) !important;\n}\n\n.fff-shared-footer-container-mobile .fff-shared-footer-sm-container .d-block a {\n  margin: 0 3px;\n}\n\n.fff-shared-footer-container-mobile\n  .fff-shared-footer-sm-container\n  .d-block\n  a:nth-child(4) {\n  transform: translateX(2px);\n}\n.fff-shared-footer-sm-container.fff-shared-footer-top-section-col {\n  margin: 0;\n  align-items: flex-end;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.is-not-login .fff-shared-footer-sm-container .d-block {\n  transform: translate(18px, -7px);\n}\n.fff-shared-footer-sm-container .d-block {\n  transform: translate(17px, -14px);\n}\n.fff-shared-footer-sm-container .d-block a {\n  margin-right: 6px;\n}\n\n.fff-shared-footer-sm-container .d-block a:nth-child(4) {\n  margin: 0 10px 0 -5px;\n}\n\n.d-block i {\n  transform: translate(-11px, -11px);\n  color: #d19ae0;\n  font-size: 27px;\n}\n\n.fff-shared-footer-container-mobile .d-block i {\n  transform: translate(-9px, 6px);\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1080px) {\n  .fff-shared-footer-sm-container.fff-shared-footer-top-section-col {\n    margin: 0 auto;\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: center;\n    margin-bottom: 20px;\n  }\n  .fff-shared-footer-sm-icons {\n    margin: 0 5px 0 5px;\n  }\n  .fff-shared-footer-top-section-col-logout {\n    margin: -32px auto 20px auto;\n    margin-bottom: unset;\n  }\n}\n\n@media (max-width: 767px) {\n  .fff-shared-footer-sm-container.fff-shared-footer-top-section-col {\n    flex-direction: row;\n    justify-content: center;\n  }\n  .fff-shared-footer-sm-icons {\n    margin: 0 5px 0 5px;\n  }\n}\n";
styleInject(css_248z$6);
var img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='42px' height='42px' viewBox='0 0 42 42' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'%3e %3cg id='Artboard' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Group'%3e %3crect id='Rectangle' fill-opacity='0' fill='white' x='0' y='0' width='42' height='42'%3e%3c/rect%3e %3cg id='instagram' transform='translate(9.000000%2c 10.000000)' fill='%23D19AE0' fill-rule='nonzero'%3e %3cpath d='M11.4155896%2c5.60309048 C8.17690778%2c5.60309048 5.5645748%2c8.23591431 5.5645748%2c11.5 C5.5645748%2c14.7640857 8.17690778%2c17.3969095 11.4155896%2c17.3969095 C14.6542714%2c17.3969095 17.2666044%2c14.7640857 17.2666044%2c11.5 C17.2666044%2c8.23591431 14.6542714%2c5.60309048 11.4155896%2c5.60309048 Z M11.4155896%2c15.333761 C9.32266786%2c15.333761 7.61166614%2c13.6144706 7.61166614%2c11.5 C7.61166614%2c9.3855294 9.3175756%2c7.66623898 11.4155896%2c7.66623898 C13.5136036%2c7.66623898 15.2195131%2c9.3855294 15.2195131%2c11.5 C15.2195131%2c13.6144706 13.5085114%2c15.333761 11.4155896%2c15.333761 L11.4155896%2c15.333761 Z M18.8706685%2c5.3618766 C18.8706685%2c6.12657592 18.2595965%2c6.73730894 17.505941%2c6.73730894 C16.7471932%2c6.73730894 16.1412134%2c6.12144371 16.1412134%2c5.3618766 C16.1412134%2c4.60230949 16.7522855%2c3.98644427 17.505941%2c3.98644427 C18.2595965%2c3.98644427 18.8706685%2c4.60230949 18.8706685%2c5.3618766 Z M22.7458838%2c6.75783778 C22.6593152%2c4.91537432 22.2417493%2c3.28333147 20.9024831%2c1.9386924 C19.5683091%2c0.59405333 17.9489682%2c0.173212094 16.1208443%2c0.0808323106 C14.2367055%2c-0.0269441035 8.58938141%2c-0.0269441035 6.70524261%2c0.0808323106 C4.88221101%2c0.168079884 3.2628701%2c0.58892112 1.92360387%2c1.93356019 C0.584337642%2c3.27819926 0.171864012%2c4.91024211 0.0802032057%2c6.75270557 C-0.0267344019%2c8.65162334 -0.0267344019%2c14.3432444 0.0802032057%2c16.2421622 C0.166771745%2c18.0846257 0.584337642%2c19.7166685 1.92360387%2c21.0613076 C3.2628701%2c22.4059467 4.87711875%2c22.8267879 6.70524261%2c22.9191677 C8.58938141%2c23.0269441 14.2367055%2c23.0269441 16.1208443%2c22.9191677 C17.9489682%2c22.8319201 19.5683091%2c22.4110789 20.9024831%2c21.0613076 C22.236657%2c19.7166685 22.6542229%2c18.0846257 22.7458838%2c16.2421622 C22.8528214%2c14.3432444 22.8528214%2c8.65675555 22.7458838%2c6.75783778 Z M20.3117801%2c18.2796497 C19.9145833%2c19.2855629 19.145651%2c20.0605266 18.1424744%2c20.4659712 C16.6402556%2c21.0664398 13.0756687%2c20.9278701 11.4155896%2c20.9278701 C9.75551056%2c20.9278701 6.18583137%2c21.0613076 4.68870487%2c20.4659712 C3.69062053%2c20.0656588 2.92168821%2c19.2906951 2.51939911%2c18.2796497 C1.92360387%2c16.7656477 2.06109508%2c13.1731005 2.06109508%2c11.5 C2.06109508%2c9.82689948 1.92869614%2c6.22922013 2.51939911%2c4.72035033 C2.91659594%2c3.71443713 3.68552826%2c2.93947339 4.68870487%2c2.53402879 C6.19092364%2c1.93356019 9.75551056%2c2.07212987 11.4155896%2c2.07212987 C13.0756687%2c2.07212987 16.6453479%2c1.9386924 18.1424744%2c2.53402879 C19.1405587%2c2.93434118 19.909491%2c3.70930492 20.3117801%2c4.72035033 C20.9075754%2c6.23435234 20.7700841%2c9.82689948 20.7700841%2c11.5 C20.7700841%2c13.1731005 20.9075754%2c16.7707799 20.3117801%2c18.2796497 Z' id='Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 21.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:url(%23SVGID_1_)%3b%7d%3c/style%3e%3clinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='-55.676' y1='19.9' x2='132.5773' y2='19.9' gradientTransform='matrix(1 0 0 -1 0 40)'%3e %3cstop offset='0' style='stop-color:%23C47DD9'/%3e %3cstop offset='1' style='stop-color:%23FDBCD4'/%3e%3c/linearGradient%3e%3cpath class='st0' d='M21.3%2c14.1c0-0.6%2c0.4-0.8%2c0.9-0.8c0.6%2c0%2c1.3%2c0%2c1.9%2c0c0.2%2c0%2c0.4%2c0%2c0.6%2c0c0.2-1.3%2c0.3-2.6%2c0.5-3.9 c-0.2%2c0-0.4-0.1-0.6-0.1c-0.9-0.1-1.9-0.1-2.8-0.1c-0.9%2c0-1.8%2c0-2.7%2c0.1c-1%2c0.1-1.7%2c0.6-2.2%2c1.4c-0.4%2c0.6-0.6%2c1.3-0.6%2c2 c0%2c1.1%2c0%2c2.2%2c0%2c3.2c0%2c0.1%2c0%2c0.2-0.2%2c0.1c-0.7%2c0-1.4%2c0-2%2c0H14c0%2c1.3%2c0%2c2.6%2c0.1%2c4c0.8%2c0%2c1.5%2c0%2c2.3%2c0c0%2c3.7%2c0%2c7.4%2c0%2c11c1.7%2c0%2c3.4%2c0%2c5%2c0 c0-3.7%2c0-7.4%2c0-11c1.2%2c0%2c2.3%2c0%2c3.5%2c0c0-1.4%2c0-2.7%2c0-4.1c-1.2%2c0-2.3%2c0-3.5%2c0C21.3%2c15.4%2c21.3%2c14.8%2c21.3%2c14.1z'/%3e%3c/svg%3e";
var img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 21.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:url(%23SVGID_1_)%3b%7d%3c/style%3e%3clinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='-158.676' y1='19.9797' x2='29.5773' y2='19.9797' gradientTransform='matrix(1 0 0 -1 0 40)'%3e %3cstop offset='0' style='stop-color:%23C47DD9'/%3e %3cstop offset='1' style='stop-color:%23FDBCD4'/%3e%3c/linearGradient%3e%3cpath class='st0' d='M29.4%2c14.5c-0.4-1.8-1.3-3.2-2.9-4.3c-1.2-0.9-2.6-1.4-4.1-1.6c-1.9-0.3-3.9-0.2-5.7%2c0.5c-2%2c0.8-3.5%2c2-4.6%2c3.8 s-1.3%2c3.8-0.9%2c5.9c0.3%2c1.6%2c1.3%2c2.6%2c2.9%2c3c0.1%2c0%2c0.2%2c0%2c0.3-0.1c0.4-0.7%2c0.5-1.5%2c0.1-2.2c-0.2-0.4-0.5-0.8-0.6-1.2 c-0.4-1.5-0.2-3%2c0.7-4.4c0.8-1.3%2c1.8-2.2%2c3.2-2.8c2.2-0.9%2c4.3-1%2c6.3%2c0.3c0.9%2c0.6%2c1.5%2c1.4%2c1.9%2c2.5c0.3%2c1.2%2c0.4%2c2.4%2c0.2%2c3.6 c-0.2%2c1.5-0.7%2c2.9-1.6%2c4c-0.8%2c1-1.8%2c1.5-3.1%2c1.3c-1.2-0.2-1.8-0.8-1.7-2c0-0.7%2c0.2-1.4%2c0.4-2.1c0.3-1%2c0.7-2.1%2c0.8-3.2 c0.1-0.5%2c0-1-0.3-1.4c-0.7-1-2.3-1-3.2-0.1c-0.4%2c0.4-0.7%2c0.9-0.9%2c1.5c-0.4%2c1.2-0.4%2c2.3%2c0.1%2c3.5c0.1%2c0.1%2c0.1%2c0.3%2c0%2c0.4 c-0.4%2c1.6-0.8%2c3.2-1.2%2c4.9c-0.4%2c1.8-0.7%2c3.5-0.7%2c5.4c0%2c0.6%2c0.1%2c1.2%2c0.1%2c1.9c0.1-0.1%2c0.1-0.1%2c0.2-0.1c0.7-0.5%2c1.2-1.1%2c1.6-1.8 c0.7-1.2%2c1.1-2.5%2c1.5-3.9c0.2-0.7%2c0.3-1.3%2c0.5-2c0.3%2c0.2%2c0.5%2c0.3%2c0.8%2c0.5c0.7%2c0.4%2c1.3%2c0.8%2c2.1%2c0.9c2.1%2c0.2%2c3.9-0.4%2c5.4-1.8 c1.1-1.1%2c1.8-2.3%2c2.2-3.7C29.6%2c17.9%2c29.7%2c16.2%2c29.4%2c14.5z'/%3e%3c/svg%3e";
var img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 21.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:url(%23SVGID_1_)%3b%7d%3c/style%3e%3clinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='-85.676' y1='20.1206' x2='102.5773' y2='20.1206' gradientTransform='matrix(1 0 0 -1 0 40)'%3e %3cstop offset='0' style='stop-color:%23C47DD9'/%3e %3cstop offset='1' style='stop-color:%23FDBCD4'/%3e%3c/linearGradient%3e%3cpath class='st0' d='M27%2c21.6c-0.4-0.8-0.2-1.5%2c0.7-1.9c0.3-0.2%2c0.7-0.3%2c1.1-0.4c0.3-0.1%2c0.7-0.3%2c1-0.4c0.4-0.3%2c0.4-0.6-0.1-0.7 c-0.3-0.1-0.6-0.1-0.9%2c0c-0.6%2c0.2-1.1%2c0.4-1.7%2c0.2c-0.3-0.1-0.5-0.3-0.5-0.6c0.1-1%2c0.1-1.9%2c0.1-2.9c0.1-1.8-0.6-3.3-2-4.5 c-2.2-1.8-5.8-2.1-8.3-0.7c-1.7%2c0.9-2.9%2c2.3-3%2c4.2c-0.1%2c1.2%2c0%2c2.5%2c0.1%2c3.7c0%2c0.6-0.1%2c0.7-0.7%2c0.8c-0.6%2c0.1-1.1%2c0-1.7-0.2 c-0.3-0.1-0.6-0.1-0.9%2c0c-0.3%2c0.2-0.4%2c0.4-0.1%2c0.6s0.7%2c0.4%2c1.1%2c0.5s0.7%2c0.2%2c1.1%2c0.4c0.8%2c0.4%2c1.1%2c1%2c0.7%2c1.8c-0.7%2c1.6-1.9%2c3-3.5%2c3.9 c-0.7%2c0.4-1.4%2c0.6-2.2%2c0.9c0.2%2c0.1%2c0.4%2c0.3%2c0.6%2c0.4c0.7%2c0.2%2c1.4%2c0.4%2c2.2%2c0.5c0.5%2c0.1%2c0.8%2c0.3%2c0.9%2c0.7c0%2c0.2%2c0.1%2c0.5%2c0.2%2c0.7 c0%2c0.1%2c0.2%2c0.2%2c0.3%2c0.2c0.3%2c0%2c0.5-0.1%2c0.8-0.1c1.4-0.2%2c2.8-0.1%2c3.9%2c0.8c0.3%2c0.2%2c0.7%2c0.4%2c1%2c0.6c1.8%2c1.1%2c3.6%2c1.1%2c5.5%2c0.1 c0.4-0.2%2c0.8-0.5%2c1.2-0.7c0.9-0.6%2c1.9-0.9%2c3-0.8c0.5%2c0%2c0.9%2c0.1%2c1.4%2c0.1c0.6%2c0.1%2c0.6%2c0.2%2c0.7-0.4c0-0.2%2c0.1-0.3%2c0.1-0.5 c0.1-0.3%2c0.3-0.5%2c0.7-0.6c0.8-0.1%2c1.5-0.3%2c2.2-0.5c0.2-0.1%2c0.4-0.3%2c0.7-0.4C29.9%2c25.6%2c28.1%2c23.9%2c27%2c21.6z'/%3e%3c/svg%3e";
var img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 21.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:url(%23SVGID_1_)%3b%7d%3c/style%3e%3clinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='-25.076' y1='20' x2='163.1773' y2='20' gradientTransform='matrix(1 0 0 -1 0 40)'%3e %3cstop offset='0' style='stop-color:%23C47DD9'/%3e %3cstop offset='1' style='stop-color:%23FDBCD4'/%3e%3c/linearGradient%3e%3cpath class='st0' d='M32.1%2c10.3c-0.1%2c0.1-0.2%2c0.1-0.3%2c0.1c-0.9%2c0.5-1.8%2c0.8-2.7%2c1c-0.2%2c0.1-0.4%2c0-0.6-0.1c-1.1-1-2.4-1.5-3.9-1.4 c-1.7%2c0.1-3.1%2c0.8-4%2c2.2c-0.7%2c0.9-1%2c2-0.9%2c3.1c0%2c0.3%2c0.1%2c0.6%2c0.1%2c0.9c-4.4-0.3-8-2.1-10.8-5.3c-0.5%2c0.9-0.8%2c1.9-0.7%2c3.1 c0.2%2c1.5%2c0.9%2c2.7%2c2.2%2c3.7c-0.8%2c0-1.6-0.2-2.3-0.6c-0.1%2c1.6%2c1%2c4.3%2c4.1%2c5.1c-0.4%2c0.1-0.7%2c0.1-1.1%2c0.1s-0.8%2c0-1.2%2c0 c0.9%2c2.2%2c2.5%2c3.3%2c4.9%2c3.5c-2.3%2c1.7-4.8%2c2.3-7.7%2c2.1c0.1%2c0%2c0.1%2c0.1%2c0.1%2c0.1c1.8%2c1.1%2c3.8%2c1.8%2c6%2c2.1c1.9%2c0.2%2c3.7%2c0.1%2c5.5-0.3 c2-0.4%2c3.8-1.3%2c5.5-2.5c1.8-1.3%2c3.2-3%2c4.2-5c1.2-2.2%2c1.7-4.6%2c1.7-7.1c0-0.1%2c0-0.2%2c0.2-0.3c0.7-0.5%2c1.3-1.1%2c1.8-1.7 c0.1-0.1%2c0.2-0.2%2c0.3-0.4c0.1-0.1%2c0.2-0.2%2c0.3-0.4c-0.9%2c0.3-1.9%2c0.6-2.8%2c0.7C30.9%2c12.4%2c31.7%2c11.5%2c32.1%2c10.3z'/%3e%3c/svg%3e";
var img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 21.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 40' style='enable-background:new 0 0 40 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill:none%3b%7d .st1%7bfill:url(%23SVGID_1_)%3b%7d%3c/style%3e%3cg%3e %3cpath class='st0' d='M16%2c24.6c3.2-1.6%2c6.3-3.2%2c9.6-4.9c-3.2-1.7-6.4-3.3-9.6-4.9C16%2c18.1%2c16%2c21.3%2c16%2c24.6z'/%3e %3clinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='-122.976' y1='20' x2='65.2773' y2='20' gradientTransform='matrix(1 0 0 -1 0 40)'%3e %3cstop offset='0' style='stop-color:%23C47DD9'/%3e %3cstop offset='1' style='stop-color:%23FDBCD4'/%3e %3c/linearGradient%3e %3cpath class='st1' d='M34.8%2c15.9c-0.1-1-0.2-2-0.4-3C34%2c11.3%2c32.7%2c10.2%2c31%2c10c-2.3-0.2-4.5-0.3-6.8-0.3c-2.7%2c0-5.4-0.1-8.1%2c0 c-2%2c0-4%2c0.2-6%2c0.3c-0.6%2c0-1.2%2c0.1-1.7%2c0.2c-1.4%2c0.3-2.3%2c1.1-2.8%2c2.4c-0.4%2c1-0.5%2c2-0.5%2c3c0%2c0.6-0.1%2c1.2-0.1%2c1.8c0%2c0.1%2c0%2c0.2%2c0%2c0.2 c0%2c1.6%2c0%2c3.2%2c0%2c4.8c0%2c0.5%2c0%2c0.9%2c0.1%2c1.4c0.1%2c1%2c0.2%2c2.1%2c0.4%2c3.1C5.8%2c28.6%2c7.2%2c29.8%2c9%2c30c2.3%2c0.2%2c4.5%2c0.3%2c6.8%2c0.3 c2.7%2c0%2c5.4%2c0.1%2c8.1%2c0c2.1%2c0%2c4.2-0.2%2c6.2-0.3c0.5%2c0%2c1-0.1%2c1.5-0.2c1.4-0.3%2c2.3-1.1%2c2.8-2.4c0.4-1%2c0.4-2%2c0.5-3 c0.1-0.6%2c0.1-1.2%2c0.1-1.8c0-0.1%2c0-0.2%2c0-0.3c0-1.6%2c0-3.2%2c0-4.9C34.8%2c17%2c34.8%2c16.4%2c34.8%2c15.9z M16%2c24.6c0-3.3%2c0-6.5%2c0-9.8 c3.2%2c1.6%2c6.3%2c3.3%2c9.6%2c4.9C22.3%2c21.3%2c19.1%2c22.9%2c16%2c24.6z'/%3e%3c/g%3e%3c/svg%3e";
var iconImages = {
  InstagramIcon: img$6,
  FacebookIcon: img$5,
  PinterestIcon: img$4,
  SnapchatIcon: img$3,
  TwitterIcon: img$2,
  YoutubeIcon: img$1
};

var SMFooter = function SMFooter(_ref6) {
  var socialMedias = _ref6.socialMedias,
      isTablet = _ref6.isTablet,
      isMobile = _ref6.isMobile,
      isLogin = _ref6.isLogin;
  // eslint-disable-next-line react/destructuring-assignment
  var icons = socialMedias.icons;
  var getTabletStyles = classnames({
    'fff-shared-footer-top-section-col-logout': isTablet && isLogin
  });

  var mappedIcons = function mappedIcons() {
    return icons.map(function (_ref7) {
      var id = _ref7.id,
          route = _ref7.route,
          img = _ref7.img,
          icon = _ref7.icon;
      return /*#__PURE__*/React.createElement("a", {
        key: id,
        href: route
      }, icon || /*#__PURE__*/React.createElement("img", {
        src: iconImages[img],
        className: "fff-shared-footer-sm-icons",
        alt: "social"
      }));
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "fff-shared-footer-sm-container fff-shared-footer-top-section-col ".concat(getTabletStyles)
  }, isTablet ? mappedIcons() : /*#__PURE__*/React.createElement("div", null, mappedIcons(), !isMobile && /*#__PURE__*/React.createElement(UserWay, null)));
};

var img = "data:image/png;base64,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";

var validateEmail = function validateEmail(email) {
  /* eslint-disable-next-line no-useless-escape */
  var regex = /^([a-zA-Z0-9_.-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
};

var css_248z$5 = ".email-capture-container {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  max-width: 478px;\n}\n.footer-title {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: normal;\n  margin-bottom: 18px;\n  box-sizing: border-box;\n}\n.footer-title__email {\n  font-family: 'Nunito Sans', sans-serif;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 18px;\n  line-height: 24px;\n  color: #000;\n  box-sizing: border-box;\n  margin-bottom: 5px;\n}\n.fff-shared-footer-container-mobile .footer-title__email {\n  margin-bottom: 0;\n}\n.footer-title__social {\n  text-align: center;\n  box-sizing: border-box;\n}\n.email-sub__container {\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n}\n.email-sub__form {\n  display: flex;\n  margin-left: 102px;\n  box-sizing: border-box;\n}\n.email-sub__input {\n  height: 48px;\n  width: 100%;\n  max-width: 305px;\n  box-sizing: border-box;\n}\n.email-sub__input input {\n  border-top: 1px solid #d0d0d0;\n  border-left: 1px solid #d0d0d0;\n  border-bottom: 1px solid #d0d0d0;\n  border-radius: 6px 0 0 6px;\n  border-right: none;\n  box-sizing: border-box;\n}\n.email-sub__input input::placeholder {\n  opacity: 0.4;\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 14px;\n  letter-spacing: normal;\n  color: #000000;\n  box-sizing: border-box;\n}\n.email-sub__input__error input {\n  border-top: 1px solid #ff0000;\n  border-left: 1px solid #ff0000;\n  border-bottom: 1px solid #ff0000;\n}\n#email-sub__label {\n  display: block;\n  margin-bottom: 0;\n  box-sizing: border-box;\n}\n#email-sub,\n#email-sub-choice {\n  width: 100%;\n  height: 48px;\n  padding: 11px;\n  box-sizing: border-box;\n}\n.fff-shared-footer-container-mobile #email-sub {\n  padding: 15px;\n}\n.email-sub__img {\n  display: inline-block;\n  height: 60px;\n  width: 60px;\n  margin-right: 42px;\n  box-sizing: border-box;\n}\n.email-sub__desc {\n  margin: 0 0 10px 0;\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 18px;\n  letter-spacing: normal;\n  white-space: normal;\n}\n.email-sub__text {\n  display: inline-block;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.email-capture-choice .jsEmailSub {\n  max-width: 500px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n.email-capture-choice {\n  text-align: center;\n  box-sizing: border-box;\n}\n.email-capture-choice .email-sub__input {\n  max-width: 420px;\n  box-sizing: border-box;\n}\n.email-capture-choice .email-sub__disclaimer {\n  margin: 10px auto;\n  box-sizing: border-box;\n}\n.email-sub__text-choice {\n  margin: 0 auto;\n  max-width: 390px;\n  box-sizing: border-box;\n}\n.email-submit {\n  width: 48px;\n  height: 48px;\n  font-size: 15px;\n  border: solid 1px #fb6a66;\n  color: #fb6a66;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  box-sizing: border-box;\n  min-width: 48px;\n  cursor: pointer;\n}\n.email-submit img {\n  font-size: 18px;\n  width: unset;\n}\n.email-submit-choice {\n  background-color: #fb6a66;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n  width: auto;\n  padding: 10px 20px;\n  box-sizing: border-box;\n}\n.email-sub__confirmation-cntnr {\n  padding: 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  box-sizing: border-box;\n  margin-left: 102px;\n  min-height: 48px;\n}\n.email-sub__confirmation-cntnr .email-sub__icon {\n  font-size: 18px;\n  color: #9dd321;\n  margin-right: 6px;\n  box-sizing: border-box;\n  transform: unset;\n}\n.email-sub__confirmation {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: normal;\n  margin: 0;\n  box-sizing: border-box;\n}\n.email-sub__error {\n  color: #fb6a66;\n  font-size: 12px;\n  line-height: 15px;\n  margin: 7px 0 0 0;\n  box-sizing: border-box;\n}\n.email-sub__disclaimer {\n  font-family: 'Nunito Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 15px;\n  letter-spacing: normal;\n  white-space: break-spaces;\n  max-width: 359px;\n  margin: 13px 0 10px 102px;\n  color: black;\n  box-sizing: border-box;\n}\n.email-sub__disclaimer__error {\n  margin: 24px 0 10px 102px;\n  padding-top: 9px;\n  box-sizing: border-box;\n}\n.term-condition {\n  color: #000;\n  font-weight: bold;\n  box-sizing: border-box;\n  text-decoration: none;\n}\n.about-menu,\n.support-menu {\n  display: block;\n  box-sizing: border-box;\n}\n.no-dots {\n  list-style-type: none;\n  padding: 0;\n  box-sizing: border-box;\n}\n.no-dots li {\n  opacity: 0.6;\n  font-size: 14px;\n  line-height: 1.71;\n  letter-spacing: normal;\n  box-sizing: border-box;\n}\n.copyright-footer {\n  display: table;\n  height: 48px;\n  padding: 12px 0;\n  text-align: center;\n  background-color: #e8e8e8;\n  box-sizing: border-box;\n}\n.copyright-footer__list {\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n.copyright-footer__list li {\n  font-size: 12px;\n  display: inline;\n  margin: 0 15px;\n  box-sizing: border-box;\n}\n#ot-sdk-btn.ot-sdk-show-settings {\n  font-size: 12px !important;\n  color: #222222 !important;\n  border: none !important;\n  background: 0 0 !important;\n  padding: 0 !important;\n  text-align: left !important;\n  box-sizing: border-box;\n}\n#ot-sdk-btn.ot-sdk-show-settings:hover {\n  box-sizing: border-box;\n}\n@media (max-width: 767px) {\n  .email-capture-container {\n    width: 100%;\n    max-width: 100%;\n    float: none;\n    justify-content: center;\n  }\n  .footer-title {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.29;\n    padding: 15px;\n    margin-bottom: 0;\n    text-align: center;\n  }\n  .footer-title__social {\n    font-size: 16px;\n  }\n  .email-sub__container {\n    display: block;\n  }\n  .email-sub__form {\n    justify-content: center;\n    max-width: 380px;\n    margin: 0 auto 19px auto;\n  }\n  .email-sub__img {\n    height: unset;\n    display: block;\n    margin: 0 auto 7px auto;\n    text-align: center;\n  }\n  .email-sub__text {\n    max-width: 275px;\n    margin: 0 auto;\n    display: block;\n    text-align: center;\n  }\n  .email-sub__desc {\n    font-size: 16px;\n    line-height: 24px;\n  }\n  .email-sub__confirmation-cntnr {\n    justify-content: center;\n    padding: 16px 10px;\n    max-width: 280px;\n    margin: 0 auto 16px;\n    min-height: unset;\n  }\n  .email-sub__confirmation {\n    text-align: center;\n  }\n  .email-sub__disclaimer {\n    text-align: center;\n    margin: 0 auto 17px auto;\n  }\n  .mobile-tab {\n    border-bottom: 1px solid #e8e8e8;\n  }\n  .about-menu,\n  .support-menu {\n    display: none;\n  }\n  .no-dots li {\n    font-size: 12px;\n    text-align: center;\n  }\n  .about-menu li,\n  .support-menu li {\n    font-size: 14px;\n    opacity: 1;\n    margin: 15px 0;\n  }\n  .social-media__container {\n    padding-top: 9px;\n  }\n  #menu-social-icons {\n    padding: 5px 0;\n  }\n  #menu-social-icons li {\n    padding: 0 15px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1080px) {\n  .email-sub__desc {\n    margin: 0 0 13px 0;\n    max-width: 275px;\n  }\n  .email-sub__disclaimer {\n    max-width: 258px;\n  }\n}\n\n@media only screen and (max-width: 1076px) {\n  .email-sub__desc {\n    white-space: break-spaces;\n  }\n}\n";
styleInject(css_248z$5);

var EmailCapture = function EmailCapture(_ref8) {
  var isMobile = _ref8.isMobile,
      isTablet = _ref8.isTablet;

  var _useState7 = useState(''),
      _useState8 = _slicedToArray2(_useState7, 2),
      email = _useState8[0],
      setEmail = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray2(_useState9, 2),
      error = _useState10[0],
      setError = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray2(_useState11, 2),
      submitted = _useState12[0],
      setSubmitted = _useState12[1];

  var _onChange = function onChange(value) {
    setEmail(value);
  };

  var submitForm = function submitForm(e) {
    e.preventDefault();
    var isValid = validate();

    if (isValid) {
      setSubmitted(true);
      sendEmailToIterable(email);
    }
  };

  var validate = function validate() {
    if (email !== '' && validateEmail(email)) {
      setError(false);
      return true;
    }

    setError(true);
    return false;
  };

  var errorStyle = classnames({
    'email-sub__disclaimer__error': error
  });
  var inputErrorStyle = classnames({
    'email-sub__input__error': error
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "email-capture-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "email-sub__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "email-sub__img"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "logo",
    src: img,
    className: "fff-logo"
  }), !isMobile && isTablet && /*#__PURE__*/React.createElement(UserWay, null)), /*#__PURE__*/React.createElement("div", {
    className: "email-sub__text"
  }, /*#__PURE__*/React.createElement("header", {
    className: "footer-title__email"
  }, "Our Emails are Pretty Awesome"), /*#__PURE__*/React.createElement("p", {
    className: "email-sub__desc"
  }, "Be the first to know about offers, launches, and products."))), /*#__PURE__*/React.createElement("div", {
    id: "jsEmailSub",
    className: "jsEmailSub"
  }, !submitted ? /*#__PURE__*/React.createElement("form", {
    className: "email-sub__form",
    onSubmit: submitForm
  }, /*#__PURE__*/React.createElement("div", {
    className: "email-sub__input emailSubInput"
  }, /*#__PURE__*/React.createElement("label", {
    id: "email-sub__label",
    htmlFor: "email-sub",
    className: inputErrorStyle
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "email-sub",
    className: "email-sub",
    value: email,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    placeholder: "Enter your e-mail address"
  })), error && /*#__PURE__*/React.createElement("p", {
    className: "email-sub__error emailSubError"
  }, "Please enter a valid email address")), /*#__PURE__*/React.createElement("button", {
    id: "emailSubmit",
    className: "email-submit",
    type: "submit"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://s3.amazonaws.com/dev-abtesting-assets/winter_master_2020/img/fa-arrow-right.svg",
    alt: "Submit email"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "email-sub__confirmation-cntnr"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-check-circle email-sub__icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "email-sub__confirmation"
  }, "Thanks for submitting your email!"))), /*#__PURE__*/React.createElement("p", {
    className: "email-sub__disclaimer ".concat(errorStyle)
  }, "By submitting you agree to the", /*#__PURE__*/React.createElement("a", {
    className: "term-condition",
    href: "https://legal.fabfitfun.com/?#terms-of-use/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, ' ', "Terms of Use and Sale"), ". You will receive email periodically and can opt-out at any time."));
};

var buildPath = function buildPath(route) {
  var subdomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var prodOnly = arguments.length > 2 ? arguments[2] : undefined;
  var isAbsolutePath = route.startsWith('http') || route.startsWith('https');
  if (isAbsolutePath) return route;
  var domainParts = isBrowser() ? window.location.hostname.split('.') : ['fabfitfun', 'com'];
  var domain = prodOnly ? 'fabfitfun' : domainParts[domainParts.length - 2];
  var host = "".concat(domain, ".").concat(domainParts[domainParts.length - 1]);

  if (subdomain !== '') {
    host = "".concat(subdomain, ".").concat(host);
  }

  return "//".concat(host).concat(route);
};

var css_248z$4 = "/*!\n * Font Awesome Pro 5.5.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n.fa, .fab, .fal, .far, .fas {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1\n}\n\n.fa-lg {\n    font-size: 1.33333em;\n    line-height: .75em;\n    vertical-align: -.0667em\n}\n\n.fa-xs {\n    font-size: .75em\n}\n\n.fa-sm {\n    font-size: .875em\n}\n\n.fa-1x {\n    font-size: 1em\n}\n\n.fa-2x {\n    font-size: 2em\n}\n\n.fa-3x {\n    font-size: 3em\n}\n\n.fa-4x {\n    font-size: 4em\n}\n\n.fa-5x {\n    font-size: 5em\n}\n\n.fa-6x {\n    font-size: 6em\n}\n\n.fa-7x {\n    font-size: 7em\n}\n\n.fa-8x {\n    font-size: 8em\n}\n\n.fa-9x {\n    font-size: 9em\n}\n\n.fa-10x {\n    font-size: 10em\n}\n\n.fa-fw {\n    text-align: center;\n    width: 1.25em\n}\n\n.fa-ul {\n    list-style-type: none;\n    margin-left: 2.5em;\n    padding-left: 0\n}\n\n.fa-ul > li {\n    position: relative\n}\n\n.fa-li {\n    left: -2em;\n    position: absolute;\n    text-align: center;\n    width: 2em;\n    line-height: inherit\n}\n\n.fa-border {\n    border: .08em solid #eee;\n    border-radius: .1em;\n    padding: .2em .25em .15em\n}\n\n.fa-pull-left {\n    float: left\n}\n\n.fa-pull-right {\n    float: right\n}\n\n.fa.fa-pull-left, .fab.fa-pull-left, .fal.fa-pull-left, .far.fa-pull-left, .fas.fa-pull-left {\n    margin-right: .3em\n}\n\n.fa.fa-pull-right, .fab.fa-pull-right, .fal.fa-pull-right, .far.fa-pull-right, .fas.fa-pull-right {\n    margin-left: .3em\n}\n\n.fa-spin {\n    animation: fa-spin 2s infinite linear\n}\n\n.fa-pulse {\n    animation: fa-spin 1s infinite steps(8)\n}\n\n@keyframes fa-spin {\n    0% {\n        transform: rotate(0deg)\n    }\n    to {\n        transform: rotate(1turn)\n    }\n}\n\n.fa-rotate-90 {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n    transform: rotate(90deg)\n}\n\n.fa-rotate-180 {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n    transform: rotate(180deg)\n}\n\n.fa-rotate-270 {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n    transform: rotate(270deg)\n}\n\n.fa-flip-horizontal {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n    transform: scaleX(-1)\n}\n\n.fa-flip-vertical {\n    transform: scaleY(-1)\n}\n\n.fa-flip-horizontal.fa-flip-vertical, .fa-flip-vertical {\n    -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\"\n}\n\n.fa-flip-horizontal.fa-flip-vertical {\n    transform: scale(-1)\n}\n\n:root .fa-flip-horizontal, :root .fa-flip-vertical, :root .fa-rotate-90, :root .fa-rotate-180, :root .fa-rotate-270 {\n    -webkit-filter: none;\n    filter: none\n}\n\n.fa-stack {\n    display: inline-block;\n    height: 2em;\n    line-height: 2em;\n    position: relative;\n    vertical-align: middle;\n    width: 2.5em\n}\n\n.fa-stack-1x, .fa-stack-2x {\n    left: 0;\n    position: absolute;\n    text-align: center;\n    width: 100%\n}\n\n.fa-stack-1x {\n    line-height: inherit\n}\n\n.fa-stack-2x {\n    font-size: 2em\n}\n\n.fa-inverse {\n    color: #fff\n}\n\n.fa-500px:before {\n    content: \"\\f26e\"\n}\n\n.fa-abacus:before {\n    content: \"\\f640\"\n}\n\n.fa-accessible-icon:before {\n    content: \"\\f368\"\n}\n\n.fa-accusoft:before {\n    content: \"\\f369\"\n}\n\n.fa-acorn:before {\n    content: \"\\f6ae\"\n}\n\n.fa-acquisitions-incorporated:before {\n    content: \"\\f6af\"\n}\n\n.fa-ad:before {\n    content: \"\\f641\"\n}\n\n.fa-address-book:before {\n    content: \"\\f2b9\"\n}\n\n.fa-address-card:before {\n    content: \"\\f2bb\"\n}\n\n.fa-adjust:before {\n    content: \"\\f042\"\n}\n\n.fa-adn:before {\n    content: \"\\f170\"\n}\n\n.fa-adversal:before {\n    content: \"\\f36a\"\n}\n\n.fa-affiliatetheme:before {\n    content: \"\\f36b\"\n}\n\n.fa-air-freshener:before {\n    content: \"\\f5d0\"\n}\n\n.fa-alarm-clock:before {\n    content: \"\\f34e\"\n}\n\n.fa-algolia:before {\n    content: \"\\f36c\"\n}\n\n.fa-alicorn:before {\n    content: \"\\f6b0\"\n}\n\n.fa-align-center:before {\n    content: \"\\f037\"\n}\n\n.fa-align-justify:before {\n    content: \"\\f039\"\n}\n\n.fa-align-left:before {\n    content: \"\\f036\"\n}\n\n.fa-align-right:before {\n    content: \"\\f038\"\n}\n\n.fa-alipay:before {\n    content: \"\\f642\"\n}\n\n.fa-allergies:before {\n    content: \"\\f461\"\n}\n\n.fa-amazon:before {\n    content: \"\\f270\"\n}\n\n.fa-amazon-pay:before {\n    content: \"\\f42c\"\n}\n\n.fa-ambulance:before {\n    content: \"\\f0f9\"\n}\n\n.fa-american-sign-language-interpreting:before {\n    content: \"\\f2a3\"\n}\n\n.fa-amilia:before {\n    content: \"\\f36d\"\n}\n\n.fa-analytics:before {\n    content: \"\\f643\"\n}\n\n.fa-anchor:before {\n    content: \"\\f13d\"\n}\n\n.fa-android:before {\n    content: \"\\f17b\"\n}\n\n.fa-angellist:before {\n    content: \"\\f209\"\n}\n\n.fa-angle-double-down:before {\n    content: \"\\f103\"\n}\n\n.fa-angle-double-left:before {\n    content: \"\\f100\"\n}\n\n.fa-angle-double-right:before {\n    content: \"\\f101\"\n}\n\n.fa-angle-double-up:before {\n    content: \"\\f102\"\n}\n\n.fa-angle-down:before {\n    content: \"\\f107\"\n}\n\n.fa-angle-left:before {\n    content: \"\\f104\"\n}\n\n.fa-angle-right:before {\n    content: \"\\f105\"\n}\n\n.fa-angle-up:before {\n    content: \"\\f106\"\n}\n\n.fa-angry:before {\n    content: \"\\f556\"\n}\n\n.fa-angrycreative:before {\n    content: \"\\f36e\"\n}\n\n.fa-angular:before {\n    content: \"\\f420\"\n}\n\n.fa-ankh:before {\n    content: \"\\f644\"\n}\n\n.fa-app-store:before {\n    content: \"\\f36f\"\n}\n\n.fa-app-store-ios:before {\n    content: \"\\f370\"\n}\n\n.fa-apper:before {\n    content: \"\\f371\"\n}\n\n.fa-apple:before {\n    content: \"\\f179\"\n}\n\n.fa-apple-alt:before {\n    content: \"\\f5d1\"\n}\n\n.fa-apple-crate:before {\n    content: \"\\f6b1\"\n}\n\n.fa-apple-pay:before {\n    content: \"\\f415\"\n}\n\n.fa-archive:before {\n    content: \"\\f187\"\n}\n\n.fa-archway:before {\n    content: \"\\f557\"\n}\n\n.fa-arrow-alt-circle-down:before {\n    content: \"\\f358\"\n}\n\n.fa-arrow-alt-circle-left:before {\n    content: \"\\f359\"\n}\n\n.fa-arrow-alt-circle-right:before {\n    content: \"\\f35a\"\n}\n\n.fa-arrow-alt-circle-up:before {\n    content: \"\\f35b\"\n}\n\n.fa-arrow-alt-down:before {\n    content: \"\\f354\"\n}\n\n.fa-arrow-alt-from-bottom:before {\n    content: \"\\f346\"\n}\n\n.fa-arrow-alt-from-left:before {\n    content: \"\\f347\"\n}\n\n.fa-arrow-alt-from-right:before {\n    content: \"\\f348\"\n}\n\n.fa-arrow-alt-from-top:before {\n    content: \"\\f349\"\n}\n\n.fa-arrow-alt-left:before {\n    content: \"\\f355\"\n}\n\n.fa-arrow-alt-right:before {\n    content: \"\\f356\"\n}\n\n.fa-arrow-alt-square-down:before {\n    content: \"\\f350\"\n}\n\n.fa-arrow-alt-square-left:before {\n    content: \"\\f351\"\n}\n\n.fa-arrow-alt-square-right:before {\n    content: \"\\f352\"\n}\n\n.fa-arrow-alt-square-up:before {\n    content: \"\\f353\"\n}\n\n.fa-arrow-alt-to-bottom:before {\n    content: \"\\f34a\"\n}\n\n.fa-arrow-alt-to-left:before {\n    content: \"\\f34b\"\n}\n\n.fa-arrow-alt-to-right:before {\n    content: \"\\f34c\"\n}\n\n.fa-arrow-alt-to-top:before {\n    content: \"\\f34d\"\n}\n\n.fa-arrow-alt-up:before {\n    content: \"\\f357\"\n}\n\n.fa-arrow-circle-down:before {\n    content: \"\\f0ab\"\n}\n\n.fa-arrow-circle-left:before {\n    content: \"\\f0a8\"\n}\n\n.fa-arrow-circle-right:before {\n    content: \"\\f0a9\"\n}\n\n.fa-arrow-circle-up:before {\n    content: \"\\f0aa\"\n}\n\n.fa-arrow-down:before {\n    content: \"\\f063\"\n}\n\n.fa-arrow-from-bottom:before {\n    content: \"\\f342\"\n}\n\n.fa-arrow-from-left:before {\n    content: \"\\f343\"\n}\n\n.fa-arrow-from-right:before {\n    content: \"\\f344\"\n}\n\n.fa-arrow-from-top:before {\n    content: \"\\f345\"\n}\n\n.fa-arrow-left:before {\n    content: \"\\f060\"\n}\n\n.fa-arrow-right:before {\n    content: \"\\f061\"\n}\n\n.fa-arrow-square-down:before {\n    content: \"\\f339\"\n}\n\n.fa-arrow-square-left:before {\n    content: \"\\f33a\"\n}\n\n.fa-arrow-square-right:before {\n    content: \"\\f33b\"\n}\n\n.fa-arrow-square-up:before {\n    content: \"\\f33c\"\n}\n\n.fa-arrow-to-bottom:before {\n    content: \"\\f33d\"\n}\n\n.fa-arrow-to-left:before {\n    content: \"\\f33e\"\n}\n\n.fa-arrow-to-right:before {\n    content: \"\\f340\"\n}\n\n.fa-arrow-to-top:before {\n    content: \"\\f341\"\n}\n\n.fa-arrow-up:before {\n    content: \"\\f062\"\n}\n\n.fa-arrows:before {\n    content: \"\\f047\"\n}\n\n.fa-arrows-alt:before {\n    content: \"\\f0b2\"\n}\n\n.fa-arrows-alt-h:before {\n    content: \"\\f337\"\n}\n\n.fa-arrows-alt-v:before {\n    content: \"\\f338\"\n}\n\n.fa-arrows-h:before {\n    content: \"\\f07e\"\n}\n\n.fa-arrows-v:before {\n    content: \"\\f07d\"\n}\n\n.fa-assistive-listening-systems:before {\n    content: \"\\f2a2\"\n}\n\n.fa-asterisk:before {\n    content: \"\\f069\"\n}\n\n.fa-asymmetrik:before {\n    content: \"\\f372\"\n}\n\n.fa-at:before {\n    content: \"\\f1fa\"\n}\n\n.fa-atlas:before {\n    content: \"\\f558\"\n}\n\n.fa-atom:before {\n    content: \"\\f5d2\"\n}\n\n.fa-atom-alt:before {\n    content: \"\\f5d3\"\n}\n\n.fa-audible:before {\n    content: \"\\f373\"\n}\n\n.fa-audio-description:before {\n    content: \"\\f29e\"\n}\n\n.fa-autoprefixer:before {\n    content: \"\\f41c\"\n}\n\n.fa-avianex:before {\n    content: \"\\f374\"\n}\n\n.fa-aviato:before {\n    content: \"\\f421\"\n}\n\n.fa-award:before {\n    content: \"\\f559\"\n}\n\n.fa-aws:before {\n    content: \"\\f375\"\n}\n\n.fa-axe:before {\n    content: \"\\f6b2\"\n}\n\n.fa-axe-battle:before {\n    content: \"\\f6b3\"\n}\n\n.fa-backpack:before {\n    content: \"\\f5d4\"\n}\n\n.fa-backspace:before {\n    content: \"\\f55a\"\n}\n\n.fa-backward:before {\n    content: \"\\f04a\"\n}\n\n.fa-badge:before {\n    content: \"\\f335\"\n}\n\n.fa-badge-check:before {\n    content: \"\\f336\"\n}\n\n.fa-badge-dollar:before {\n    content: \"\\f645\"\n}\n\n.fa-badge-percent:before {\n    content: \"\\f646\"\n}\n\n.fa-badger-honey:before {\n    content: \"\\f6b4\"\n}\n\n.fa-balance-scale:before {\n    content: \"\\f24e\"\n}\n\n.fa-balance-scale-left:before {\n    content: \"\\f515\"\n}\n\n.fa-balance-scale-right:before {\n    content: \"\\f516\"\n}\n\n.fa-ballot:before {\n    content: \"\\f732\"\n}\n\n.fa-ballot-check:before {\n    content: \"\\f733\"\n}\n\n.fa-ban:before {\n    content: \"\\f05e\"\n}\n\n.fa-band-aid:before {\n    content: \"\\f462\"\n}\n\n.fa-bandcamp:before {\n    content: \"\\f2d5\"\n}\n\n.fa-barcode:before {\n    content: \"\\f02a\"\n}\n\n.fa-barcode-alt:before {\n    content: \"\\f463\"\n}\n\n.fa-barcode-read:before {\n    content: \"\\f464\"\n}\n\n.fa-barcode-scan:before {\n    content: \"\\f465\"\n}\n\n.fa-bars:before {\n    content: \"\\f0c9\"\n}\n\n.fa-baseball:before {\n    content: \"\\f432\"\n}\n\n.fa-baseball-ball:before {\n    content: \"\\f433\"\n}\n\n.fa-basketball-ball:before {\n    content: \"\\f434\"\n}\n\n.fa-basketball-hoop:before {\n    content: \"\\f435\"\n}\n\n.fa-bat:before {\n    content: \"\\f6b5\"\n}\n\n.fa-bath:before {\n    content: \"\\f2cd\"\n}\n\n.fa-battery-bolt:before {\n    content: \"\\f376\"\n}\n\n.fa-battery-empty:before {\n    content: \"\\f244\"\n}\n\n.fa-battery-full:before {\n    content: \"\\f240\"\n}\n\n.fa-battery-half:before {\n    content: \"\\f242\"\n}\n\n.fa-battery-quarter:before {\n    content: \"\\f243\"\n}\n\n.fa-battery-slash:before {\n    content: \"\\f377\"\n}\n\n.fa-battery-three-quarters:before {\n    content: \"\\f241\"\n}\n\n.fa-bed:before {\n    content: \"\\f236\"\n}\n\n.fa-beer:before {\n    content: \"\\f0fc\"\n}\n\n.fa-behance:before {\n    content: \"\\f1b4\"\n}\n\n.fa-behance-square:before {\n    content: \"\\f1b5\"\n}\n\n.fa-bell:before {\n    content: \"\\f0f3\"\n}\n\n.fa-bell-school:before {\n    content: \"\\f5d5\"\n}\n\n.fa-bell-school-slash:before {\n    content: \"\\f5d6\"\n}\n\n.fa-bell-slash:before {\n    content: \"\\f1f6\"\n}\n\n.fa-bezier-curve:before {\n    content: \"\\f55b\"\n}\n\n.fa-bible:before {\n    content: \"\\f647\"\n}\n\n.fa-bicycle:before {\n    content: \"\\f206\"\n}\n\n.fa-bimobject:before {\n    content: \"\\f378\"\n}\n\n.fa-binoculars:before {\n    content: \"\\f1e5\"\n}\n\n.fa-birthday-cake:before {\n    content: \"\\f1fd\"\n}\n\n.fa-bitbucket:before {\n    content: \"\\f171\"\n}\n\n.fa-bitcoin:before {\n    content: \"\\f379\"\n}\n\n.fa-bity:before {\n    content: \"\\f37a\"\n}\n\n.fa-black-tie:before {\n    content: \"\\f27e\"\n}\n\n.fa-blackberry:before {\n    content: \"\\f37b\"\n}\n\n.fa-blanket:before {\n    content: \"\\f498\"\n}\n\n.fa-blender:before {\n    content: \"\\f517\"\n}\n\n.fa-blender-phone:before {\n    content: \"\\f6b6\"\n}\n\n.fa-blind:before {\n    content: \"\\f29d\"\n}\n\n.fa-blogger:before {\n    content: \"\\f37c\"\n}\n\n.fa-blogger-b:before {\n    content: \"\\f37d\"\n}\n\n.fa-bluetooth:before {\n    content: \"\\f293\"\n}\n\n.fa-bluetooth-b:before {\n    content: \"\\f294\"\n}\n\n.fa-bold:before {\n    content: \"\\f032\"\n}\n\n.fa-bolt:before {\n    content: \"\\f0e7\"\n}\n\n.fa-bomb:before {\n    content: \"\\f1e2\"\n}\n\n.fa-bone:before {\n    content: \"\\f5d7\"\n}\n\n.fa-bone-break:before {\n    content: \"\\f5d8\"\n}\n\n.fa-bong:before {\n    content: \"\\f55c\"\n}\n\n.fa-book:before {\n    content: \"\\f02d\"\n}\n\n.fa-book-alt:before {\n    content: \"\\f5d9\"\n}\n\n.fa-book-dead:before {\n    content: \"\\f6b7\"\n}\n\n.fa-book-heart:before {\n    content: \"\\f499\"\n}\n\n.fa-book-open:before {\n    content: \"\\f518\"\n}\n\n.fa-book-reader:before {\n    content: \"\\f5da\"\n}\n\n.fa-book-spells:before {\n    content: \"\\f6b8\"\n}\n\n.fa-bookmark:before {\n    content: \"\\f02e\"\n}\n\n.fa-books:before {\n    content: \"\\f5db\"\n}\n\n.fa-booth-curtain:before {\n    content: \"\\f734\"\n}\n\n.fa-bow-arrow:before {\n    content: \"\\f6b9\"\n}\n\n.fa-bowling-ball:before {\n    content: \"\\f436\"\n}\n\n.fa-bowling-pins:before {\n    content: \"\\f437\"\n}\n\n.fa-box:before {\n    content: \"\\f466\"\n}\n\n.fa-box-alt:before {\n    content: \"\\f49a\"\n}\n\n.fa-box-ballot:before {\n    content: \"\\f735\"\n}\n\n.fa-box-check:before {\n    content: \"\\f467\"\n}\n\n.fa-box-fragile:before {\n    content: \"\\f49b\"\n}\n\n.fa-box-full:before {\n    content: \"\\f49c\"\n}\n\n.fa-box-heart:before {\n    content: \"\\f49d\"\n}\n\n.fa-box-open:before {\n    content: \"\\f49e\"\n}\n\n.fa-box-up:before {\n    content: \"\\f49f\"\n}\n\n.fa-box-usd:before {\n    content: \"\\f4a0\"\n}\n\n.fa-boxes:before {\n    content: \"\\f468\"\n}\n\n.fa-boxes-alt:before {\n    content: \"\\f4a1\"\n}\n\n.fa-boxing-glove:before {\n    content: \"\\f438\"\n}\n\n.fa-braille:before {\n    content: \"\\f2a1\"\n}\n\n.fa-brain:before {\n    content: \"\\f5dc\"\n}\n\n.fa-briefcase:before {\n    content: \"\\f0b1\"\n}\n\n.fa-briefcase-medical:before {\n    content: \"\\f469\"\n}\n\n.fa-broadcast-tower:before {\n    content: \"\\f519\"\n}\n\n.fa-broom:before {\n    content: \"\\f51a\"\n}\n\n.fa-browser:before {\n    content: \"\\f37e\"\n}\n\n.fa-brush:before {\n    content: \"\\f55d\"\n}\n\n.fa-btc:before {\n    content: \"\\f15a\"\n}\n\n.fa-bug:before {\n    content: \"\\f188\"\n}\n\n.fa-building:before {\n    content: \"\\f1ad\"\n}\n\n.fa-bullhorn:before {\n    content: \"\\f0a1\"\n}\n\n.fa-bullseye:before {\n    content: \"\\f140\"\n}\n\n.fa-bullseye-arrow:before {\n    content: \"\\f648\"\n}\n\n.fa-bullseye-pointer:before {\n    content: \"\\f649\"\n}\n\n.fa-burn:before {\n    content: \"\\f46a\"\n}\n\n.fa-buromobelexperte:before {\n    content: \"\\f37f\"\n}\n\n.fa-bus:before {\n    content: \"\\f207\"\n}\n\n.fa-bus-alt:before {\n    content: \"\\f55e\"\n}\n\n.fa-bus-school:before {\n    content: \"\\f5dd\"\n}\n\n.fa-business-time:before {\n    content: \"\\f64a\"\n}\n\n.fa-buysellads:before {\n    content: \"\\f20d\"\n}\n\n.fa-cabinet-filing:before {\n    content: \"\\f64b\"\n}\n\n.fa-calculator:before {\n    content: \"\\f1ec\"\n}\n\n.fa-calculator-alt:before {\n    content: \"\\f64c\"\n}\n\n.fa-calendar:before {\n    content: \"\\f133\"\n}\n\n.fa-calendar-alt:before {\n    content: \"\\f073\"\n}\n\n.fa-calendar-check:before {\n    content: \"\\f274\"\n}\n\n.fa-calendar-edit:before {\n    content: \"\\f333\"\n}\n\n.fa-calendar-exclamation:before {\n    content: \"\\f334\"\n}\n\n.fa-calendar-minus:before {\n    content: \"\\f272\"\n}\n\n.fa-calendar-plus:before {\n    content: \"\\f271\"\n}\n\n.fa-calendar-star:before {\n    content: \"\\f736\"\n}\n\n.fa-calendar-times:before {\n    content: \"\\f273\"\n}\n\n.fa-camera:before {\n    content: \"\\f030\"\n}\n\n.fa-camera-alt:before {\n    content: \"\\f332\"\n}\n\n.fa-camera-retro:before {\n    content: \"\\f083\"\n}\n\n.fa-campfire:before {\n    content: \"\\f6ba\"\n}\n\n.fa-campground:before {\n    content: \"\\f6bb\"\n}\n\n.fa-candle-holder:before {\n    content: \"\\f6bc\"\n}\n\n.fa-candy-corn:before {\n    content: \"\\f6bd\"\n}\n\n.fa-cannabis:before {\n    content: \"\\f55f\"\n}\n\n.fa-capsules:before {\n    content: \"\\f46b\"\n}\n\n.fa-car:before {\n    content: \"\\f1b9\"\n}\n\n.fa-car-alt:before {\n    content: \"\\f5de\"\n}\n\n.fa-car-battery:before {\n    content: \"\\f5df\"\n}\n\n.fa-car-bump:before {\n    content: \"\\f5e0\"\n}\n\n.fa-car-crash:before {\n    content: \"\\f5e1\"\n}\n\n.fa-car-garage:before {\n    content: \"\\f5e2\"\n}\n\n.fa-car-mechanic:before {\n    content: \"\\f5e3\"\n}\n\n.fa-car-side:before {\n    content: \"\\f5e4\"\n}\n\n.fa-car-tilt:before {\n    content: \"\\f5e5\"\n}\n\n.fa-car-wash:before {\n    content: \"\\f5e6\"\n}\n\n.fa-caret-circle-down:before {\n    content: \"\\f32d\"\n}\n\n.fa-caret-circle-left:before {\n    content: \"\\f32e\"\n}\n\n.fa-caret-circle-right:before {\n    content: \"\\f330\"\n}\n\n.fa-caret-circle-up:before {\n    content: \"\\f331\"\n}\n\n.fa-caret-down:before {\n    content: \"\\f0d7\"\n}\n\n.fa-caret-left:before {\n    content: \"\\f0d9\"\n}\n\n.fa-caret-right:before {\n    content: \"\\f0da\"\n}\n\n.fa-caret-square-down:before {\n    content: \"\\f150\"\n}\n\n.fa-caret-square-left:before {\n    content: \"\\f191\"\n}\n\n.fa-caret-square-right:before {\n    content: \"\\f152\"\n}\n\n.fa-caret-square-up:before {\n    content: \"\\f151\"\n}\n\n.fa-caret-up:before {\n    content: \"\\f0d8\"\n}\n\n.fa-cart-arrow-down:before {\n    content: \"\\f218\"\n}\n\n.fa-cart-plus:before {\n    content: \"\\f217\"\n}\n\n.fa-cat:before {\n    content: \"\\f6be\"\n}\n\n.fa-cauldron:before {\n    content: \"\\f6bf\"\n}\n\n.fa-cc-amazon-pay:before {\n    content: \"\\f42d\"\n}\n\n.fa-cc-amex:before {\n    content: \"\\f1f3\"\n}\n\n.fa-cc-apple-pay:before {\n    content: \"\\f416\"\n}\n\n.fa-cc-diners-club:before {\n    content: \"\\f24c\"\n}\n\n.fa-cc-discover:before {\n    content: \"\\f1f2\"\n}\n\n.fa-cc-jcb:before {\n    content: \"\\f24b\"\n}\n\n.fa-cc-mastercard:before {\n    content: \"\\f1f1\"\n}\n\n.fa-cc-paypal:before {\n    content: \"\\f1f4\"\n}\n\n.fa-cc-stripe:before {\n    content: \"\\f1f5\"\n}\n\n.fa-cc-visa:before {\n    content: \"\\f1f0\"\n}\n\n.fa-centercode:before {\n    content: \"\\f380\"\n}\n\n.fa-certificate:before {\n    content: \"\\f0a3\"\n}\n\n.fa-chair:before {\n    content: \"\\f6c0\"\n}\n\n.fa-chair-office:before {\n    content: \"\\f6c1\"\n}\n\n.fa-chalkboard:before {\n    content: \"\\f51b\"\n}\n\n.fa-chalkboard-teacher:before {\n    content: \"\\f51c\"\n}\n\n.fa-charging-station:before {\n    content: \"\\f5e7\"\n}\n\n.fa-chart-area:before {\n    content: \"\\f1fe\"\n}\n\n.fa-chart-bar:before {\n    content: \"\\f080\"\n}\n\n.fa-chart-line:before {\n    content: \"\\f201\"\n}\n\n.fa-chart-line-down:before {\n    content: \"\\f64d\"\n}\n\n.fa-chart-pie:before {\n    content: \"\\f200\"\n}\n\n.fa-chart-pie-alt:before {\n    content: \"\\f64e\"\n}\n\n.fa-check:before {\n    content: \"\\f00c\"\n}\n\n.fa-check-circle:before {\n    content: \"\\f058\"\n}\n\n.fa-check-double:before {\n    content: \"\\f560\"\n}\n\n.fa-check-square:before {\n    content: \"\\f14a\"\n}\n\n.fa-chess:before {\n    content: \"\\f439\"\n}\n\n.fa-chess-bishop:before {\n    content: \"\\f43a\"\n}\n\n.fa-chess-bishop-alt:before {\n    content: \"\\f43b\"\n}\n\n.fa-chess-board:before {\n    content: \"\\f43c\"\n}\n\n.fa-chess-clock:before {\n    content: \"\\f43d\"\n}\n\n.fa-chess-clock-alt:before {\n    content: \"\\f43e\"\n}\n\n.fa-chess-king:before {\n    content: \"\\f43f\"\n}\n\n.fa-chess-king-alt:before {\n    content: \"\\f440\"\n}\n\n.fa-chess-knight:before {\n    content: \"\\f441\"\n}\n\n.fa-chess-knight-alt:before {\n    content: \"\\f442\"\n}\n\n.fa-chess-pawn:before {\n    content: \"\\f443\"\n}\n\n.fa-chess-pawn-alt:before {\n    content: \"\\f444\"\n}\n\n.fa-chess-queen:before {\n    content: \"\\f445\"\n}\n\n.fa-chess-queen-alt:before {\n    content: \"\\f446\"\n}\n\n.fa-chess-rook:before {\n    content: \"\\f447\"\n}\n\n.fa-chess-rook-alt:before {\n    content: \"\\f448\"\n}\n\n.fa-chevron-circle-down:before {\n    content: \"\\f13a\"\n}\n\n.fa-chevron-circle-left:before {\n    content: \"\\f137\"\n}\n\n.fa-chevron-circle-right:before {\n    content: \"\\f138\"\n}\n\n.fa-chevron-circle-up:before {\n    content: \"\\f139\"\n}\n\n.fa-chevron-double-down:before {\n    content: \"\\f322\"\n}\n\n.fa-chevron-double-left:before {\n    content: \"\\f323\"\n}\n\n.fa-chevron-double-right:before {\n    content: \"\\f324\"\n}\n\n.fa-chevron-double-up:before {\n    content: \"\\f325\"\n}\n\n.fa-chevron-down:before {\n    content: \"\\f078\"\n}\n\n.fa-chevron-left:before {\n    content: \"\\f053\"\n}\n\n.fa-chevron-right:before {\n    content: \"\\f054\"\n}\n\n.fa-chevron-square-down:before {\n    content: \"\\f329\"\n}\n\n.fa-chevron-square-left:before {\n    content: \"\\f32a\"\n}\n\n.fa-chevron-square-right:before {\n    content: \"\\f32b\"\n}\n\n.fa-chevron-square-up:before {\n    content: \"\\f32c\"\n}\n\n.fa-chevron-up:before {\n    content: \"\\f077\"\n}\n\n.fa-child:before {\n    content: \"\\f1ae\"\n}\n\n.fa-chrome:before {\n    content: \"\\f268\"\n}\n\n.fa-church:before {\n    content: \"\\f51d\"\n}\n\n.fa-circle:before {\n    content: \"\\f111\"\n}\n\n.fa-circle-notch:before {\n    content: \"\\f1ce\"\n}\n\n.fa-city:before {\n    content: \"\\f64f\"\n}\n\n.fa-claw-marks:before {\n    content: \"\\f6c2\"\n}\n\n.fa-clipboard:before {\n    content: \"\\f328\"\n}\n\n.fa-clipboard-check:before {\n    content: \"\\f46c\"\n}\n\n.fa-clipboard-list:before {\n    content: \"\\f46d\"\n}\n\n.fa-clipboard-list-check:before {\n    content: \"\\f737\"\n}\n\n.fa-clipboard-prescription:before {\n    content: \"\\f5e8\"\n}\n\n.fa-clock:before {\n    content: \"\\f017\"\n}\n\n.fa-clone:before {\n    content: \"\\f24d\"\n}\n\n.fa-closed-captioning:before {\n    content: \"\\f20a\"\n}\n\n.fa-cloud:before {\n    content: \"\\f0c2\"\n}\n\n.fa-cloud-download:before {\n    content: \"\\f0ed\"\n}\n\n.fa-cloud-download-alt:before {\n    content: \"\\f381\"\n}\n\n.fa-cloud-drizzle:before {\n    content: \"\\f738\"\n}\n\n.fa-cloud-hail:before {\n    content: \"\\f739\"\n}\n\n.fa-cloud-hail-mixed:before {\n    content: \"\\f73a\"\n}\n\n.fa-cloud-meatball:before {\n    content: \"\\f73b\"\n}\n\n.fa-cloud-moon:before {\n    content: \"\\f6c3\"\n}\n\n.fa-cloud-moon-rain:before {\n    content: \"\\f73c\"\n}\n\n.fa-cloud-rain:before {\n    content: \"\\f73d\"\n}\n\n.fa-cloud-rainbow:before {\n    content: \"\\f73e\"\n}\n\n.fa-cloud-showers:before {\n    content: \"\\f73f\"\n}\n\n.fa-cloud-showers-heavy:before {\n    content: \"\\f740\"\n}\n\n.fa-cloud-sleet:before {\n    content: \"\\f741\"\n}\n\n.fa-cloud-snow:before {\n    content: \"\\f742\"\n}\n\n.fa-cloud-sun:before {\n    content: \"\\f6c4\"\n}\n\n.fa-cloud-sun-rain:before {\n    content: \"\\f743\"\n}\n\n.fa-cloud-upload:before {\n    content: \"\\f0ee\"\n}\n\n.fa-cloud-upload-alt:before {\n    content: \"\\f382\"\n}\n\n.fa-clouds:before {\n    content: \"\\f744\"\n}\n\n.fa-clouds-moon:before {\n    content: \"\\f745\"\n}\n\n.fa-clouds-sun:before {\n    content: \"\\f746\"\n}\n\n.fa-cloudscale:before {\n    content: \"\\f383\"\n}\n\n.fa-cloudsmith:before {\n    content: \"\\f384\"\n}\n\n.fa-cloudversify:before {\n    content: \"\\f385\"\n}\n\n.fa-club:before {\n    content: \"\\f327\"\n}\n\n.fa-cocktail:before {\n    content: \"\\f561\"\n}\n\n.fa-code:before {\n    content: \"\\f121\"\n}\n\n.fa-code-branch:before {\n    content: \"\\f126\"\n}\n\n.fa-code-commit:before {\n    content: \"\\f386\"\n}\n\n.fa-code-merge:before {\n    content: \"\\f387\"\n}\n\n.fa-codepen:before {\n    content: \"\\f1cb\"\n}\n\n.fa-codiepie:before {\n    content: \"\\f284\"\n}\n\n.fa-coffee:before {\n    content: \"\\f0f4\"\n}\n\n.fa-coffee-togo:before {\n    content: \"\\f6c5\"\n}\n\n.fa-coffin:before {\n    content: \"\\f6c6\"\n}\n\n.fa-cog:before {\n    content: \"\\f013\"\n}\n\n.fa-cogs:before {\n    content: \"\\f085\"\n}\n\n.fa-coins:before {\n    content: \"\\f51e\"\n}\n\n.fa-columns:before {\n    content: \"\\f0db\"\n}\n\n.fa-comment:before {\n    content: \"\\f075\"\n}\n\n.fa-comment-alt:before {\n    content: \"\\f27a\"\n}\n\n.fa-comment-alt-check:before {\n    content: \"\\f4a2\"\n}\n\n.fa-comment-alt-dollar:before {\n    content: \"\\f650\"\n}\n\n.fa-comment-alt-dots:before {\n    content: \"\\f4a3\"\n}\n\n.fa-comment-alt-edit:before {\n    content: \"\\f4a4\"\n}\n\n.fa-comment-alt-exclamation:before {\n    content: \"\\f4a5\"\n}\n\n.fa-comment-alt-lines:before {\n    content: \"\\f4a6\"\n}\n\n.fa-comment-alt-minus:before {\n    content: \"\\f4a7\"\n}\n\n.fa-comment-alt-plus:before {\n    content: \"\\f4a8\"\n}\n\n.fa-comment-alt-slash:before {\n    content: \"\\f4a9\"\n}\n\n.fa-comment-alt-smile:before {\n    content: \"\\f4aa\"\n}\n\n.fa-comment-alt-times:before {\n    content: \"\\f4ab\"\n}\n\n.fa-comment-check:before {\n    content: \"\\f4ac\"\n}\n\n.fa-comment-dollar:before {\n    content: \"\\f651\"\n}\n\n.fa-comment-dots:before {\n    content: \"\\f4ad\"\n}\n\n.fa-comment-edit:before {\n    content: \"\\f4ae\"\n}\n\n.fa-comment-exclamation:before {\n    content: \"\\f4af\"\n}\n\n.fa-comment-lines:before {\n    content: \"\\f4b0\"\n}\n\n.fa-comment-minus:before {\n    content: \"\\f4b1\"\n}\n\n.fa-comment-plus:before {\n    content: \"\\f4b2\"\n}\n\n.fa-comment-slash:before {\n    content: \"\\f4b3\"\n}\n\n.fa-comment-smile:before {\n    content: \"\\f4b4\"\n}\n\n.fa-comment-times:before {\n    content: \"\\f4b5\"\n}\n\n.fa-comments:before {\n    content: \"\\f086\"\n}\n\n.fa-comments-alt:before {\n    content: \"\\f4b6\"\n}\n\n.fa-comments-alt-dollar:before {\n    content: \"\\f652\"\n}\n\n.fa-comments-dollar:before {\n    content: \"\\f653\"\n}\n\n.fa-compact-disc:before {\n    content: \"\\f51f\"\n}\n\n.fa-compass:before {\n    content: \"\\f14e\"\n}\n\n.fa-compass-slash:before {\n    content: \"\\f5e9\"\n}\n\n.fa-compress:before {\n    content: \"\\f066\"\n}\n\n.fa-compress-alt:before {\n    content: \"\\f422\"\n}\n\n.fa-compress-wide:before {\n    content: \"\\f326\"\n}\n\n.fa-concierge-bell:before {\n    content: \"\\f562\"\n}\n\n.fa-connectdevelop:before {\n    content: \"\\f20e\"\n}\n\n.fa-container-storage:before {\n    content: \"\\f4b7\"\n}\n\n.fa-contao:before {\n    content: \"\\f26d\"\n}\n\n.fa-conveyor-belt:before {\n    content: \"\\f46e\"\n}\n\n.fa-conveyor-belt-alt:before {\n    content: \"\\f46f\"\n}\n\n.fa-cookie:before {\n    content: \"\\f563\"\n}\n\n.fa-cookie-bite:before {\n    content: \"\\f564\"\n}\n\n.fa-copy:before {\n    content: \"\\f0c5\"\n}\n\n.fa-copyright:before {\n    content: \"\\f1f9\"\n}\n\n.fa-corn:before {\n    content: \"\\f6c7\"\n}\n\n.fa-couch:before {\n    content: \"\\f4b8\"\n}\n\n.fa-cow:before {\n    content: \"\\f6c8\"\n}\n\n.fa-cpanel:before {\n    content: \"\\f388\"\n}\n\n.fa-creative-commons:before {\n    content: \"\\f25e\"\n}\n\n.fa-creative-commons-by:before {\n    content: \"\\f4e7\"\n}\n\n.fa-creative-commons-nc:before {\n    content: \"\\f4e8\"\n}\n\n.fa-creative-commons-nc-eu:before {\n    content: \"\\f4e9\"\n}\n\n.fa-creative-commons-nc-jp:before {\n    content: \"\\f4ea\"\n}\n\n.fa-creative-commons-nd:before {\n    content: \"\\f4eb\"\n}\n\n.fa-creative-commons-pd:before {\n    content: \"\\f4ec\"\n}\n\n.fa-creative-commons-pd-alt:before {\n    content: \"\\f4ed\"\n}\n\n.fa-creative-commons-remix:before {\n    content: \"\\f4ee\"\n}\n\n.fa-creative-commons-sa:before {\n    content: \"\\f4ef\"\n}\n\n.fa-creative-commons-sampling:before {\n    content: \"\\f4f0\"\n}\n\n.fa-creative-commons-sampling-plus:before {\n    content: \"\\f4f1\"\n}\n\n.fa-creative-commons-share:before {\n    content: \"\\f4f2\"\n}\n\n.fa-creative-commons-zero:before {\n    content: \"\\f4f3\"\n}\n\n.fa-credit-card:before {\n    content: \"\\f09d\"\n}\n\n.fa-credit-card-blank:before {\n    content: \"\\f389\"\n}\n\n.fa-credit-card-front:before {\n    content: \"\\f38a\"\n}\n\n.fa-cricket:before {\n    content: \"\\f449\"\n}\n\n.fa-critical-role:before {\n    content: \"\\f6c9\"\n}\n\n.fa-crop:before {\n    content: \"\\f125\"\n}\n\n.fa-crop-alt:before {\n    content: \"\\f565\"\n}\n\n.fa-cross:before {\n    content: \"\\f654\"\n}\n\n.fa-crosshairs:before {\n    content: \"\\f05b\"\n}\n\n.fa-crow:before {\n    content: \"\\f520\"\n}\n\n.fa-crown:before {\n    content: \"\\f521\"\n}\n\n.fa-css3:before {\n    content: \"\\f13c\"\n}\n\n.fa-css3-alt:before {\n    content: \"\\f38b\"\n}\n\n.fa-cube:before {\n    content: \"\\f1b2\"\n}\n\n.fa-cubes:before {\n    content: \"\\f1b3\"\n}\n\n.fa-curling:before {\n    content: \"\\f44a\"\n}\n\n.fa-cut:before {\n    content: \"\\f0c4\"\n}\n\n.fa-cuttlefish:before {\n    content: \"\\f38c\"\n}\n\n.fa-d-and-d:before {\n    content: \"\\f38d\"\n}\n\n.fa-d-and-d-beyond:before {\n    content: \"\\f6ca\"\n}\n\n.fa-dagger:before {\n    content: \"\\f6cb\"\n}\n\n.fa-dashcube:before {\n    content: \"\\f210\"\n}\n\n.fa-database:before {\n    content: \"\\f1c0\"\n}\n\n.fa-deaf:before {\n    content: \"\\f2a4\"\n}\n\n.fa-delicious:before {\n    content: \"\\f1a5\"\n}\n\n.fa-democrat:before {\n    content: \"\\f747\"\n}\n\n.fa-deploydog:before {\n    content: \"\\f38e\"\n}\n\n.fa-deskpro:before {\n    content: \"\\f38f\"\n}\n\n.fa-desktop:before {\n    content: \"\\f108\"\n}\n\n.fa-desktop-alt:before {\n    content: \"\\f390\"\n}\n\n.fa-dev:before {\n    content: \"\\f6cc\"\n}\n\n.fa-deviantart:before {\n    content: \"\\f1bd\"\n}\n\n.fa-dewpoint:before {\n    content: \"\\f748\"\n}\n\n.fa-dharmachakra:before {\n    content: \"\\f655\"\n}\n\n.fa-diagnoses:before {\n    content: \"\\f470\"\n}\n\n.fa-diamond:before {\n    content: \"\\f219\"\n}\n\n.fa-dice:before {\n    content: \"\\f522\"\n}\n\n.fa-dice-d10:before {\n    content: \"\\f6cd\"\n}\n\n.fa-dice-d12:before {\n    content: \"\\f6ce\"\n}\n\n.fa-dice-d20:before {\n    content: \"\\f6cf\"\n}\n\n.fa-dice-d4:before {\n    content: \"\\f6d0\"\n}\n\n.fa-dice-d6:before {\n    content: \"\\f6d1\"\n}\n\n.fa-dice-d8:before {\n    content: \"\\f6d2\"\n}\n\n.fa-dice-five:before {\n    content: \"\\f523\"\n}\n\n.fa-dice-four:before {\n    content: \"\\f524\"\n}\n\n.fa-dice-one:before {\n    content: \"\\f525\"\n}\n\n.fa-dice-six:before {\n    content: \"\\f526\"\n}\n\n.fa-dice-three:before {\n    content: \"\\f527\"\n}\n\n.fa-dice-two:before {\n    content: \"\\f528\"\n}\n\n.fa-digg:before {\n    content: \"\\f1a6\"\n}\n\n.fa-digital-ocean:before {\n    content: \"\\f391\"\n}\n\n.fa-digital-tachograph:before {\n    content: \"\\f566\"\n}\n\n.fa-diploma:before {\n    content: \"\\f5ea\"\n}\n\n.fa-directions:before {\n    content: \"\\f5eb\"\n}\n\n.fa-discord:before {\n    content: \"\\f392\"\n}\n\n.fa-discourse:before {\n    content: \"\\f393\"\n}\n\n.fa-divide:before {\n    content: \"\\f529\"\n}\n\n.fa-dizzy:before {\n    content: \"\\f567\"\n}\n\n.fa-dna:before {\n    content: \"\\f471\"\n}\n\n.fa-do-not-enter:before {\n    content: \"\\f5ec\"\n}\n\n.fa-dochub:before {\n    content: \"\\f394\"\n}\n\n.fa-docker:before {\n    content: \"\\f395\"\n}\n\n.fa-dog:before {\n    content: \"\\f6d3\"\n}\n\n.fa-dog-leashed:before {\n    content: \"\\f6d4\"\n}\n\n.fa-dollar-sign:before {\n    content: \"\\f155\"\n}\n\n.fa-dolly:before {\n    content: \"\\f472\"\n}\n\n.fa-dolly-empty:before {\n    content: \"\\f473\"\n}\n\n.fa-dolly-flatbed:before {\n    content: \"\\f474\"\n}\n\n.fa-dolly-flatbed-alt:before {\n    content: \"\\f475\"\n}\n\n.fa-dolly-flatbed-empty:before {\n    content: \"\\f476\"\n}\n\n.fa-donate:before {\n    content: \"\\f4b9\"\n}\n\n.fa-door-closed:before {\n    content: \"\\f52a\"\n}\n\n.fa-door-open:before {\n    content: \"\\f52b\"\n}\n\n.fa-dot-circle:before {\n    content: \"\\f192\"\n}\n\n.fa-dove:before {\n    content: \"\\f4ba\"\n}\n\n.fa-download:before {\n    content: \"\\f019\"\n}\n\n.fa-draft2digital:before {\n    content: \"\\f396\"\n}\n\n.fa-drafting-compass:before {\n    content: \"\\f568\"\n}\n\n.fa-dragon:before {\n    content: \"\\f6d5\"\n}\n\n.fa-draw-circle:before {\n    content: \"\\f5ed\"\n}\n\n.fa-draw-polygon:before {\n    content: \"\\f5ee\"\n}\n\n.fa-draw-square:before {\n    content: \"\\f5ef\"\n}\n\n.fa-dribbble:before {\n    content: \"\\f17d\"\n}\n\n.fa-dribbble-square:before {\n    content: \"\\f397\"\n}\n\n.fa-dropbox:before {\n    content: \"\\f16b\"\n}\n\n.fa-drum:before {\n    content: \"\\f569\"\n}\n\n.fa-drum-steelpan:before {\n    content: \"\\f56a\"\n}\n\n.fa-drumstick:before {\n    content: \"\\f6d6\"\n}\n\n.fa-drumstick-bite:before {\n    content: \"\\f6d7\"\n}\n\n.fa-drupal:before {\n    content: \"\\f1a9\"\n}\n\n.fa-duck:before {\n    content: \"\\f6d8\"\n}\n\n.fa-dumbbell:before {\n    content: \"\\f44b\"\n}\n\n.fa-dungeon:before {\n    content: \"\\f6d9\"\n}\n\n.fa-dyalog:before {\n    content: \"\\f399\"\n}\n\n.fa-ear:before {\n    content: \"\\f5f0\"\n}\n\n.fa-earlybirds:before {\n    content: \"\\f39a\"\n}\n\n.fa-ebay:before {\n    content: \"\\f4f4\"\n}\n\n.fa-eclipse:before {\n    content: \"\\f749\"\n}\n\n.fa-eclipse-alt:before {\n    content: \"\\f74a\"\n}\n\n.fa-edge:before {\n    content: \"\\f282\"\n}\n\n.fa-edit:before {\n    content: \"\\f044\"\n}\n\n.fa-eject:before {\n    content: \"\\f052\"\n}\n\n.fa-elementor:before {\n    content: \"\\f430\"\n}\n\n.fa-elephant:before {\n    content: \"\\f6da\"\n}\n\n.fa-ellipsis-h:before {\n    content: \"\\f141\"\n}\n\n.fa-ellipsis-h-alt:before {\n    content: \"\\f39b\"\n}\n\n.fa-ellipsis-v:before {\n    content: \"\\f142\"\n}\n\n.fa-ellipsis-v-alt:before {\n    content: \"\\f39c\"\n}\n\n.fa-ello:before {\n    content: \"\\f5f1\"\n}\n\n.fa-ember:before {\n    content: \"\\f423\"\n}\n\n.fa-empire:before {\n    content: \"\\f1d1\"\n}\n\n.fa-empty-set:before {\n    content: \"\\f656\"\n}\n\n.fa-engine-warning:before {\n    content: \"\\f5f2\"\n}\n\n.fa-envelope:before {\n    content: \"\\f0e0\"\n}\n\n.fa-envelope-open:before {\n    content: \"\\f2b6\"\n}\n\n.fa-envelope-open-dollar:before {\n    content: \"\\f657\"\n}\n\n.fa-envelope-open-text:before {\n    content: \"\\f658\"\n}\n\n.fa-envelope-square:before {\n    content: \"\\f199\"\n}\n\n.fa-envira:before {\n    content: \"\\f299\"\n}\n\n.fa-equals:before {\n    content: \"\\f52c\"\n}\n\n.fa-eraser:before {\n    content: \"\\f12d\"\n}\n\n.fa-erlang:before {\n    content: \"\\f39d\"\n}\n\n.fa-ethereum:before {\n    content: \"\\f42e\"\n}\n\n.fa-etsy:before {\n    content: \"\\f2d7\"\n}\n\n.fa-euro-sign:before {\n    content: \"\\f153\"\n}\n\n.fa-exchange:before {\n    content: \"\\f0ec\"\n}\n\n.fa-exchange-alt:before {\n    content: \"\\f362\"\n}\n\n.fa-exclamation:before {\n    content: \"\\f12a\"\n}\n\n.fa-exclamation-circle:before {\n    content: \"\\f06a\"\n}\n\n.fa-exclamation-square:before {\n    content: \"\\f321\"\n}\n\n.fa-exclamation-triangle:before {\n    content: \"\\f071\"\n}\n\n.fa-expand:before {\n    content: \"\\f065\"\n}\n\n.fa-expand-alt:before {\n    content: \"\\f424\"\n}\n\n.fa-expand-arrows:before {\n    content: \"\\f31d\"\n}\n\n.fa-expand-arrows-alt:before {\n    content: \"\\f31e\"\n}\n\n.fa-expand-wide:before {\n    content: \"\\f320\"\n}\n\n.fa-expeditedssl:before {\n    content: \"\\f23e\"\n}\n\n.fa-external-link:before {\n    content: \"\\f08e\"\n}\n\n.fa-external-link-alt:before {\n    content: \"\\f35d\"\n}\n\n.fa-external-link-square:before {\n    content: \"\\f14c\"\n}\n\n.fa-external-link-square-alt:before {\n    content: \"\\f360\"\n}\n\n.fa-eye:before {\n    content: \"\\f06e\"\n}\n\n.fa-eye-dropper:before {\n    content: \"\\f1fb\"\n}\n\n.fa-eye-evil:before {\n    content: \"\\f6db\"\n}\n\n.fa-eye-slash:before {\n    content: \"\\f070\"\n}\n\n.fa-facebook:before {\n    content: \"\\f09a\"\n}\n\n.fa-facebook-f:before {\n    content: \"\\f39e\"\n}\n\n.fa-facebook-messenger:before {\n    content: \"\\f39f\"\n}\n\n.fa-facebook-square:before {\n    content: \"\\f082\"\n}\n\n.fa-fantasy-flight-games:before {\n    content: \"\\f6dc\"\n}\n\n.fa-fast-backward:before {\n    content: \"\\f049\"\n}\n\n.fa-fast-forward:before {\n    content: \"\\f050\"\n}\n\n.fa-fax:before {\n    content: \"\\f1ac\"\n}\n\n.fa-feather:before {\n    content: \"\\f52d\"\n}\n\n.fa-feather-alt:before {\n    content: \"\\f56b\"\n}\n\n.fa-female:before {\n    content: \"\\f182\"\n}\n\n.fa-field-hockey:before {\n    content: \"\\f44c\"\n}\n\n.fa-fighter-jet:before {\n    content: \"\\f0fb\"\n}\n\n.fa-file:before {\n    content: \"\\f15b\"\n}\n\n.fa-file-alt:before {\n    content: \"\\f15c\"\n}\n\n.fa-file-archive:before {\n    content: \"\\f1c6\"\n}\n\n.fa-file-audio:before {\n    content: \"\\f1c7\"\n}\n\n.fa-file-certificate:before {\n    content: \"\\f5f3\"\n}\n\n.fa-file-chart-line:before {\n    content: \"\\f659\"\n}\n\n.fa-file-chart-pie:before {\n    content: \"\\f65a\"\n}\n\n.fa-file-check:before {\n    content: \"\\f316\"\n}\n\n.fa-file-code:before {\n    content: \"\\f1c9\"\n}\n\n.fa-file-contract:before {\n    content: \"\\f56c\"\n}\n\n.fa-file-csv:before {\n    content: \"\\f6dd\"\n}\n\n.fa-file-download:before {\n    content: \"\\f56d\"\n}\n\n.fa-file-edit:before {\n    content: \"\\f31c\"\n}\n\n.fa-file-excel:before {\n    content: \"\\f1c3\"\n}\n\n.fa-file-exclamation:before {\n    content: \"\\f31a\"\n}\n\n.fa-file-export:before {\n    content: \"\\f56e\"\n}\n\n.fa-file-image:before {\n    content: \"\\f1c5\"\n}\n\n.fa-file-import:before {\n    content: \"\\f56f\"\n}\n\n.fa-file-invoice:before {\n    content: \"\\f570\"\n}\n\n.fa-file-invoice-dollar:before {\n    content: \"\\f571\"\n}\n\n.fa-file-medical:before {\n    content: \"\\f477\"\n}\n\n.fa-file-medical-alt:before {\n    content: \"\\f478\"\n}\n\n.fa-file-minus:before {\n    content: \"\\f318\"\n}\n\n.fa-file-pdf:before {\n    content: \"\\f1c1\"\n}\n\n.fa-file-plus:before {\n    content: \"\\f319\"\n}\n\n.fa-file-powerpoint:before {\n    content: \"\\f1c4\"\n}\n\n.fa-file-prescription:before {\n    content: \"\\f572\"\n}\n\n.fa-file-signature:before {\n    content: \"\\f573\"\n}\n\n.fa-file-spreadsheet:before {\n    content: \"\\f65b\"\n}\n\n.fa-file-times:before {\n    content: \"\\f317\"\n}\n\n.fa-file-upload:before {\n    content: \"\\f574\"\n}\n\n.fa-file-user:before {\n    content: \"\\f65c\"\n}\n\n.fa-file-video:before {\n    content: \"\\f1c8\"\n}\n\n.fa-file-word:before {\n    content: \"\\f1c2\"\n}\n\n.fa-fill:before {\n    content: \"\\f575\"\n}\n\n.fa-fill-drip:before {\n    content: \"\\f576\"\n}\n\n.fa-film:before {\n    content: \"\\f008\"\n}\n\n.fa-film-alt:before {\n    content: \"\\f3a0\"\n}\n\n.fa-filter:before {\n    content: \"\\f0b0\"\n}\n\n.fa-fingerprint:before {\n    content: \"\\f577\"\n}\n\n.fa-fire:before {\n    content: \"\\f06d\"\n}\n\n.fa-fire-extinguisher:before {\n    content: \"\\f134\"\n}\n\n.fa-fire-smoke:before {\n    content: \"\\f74b\"\n}\n\n.fa-firefox:before {\n    content: \"\\f269\"\n}\n\n.fa-first-aid:before {\n    content: \"\\f479\"\n}\n\n.fa-first-order:before {\n    content: \"\\f2b0\"\n}\n\n.fa-first-order-alt:before {\n    content: \"\\f50a\"\n}\n\n.fa-firstdraft:before {\n    content: \"\\f3a1\"\n}\n\n.fa-fish:before {\n    content: \"\\f578\"\n}\n\n.fa-fist-raised:before {\n    content: \"\\f6de\"\n}\n\n.fa-flag:before {\n    content: \"\\f024\"\n}\n\n.fa-flag-alt:before {\n    content: \"\\f74c\"\n}\n\n.fa-flag-checkered:before {\n    content: \"\\f11e\"\n}\n\n.fa-flag-usa:before {\n    content: \"\\f74d\"\n}\n\n.fa-flame:before {\n    content: \"\\f6df\"\n}\n\n.fa-flask:before {\n    content: \"\\f0c3\"\n}\n\n.fa-flask-poison:before {\n    content: \"\\f6e0\"\n}\n\n.fa-flask-potion:before {\n    content: \"\\f6e1\"\n}\n\n.fa-flickr:before {\n    content: \"\\f16e\"\n}\n\n.fa-flipboard:before {\n    content: \"\\f44d\"\n}\n\n.fa-flushed:before {\n    content: \"\\f579\"\n}\n\n.fa-fly:before {\n    content: \"\\f417\"\n}\n\n.fa-fog:before {\n    content: \"\\f74e\"\n}\n\n.fa-folder:before {\n    content: \"\\f07b\"\n}\n\n.fa-folder-minus:before {\n    content: \"\\f65d\"\n}\n\n.fa-folder-open:before {\n    content: \"\\f07c\"\n}\n\n.fa-folder-plus:before {\n    content: \"\\f65e\"\n}\n\n.fa-folder-times:before {\n    content: \"\\f65f\"\n}\n\n.fa-folders:before {\n    content: \"\\f660\"\n}\n\n.fa-font:before {\n    content: \"\\f031\"\n}\n\n.fa-font-awesome:before {\n    content: \"\\f2b4\"\n}\n\n.fa-font-awesome-alt:before {\n    content: \"\\f35c\"\n}\n\n.fa-font-awesome-flag:before {\n    content: \"\\f425\"\n}\n\n.fa-font-awesome-logo-full:before {\n    content: \"\\f4e6\"\n}\n\n.fa-fonticons:before {\n    content: \"\\f280\"\n}\n\n.fa-fonticons-fi:before {\n    content: \"\\f3a2\"\n}\n\n.fa-football-ball:before {\n    content: \"\\f44e\"\n}\n\n.fa-football-helmet:before {\n    content: \"\\f44f\"\n}\n\n.fa-forklift:before {\n    content: \"\\f47a\"\n}\n\n.fa-fort-awesome:before {\n    content: \"\\f286\"\n}\n\n.fa-fort-awesome-alt:before {\n    content: \"\\f3a3\"\n}\n\n.fa-forumbee:before {\n    content: \"\\f211\"\n}\n\n.fa-forward:before {\n    content: \"\\f04e\"\n}\n\n.fa-foursquare:before {\n    content: \"\\f180\"\n}\n\n.fa-fragile:before {\n    content: \"\\f4bb\"\n}\n\n.fa-free-code-camp:before {\n    content: \"\\f2c5\"\n}\n\n.fa-freebsd:before {\n    content: \"\\f3a4\"\n}\n\n.fa-frog:before {\n    content: \"\\f52e\"\n}\n\n.fa-frown:before {\n    content: \"\\f119\"\n}\n\n.fa-frown-open:before {\n    content: \"\\f57a\"\n}\n\n.fa-fulcrum:before {\n    content: \"\\f50b\"\n}\n\n.fa-function:before {\n    content: \"\\f661\"\n}\n\n.fa-funnel-dollar:before {\n    content: \"\\f662\"\n}\n\n.fa-futbol:before {\n    content: \"\\f1e3\"\n}\n\n.fa-galactic-republic:before {\n    content: \"\\f50c\"\n}\n\n.fa-galactic-senate:before {\n    content: \"\\f50d\"\n}\n\n.fa-gamepad:before {\n    content: \"\\f11b\"\n}\n\n.fa-gas-pump:before {\n    content: \"\\f52f\"\n}\n\n.fa-gas-pump-slash:before {\n    content: \"\\f5f4\"\n}\n\n.fa-gavel:before {\n    content: \"\\f0e3\"\n}\n\n.fa-gem:before {\n    content: \"\\f3a5\"\n}\n\n.fa-genderless:before {\n    content: \"\\f22d\"\n}\n\n.fa-get-pocket:before {\n    content: \"\\f265\"\n}\n\n.fa-gg:before {\n    content: \"\\f260\"\n}\n\n.fa-gg-circle:before {\n    content: \"\\f261\"\n}\n\n.fa-ghost:before {\n    content: \"\\f6e2\"\n}\n\n.fa-gift:before {\n    content: \"\\f06b\"\n}\n\n.fa-gift-card:before {\n    content: \"\\f663\"\n}\n\n.fa-git:before {\n    content: \"\\f1d3\"\n}\n\n.fa-git-square:before {\n    content: \"\\f1d2\"\n}\n\n.fa-github:before {\n    content: \"\\f09b\"\n}\n\n.fa-github-alt:before {\n    content: \"\\f113\"\n}\n\n.fa-github-square:before {\n    content: \"\\f092\"\n}\n\n.fa-gitkraken:before {\n    content: \"\\f3a6\"\n}\n\n.fa-gitlab:before {\n    content: \"\\f296\"\n}\n\n.fa-gitter:before {\n    content: \"\\f426\"\n}\n\n.fa-glass-martini:before {\n    content: \"\\f000\"\n}\n\n.fa-glass-martini-alt:before {\n    content: \"\\f57b\"\n}\n\n.fa-glasses:before {\n    content: \"\\f530\"\n}\n\n.fa-glasses-alt:before {\n    content: \"\\f5f5\"\n}\n\n.fa-glide:before {\n    content: \"\\f2a5\"\n}\n\n.fa-glide-g:before {\n    content: \"\\f2a6\"\n}\n\n.fa-globe:before {\n    content: \"\\f0ac\"\n}\n\n.fa-globe-africa:before {\n    content: \"\\f57c\"\n}\n\n.fa-globe-americas:before {\n    content: \"\\f57d\"\n}\n\n.fa-globe-asia:before {\n    content: \"\\f57e\"\n}\n\n.fa-globe-stand:before {\n    content: \"\\f5f6\"\n}\n\n.fa-gofore:before {\n    content: \"\\f3a7\"\n}\n\n.fa-golf-ball:before {\n    content: \"\\f450\"\n}\n\n.fa-golf-club:before {\n    content: \"\\f451\"\n}\n\n.fa-goodreads:before {\n    content: \"\\f3a8\"\n}\n\n.fa-goodreads-g:before {\n    content: \"\\f3a9\"\n}\n\n.fa-google:before {\n    content: \"\\f1a0\"\n}\n\n.fa-google-drive:before {\n    content: \"\\f3aa\"\n}\n\n.fa-google-play:before {\n    content: \"\\f3ab\"\n}\n\n.fa-google-plus:before {\n    content: \"\\f2b3\"\n}\n\n.fa-google-plus-g:before {\n    content: \"\\f0d5\"\n}\n\n.fa-google-plus-square:before {\n    content: \"\\f0d4\"\n}\n\n.fa-google-wallet:before {\n    content: \"\\f1ee\"\n}\n\n.fa-gopuram:before {\n    content: \"\\f664\"\n}\n\n.fa-graduation-cap:before {\n    content: \"\\f19d\"\n}\n\n.fa-gratipay:before {\n    content: \"\\f184\"\n}\n\n.fa-grav:before {\n    content: \"\\f2d6\"\n}\n\n.fa-greater-than:before {\n    content: \"\\f531\"\n}\n\n.fa-greater-than-equal:before {\n    content: \"\\f532\"\n}\n\n.fa-grimace:before {\n    content: \"\\f57f\"\n}\n\n.fa-grin:before {\n    content: \"\\f580\"\n}\n\n.fa-grin-alt:before {\n    content: \"\\f581\"\n}\n\n.fa-grin-beam:before {\n    content: \"\\f582\"\n}\n\n.fa-grin-beam-sweat:before {\n    content: \"\\f583\"\n}\n\n.fa-grin-hearts:before {\n    content: \"\\f584\"\n}\n\n.fa-grin-squint:before {\n    content: \"\\f585\"\n}\n\n.fa-grin-squint-tears:before {\n    content: \"\\f586\"\n}\n\n.fa-grin-stars:before {\n    content: \"\\f587\"\n}\n\n.fa-grin-tears:before {\n    content: \"\\f588\"\n}\n\n.fa-grin-tongue:before {\n    content: \"\\f589\"\n}\n\n.fa-grin-tongue-squint:before {\n    content: \"\\f58a\"\n}\n\n.fa-grin-tongue-wink:before {\n    content: \"\\f58b\"\n}\n\n.fa-grin-wink:before {\n    content: \"\\f58c\"\n}\n\n.fa-grip-horizontal:before {\n    content: \"\\f58d\"\n}\n\n.fa-grip-vertical:before {\n    content: \"\\f58e\"\n}\n\n.fa-gripfire:before {\n    content: \"\\f3ac\"\n}\n\n.fa-grunt:before {\n    content: \"\\f3ad\"\n}\n\n.fa-gulp:before {\n    content: \"\\f3ae\"\n}\n\n.fa-h-square:before {\n    content: \"\\f0fd\"\n}\n\n.fa-h1:before {\n    content: \"\\f313\"\n}\n\n.fa-h2:before {\n    content: \"\\f314\"\n}\n\n.fa-h3:before {\n    content: \"\\f315\"\n}\n\n.fa-hacker-news:before {\n    content: \"\\f1d4\"\n}\n\n.fa-hacker-news-square:before {\n    content: \"\\f3af\"\n}\n\n.fa-hackerrank:before {\n    content: \"\\f5f7\"\n}\n\n.fa-hammer:before {\n    content: \"\\f6e3\"\n}\n\n.fa-hammer-war:before {\n    content: \"\\f6e4\"\n}\n\n.fa-hamsa:before {\n    content: \"\\f665\"\n}\n\n.fa-hand-heart:before {\n    content: \"\\f4bc\"\n}\n\n.fa-hand-holding:before {\n    content: \"\\f4bd\"\n}\n\n.fa-hand-holding-box:before {\n    content: \"\\f47b\"\n}\n\n.fa-hand-holding-heart:before {\n    content: \"\\f4be\"\n}\n\n.fa-hand-holding-magic:before {\n    content: \"\\f6e5\"\n}\n\n.fa-hand-holding-seedling:before {\n    content: \"\\f4bf\"\n}\n\n.fa-hand-holding-usd:before {\n    content: \"\\f4c0\"\n}\n\n.fa-hand-holding-water:before {\n    content: \"\\f4c1\"\n}\n\n.fa-hand-lizard:before {\n    content: \"\\f258\"\n}\n\n.fa-hand-paper:before {\n    content: \"\\f256\"\n}\n\n.fa-hand-peace:before {\n    content: \"\\f25b\"\n}\n\n.fa-hand-point-down:before {\n    content: \"\\f0a7\"\n}\n\n.fa-hand-point-left:before {\n    content: \"\\f0a5\"\n}\n\n.fa-hand-point-right:before {\n    content: \"\\f0a4\"\n}\n\n.fa-hand-point-up:before {\n    content: \"\\f0a6\"\n}\n\n.fa-hand-pointer:before {\n    content: \"\\f25a\"\n}\n\n.fa-hand-receiving:before {\n    content: \"\\f47c\"\n}\n\n.fa-hand-rock:before {\n    content: \"\\f255\"\n}\n\n.fa-hand-scissors:before {\n    content: \"\\f257\"\n}\n\n.fa-hand-spock:before {\n    content: \"\\f259\"\n}\n\n.fa-hands:before {\n    content: \"\\f4c2\"\n}\n\n.fa-hands-heart:before {\n    content: \"\\f4c3\"\n}\n\n.fa-hands-helping:before {\n    content: \"\\f4c4\"\n}\n\n.fa-hands-usd:before {\n    content: \"\\f4c5\"\n}\n\n.fa-handshake:before {\n    content: \"\\f2b5\"\n}\n\n.fa-handshake-alt:before {\n    content: \"\\f4c6\"\n}\n\n.fa-hanukiah:before {\n    content: \"\\f6e6\"\n}\n\n.fa-hashtag:before {\n    content: \"\\f292\"\n}\n\n.fa-hat-witch:before {\n    content: \"\\f6e7\"\n}\n\n.fa-hat-wizard:before {\n    content: \"\\f6e8\"\n}\n\n.fa-haykal:before {\n    content: \"\\f666\"\n}\n\n.fa-hdd:before {\n    content: \"\\f0a0\"\n}\n\n.fa-head-side:before {\n    content: \"\\f6e9\"\n}\n\n.fa-head-vr:before {\n    content: \"\\f6ea\"\n}\n\n.fa-heading:before {\n    content: \"\\f1dc\"\n}\n\n.fa-headphones:before {\n    content: \"\\f025\"\n}\n\n.fa-headphones-alt:before {\n    content: \"\\f58f\"\n}\n\n.fa-headset:before {\n    content: \"\\f590\"\n}\n\n.fa-heart:before {\n    content: \"\\f004\"\n}\n\n.fa-heart-circle:before {\n    content: \"\\f4c7\"\n}\n\n.fa-heart-rate:before {\n    content: \"\\f5f8\"\n}\n\n.fa-heart-square:before {\n    content: \"\\f4c8\"\n}\n\n.fa-heartbeat:before {\n    content: \"\\f21e\"\n}\n\n.fa-helicopter:before {\n    content: \"\\f533\"\n}\n\n.fa-helmet-battle:before {\n    content: \"\\f6eb\"\n}\n\n.fa-hexagon:before {\n    content: \"\\f312\"\n}\n\n.fa-highlighter:before {\n    content: \"\\f591\"\n}\n\n.fa-hiking:before {\n    content: \"\\f6ec\"\n}\n\n.fa-hippo:before {\n    content: \"\\f6ed\"\n}\n\n.fa-hips:before {\n    content: \"\\f452\"\n}\n\n.fa-hire-a-helper:before {\n    content: \"\\f3b0\"\n}\n\n.fa-history:before {\n    content: \"\\f1da\"\n}\n\n.fa-hockey-mask:before {\n    content: \"\\f6ee\"\n}\n\n.fa-hockey-puck:before {\n    content: \"\\f453\"\n}\n\n.fa-hockey-sticks:before {\n    content: \"\\f454\"\n}\n\n.fa-home:before {\n    content: \"\\f015\"\n}\n\n.fa-home-heart:before {\n    content: \"\\f4c9\"\n}\n\n.fa-hood-cloak:before {\n    content: \"\\f6ef\"\n}\n\n.fa-hooli:before {\n    content: \"\\f427\"\n}\n\n.fa-hornbill:before {\n    content: \"\\f592\"\n}\n\n.fa-horse:before {\n    content: \"\\f6f0\"\n}\n\n.fa-hospital:before {\n    content: \"\\f0f8\"\n}\n\n.fa-hospital-alt:before {\n    content: \"\\f47d\"\n}\n\n.fa-hospital-symbol:before {\n    content: \"\\f47e\"\n}\n\n.fa-hot-tub:before {\n    content: \"\\f593\"\n}\n\n.fa-hotel:before {\n    content: \"\\f594\"\n}\n\n.fa-hotjar:before {\n    content: \"\\f3b1\"\n}\n\n.fa-hourglass:before {\n    content: \"\\f254\"\n}\n\n.fa-hourglass-end:before {\n    content: \"\\f253\"\n}\n\n.fa-hourglass-half:before {\n    content: \"\\f252\"\n}\n\n.fa-hourglass-start:before {\n    content: \"\\f251\"\n}\n\n.fa-house-damage:before {\n    content: \"\\f6f1\"\n}\n\n.fa-house-flood:before {\n    content: \"\\f74f\"\n}\n\n.fa-houzz:before {\n    content: \"\\f27c\"\n}\n\n.fa-hryvnia:before {\n    content: \"\\f6f2\"\n}\n\n.fa-html5:before {\n    content: \"\\f13b\"\n}\n\n.fa-hubspot:before {\n    content: \"\\f3b2\"\n}\n\n.fa-humidity:before {\n    content: \"\\f750\"\n}\n\n.fa-hurricane:before {\n    content: \"\\f751\"\n}\n\n.fa-i-cursor:before {\n    content: \"\\f246\"\n}\n\n.fa-id-badge:before {\n    content: \"\\f2c1\"\n}\n\n.fa-id-card:before {\n    content: \"\\f2c2\"\n}\n\n.fa-id-card-alt:before {\n    content: \"\\f47f\"\n}\n\n.fa-image:before {\n    content: \"\\f03e\"\n}\n\n.fa-images:before {\n    content: \"\\f302\"\n}\n\n.fa-imdb:before {\n    content: \"\\f2d8\"\n}\n\n.fa-inbox:before {\n    content: \"\\f01c\"\n}\n\n.fa-inbox-in:before {\n    content: \"\\f310\"\n}\n\n.fa-inbox-out:before {\n    content: \"\\f311\"\n}\n\n.fa-indent:before {\n    content: \"\\f03c\"\n}\n\n.fa-industry:before {\n    content: \"\\f275\"\n}\n\n.fa-industry-alt:before {\n    content: \"\\f3b3\"\n}\n\n.fa-infinity:before {\n    content: \"\\f534\"\n}\n\n.fa-info:before {\n    content: \"\\f129\"\n}\n\n.fa-info-circle:before {\n    content: \"\\f05a\"\n}\n\n.fa-info-square:before {\n    content: \"\\f30f\"\n}\n\n.fa-inhaler:before {\n    content: \"\\f5f9\"\n}\n\n.fa-instagram:before {\n    content: \"\\f16d\"\n}\n\n.fa-integral:before {\n    content: \"\\f667\"\n}\n\n.fa-internet-explorer:before {\n    content: \"\\f26b\"\n}\n\n.fa-intersection:before {\n    content: \"\\f668\"\n}\n\n.fa-inventory:before {\n    content: \"\\f480\"\n}\n\n.fa-ioxhost:before {\n    content: \"\\f208\"\n}\n\n.fa-italic:before {\n    content: \"\\f033\"\n}\n\n.fa-itunes:before {\n    content: \"\\f3b4\"\n}\n\n.fa-itunes-note:before {\n    content: \"\\f3b5\"\n}\n\n.fa-jack-o-lantern:before {\n    content: \"\\f30e\"\n}\n\n.fa-java:before {\n    content: \"\\f4e4\"\n}\n\n.fa-jedi:before {\n    content: \"\\f669\"\n}\n\n.fa-jedi-order:before {\n    content: \"\\f50e\"\n}\n\n.fa-jenkins:before {\n    content: \"\\f3b6\"\n}\n\n.fa-joget:before {\n    content: \"\\f3b7\"\n}\n\n.fa-joint:before {\n    content: \"\\f595\"\n}\n\n.fa-joomla:before {\n    content: \"\\f1aa\"\n}\n\n.fa-journal-whills:before {\n    content: \"\\f66a\"\n}\n\n.fa-js:before {\n    content: \"\\f3b8\"\n}\n\n.fa-js-square:before {\n    content: \"\\f3b9\"\n}\n\n.fa-jsfiddle:before {\n    content: \"\\f1cc\"\n}\n\n.fa-kaaba:before {\n    content: \"\\f66b\"\n}\n\n.fa-kaggle:before {\n    content: \"\\f5fa\"\n}\n\n.fa-key:before {\n    content: \"\\f084\"\n}\n\n.fa-key-skeleton:before {\n    content: \"\\f6f3\"\n}\n\n.fa-keybase:before {\n    content: \"\\f4f5\"\n}\n\n.fa-keyboard:before {\n    content: \"\\f11c\"\n}\n\n.fa-keycdn:before {\n    content: \"\\f3ba\"\n}\n\n.fa-keynote:before {\n    content: \"\\f66c\"\n}\n\n.fa-khanda:before {\n    content: \"\\f66d\"\n}\n\n.fa-kickstarter:before {\n    content: \"\\f3bb\"\n}\n\n.fa-kickstarter-k:before {\n    content: \"\\f3bc\"\n}\n\n.fa-kidneys:before {\n    content: \"\\f5fb\"\n}\n\n.fa-kiss:before {\n    content: \"\\f596\"\n}\n\n.fa-kiss-beam:before {\n    content: \"\\f597\"\n}\n\n.fa-kiss-wink-heart:before {\n    content: \"\\f598\"\n}\n\n.fa-kite:before {\n    content: \"\\f6f4\"\n}\n\n.fa-kiwi-bird:before {\n    content: \"\\f535\"\n}\n\n.fa-knife-kitchen:before {\n    content: \"\\f6f5\"\n}\n\n.fa-korvue:before {\n    content: \"\\f42f\"\n}\n\n.fa-lambda:before {\n    content: \"\\f66e\"\n}\n\n.fa-lamp:before {\n    content: \"\\f4ca\"\n}\n\n.fa-landmark:before {\n    content: \"\\f66f\"\n}\n\n.fa-landmark-alt:before {\n    content: \"\\f752\"\n}\n\n.fa-language:before {\n    content: \"\\f1ab\"\n}\n\n.fa-laptop:before {\n    content: \"\\f109\"\n}\n\n.fa-laptop-code:before {\n    content: \"\\f5fc\"\n}\n\n.fa-laravel:before {\n    content: \"\\f3bd\"\n}\n\n.fa-lastfm:before {\n    content: \"\\f202\"\n}\n\n.fa-lastfm-square:before {\n    content: \"\\f203\"\n}\n\n.fa-laugh:before {\n    content: \"\\f599\"\n}\n\n.fa-laugh-beam:before {\n    content: \"\\f59a\"\n}\n\n.fa-laugh-squint:before {\n    content: \"\\f59b\"\n}\n\n.fa-laugh-wink:before {\n    content: \"\\f59c\"\n}\n\n.fa-layer-group:before {\n    content: \"\\f5fd\"\n}\n\n.fa-layer-minus:before {\n    content: \"\\f5fe\"\n}\n\n.fa-layer-plus:before {\n    content: \"\\f5ff\"\n}\n\n.fa-leaf:before {\n    content: \"\\f06c\"\n}\n\n.fa-leaf-heart:before {\n    content: \"\\f4cb\"\n}\n\n.fa-leaf-maple:before {\n    content: \"\\f6f6\"\n}\n\n.fa-leaf-oak:before {\n    content: \"\\f6f7\"\n}\n\n.fa-leanpub:before {\n    content: \"\\f212\"\n}\n\n.fa-lemon:before {\n    content: \"\\f094\"\n}\n\n.fa-less:before {\n    content: \"\\f41d\"\n}\n\n.fa-less-than:before {\n    content: \"\\f536\"\n}\n\n.fa-less-than-equal:before {\n    content: \"\\f537\"\n}\n\n.fa-level-down:before {\n    content: \"\\f149\"\n}\n\n.fa-level-down-alt:before {\n    content: \"\\f3be\"\n}\n\n.fa-level-up:before {\n    content: \"\\f148\"\n}\n\n.fa-level-up-alt:before {\n    content: \"\\f3bf\"\n}\n\n.fa-life-ring:before {\n    content: \"\\f1cd\"\n}\n\n.fa-lightbulb:before {\n    content: \"\\f0eb\"\n}\n\n.fa-lightbulb-dollar:before {\n    content: \"\\f670\"\n}\n\n.fa-lightbulb-exclamation:before {\n    content: \"\\f671\"\n}\n\n.fa-lightbulb-on:before {\n    content: \"\\f672\"\n}\n\n.fa-lightbulb-slash:before {\n    content: \"\\f673\"\n}\n\n.fa-line:before {\n    content: \"\\f3c0\"\n}\n\n.fa-link:before {\n    content: \"\\f0c1\"\n}\n\n.fa-linkedin:before {\n    content: \"\\f08c\"\n}\n\n.fa-linkedin-in:before {\n    content: \"\\f0e1\"\n}\n\n.fa-linode:before {\n    content: \"\\f2b8\"\n}\n\n.fa-linux:before {\n    content: \"\\f17c\"\n}\n\n.fa-lips:before {\n    content: \"\\f600\"\n}\n\n.fa-lira-sign:before {\n    content: \"\\f195\"\n}\n\n.fa-list:before {\n    content: \"\\f03a\"\n}\n\n.fa-list-alt:before {\n    content: \"\\f022\"\n}\n\n.fa-list-ol:before {\n    content: \"\\f0cb\"\n}\n\n.fa-list-ul:before {\n    content: \"\\f0ca\"\n}\n\n.fa-location:before {\n    content: \"\\f601\"\n}\n\n.fa-location-arrow:before {\n    content: \"\\f124\"\n}\n\n.fa-location-circle:before {\n    content: \"\\f602\"\n}\n\n.fa-location-slash:before {\n    content: \"\\f603\"\n}\n\n.fa-lock:before {\n    content: \"\\f023\"\n}\n\n.fa-lock-alt:before {\n    content: \"\\f30d\"\n}\n\n.fa-lock-open:before {\n    content: \"\\f3c1\"\n}\n\n.fa-lock-open-alt:before {\n    content: \"\\f3c2\"\n}\n\n.fa-long-arrow-alt-down:before {\n    content: \"\\f309\"\n}\n\n.fa-long-arrow-alt-left:before {\n    content: \"\\f30a\"\n}\n\n.fa-long-arrow-alt-right:before {\n    content: \"\\f30b\"\n}\n\n.fa-long-arrow-alt-up:before {\n    content: \"\\f30c\"\n}\n\n.fa-long-arrow-down:before {\n    content: \"\\f175\"\n}\n\n.fa-long-arrow-left:before {\n    content: \"\\f177\"\n}\n\n.fa-long-arrow-right:before {\n    content: \"\\f178\"\n}\n\n.fa-long-arrow-up:before {\n    content: \"\\f176\"\n}\n\n.fa-loveseat:before {\n    content: \"\\f4cc\"\n}\n\n.fa-low-vision:before {\n    content: \"\\f2a8\"\n}\n\n.fa-luchador:before {\n    content: \"\\f455\"\n}\n\n.fa-luggage-cart:before {\n    content: \"\\f59d\"\n}\n\n.fa-lungs:before {\n    content: \"\\f604\"\n}\n\n.fa-lyft:before {\n    content: \"\\f3c3\"\n}\n\n.fa-mace:before {\n    content: \"\\f6f8\"\n}\n\n.fa-magento:before {\n    content: \"\\f3c4\"\n}\n\n.fa-magic:before {\n    content: \"\\f0d0\"\n}\n\n.fa-magnet:before {\n    content: \"\\f076\"\n}\n\n.fa-mail-bulk:before {\n    content: \"\\f674\"\n}\n\n.fa-mailchimp:before {\n    content: \"\\f59e\"\n}\n\n.fa-male:before {\n    content: \"\\f183\"\n}\n\n.fa-mandalorian:before {\n    content: \"\\f50f\"\n}\n\n.fa-mandolin:before {\n    content: \"\\f6f9\"\n}\n\n.fa-map:before {\n    content: \"\\f279\"\n}\n\n.fa-map-marked:before {\n    content: \"\\f59f\"\n}\n\n.fa-map-marked-alt:before {\n    content: \"\\f5a0\"\n}\n\n.fa-map-marker:before {\n    content: \"\\f041\"\n}\n\n.fa-map-marker-alt:before {\n    content: \"\\f3c5\"\n}\n\n.fa-map-marker-alt-slash:before {\n    content: \"\\f605\"\n}\n\n.fa-map-marker-check:before {\n    content: \"\\f606\"\n}\n\n.fa-map-marker-edit:before {\n    content: \"\\f607\"\n}\n\n.fa-map-marker-exclamation:before {\n    content: \"\\f608\"\n}\n\n.fa-map-marker-minus:before {\n    content: \"\\f609\"\n}\n\n.fa-map-marker-plus:before {\n    content: \"\\f60a\"\n}\n\n.fa-map-marker-question:before {\n    content: \"\\f60b\"\n}\n\n.fa-map-marker-slash:before {\n    content: \"\\f60c\"\n}\n\n.fa-map-marker-smile:before {\n    content: \"\\f60d\"\n}\n\n.fa-map-marker-times:before {\n    content: \"\\f60e\"\n}\n\n.fa-map-pin:before {\n    content: \"\\f276\"\n}\n\n.fa-map-signs:before {\n    content: \"\\f277\"\n}\n\n.fa-markdown:before {\n    content: \"\\f60f\"\n}\n\n.fa-marker:before {\n    content: \"\\f5a1\"\n}\n\n.fa-mars:before {\n    content: \"\\f222\"\n}\n\n.fa-mars-double:before {\n    content: \"\\f227\"\n}\n\n.fa-mars-stroke:before {\n    content: \"\\f229\"\n}\n\n.fa-mars-stroke-h:before {\n    content: \"\\f22b\"\n}\n\n.fa-mars-stroke-v:before {\n    content: \"\\f22a\"\n}\n\n.fa-mask:before {\n    content: \"\\f6fa\"\n}\n\n.fa-mastodon:before {\n    content: \"\\f4f6\"\n}\n\n.fa-maxcdn:before {\n    content: \"\\f136\"\n}\n\n.fa-medal:before {\n    content: \"\\f5a2\"\n}\n\n.fa-medapps:before {\n    content: \"\\f3c6\"\n}\n\n.fa-medium:before {\n    content: \"\\f23a\"\n}\n\n.fa-medium-m:before {\n    content: \"\\f3c7\"\n}\n\n.fa-medkit:before {\n    content: \"\\f0fa\"\n}\n\n.fa-medrt:before {\n    content: \"\\f3c8\"\n}\n\n.fa-meetup:before {\n    content: \"\\f2e0\"\n}\n\n.fa-megaphone:before {\n    content: \"\\f675\"\n}\n\n.fa-megaport:before {\n    content: \"\\f5a3\"\n}\n\n.fa-meh:before {\n    content: \"\\f11a\"\n}\n\n.fa-meh-blank:before {\n    content: \"\\f5a4\"\n}\n\n.fa-meh-rolling-eyes:before {\n    content: \"\\f5a5\"\n}\n\n.fa-memory:before {\n    content: \"\\f538\"\n}\n\n.fa-menorah:before {\n    content: \"\\f676\"\n}\n\n.fa-mercury:before {\n    content: \"\\f223\"\n}\n\n.fa-meteor:before {\n    content: \"\\f753\"\n}\n\n.fa-microchip:before {\n    content: \"\\f2db\"\n}\n\n.fa-microphone:before {\n    content: \"\\f130\"\n}\n\n.fa-microphone-alt:before {\n    content: \"\\f3c9\"\n}\n\n.fa-microphone-alt-slash:before {\n    content: \"\\f539\"\n}\n\n.fa-microphone-slash:before {\n    content: \"\\f131\"\n}\n\n.fa-microscope:before {\n    content: \"\\f610\"\n}\n\n.fa-microsoft:before {\n    content: \"\\f3ca\"\n}\n\n.fa-mind-share:before {\n    content: \"\\f677\"\n}\n\n.fa-minus:before {\n    content: \"\\f068\"\n}\n\n.fa-minus-circle:before {\n    content: \"\\f056\"\n}\n\n.fa-minus-hexagon:before {\n    content: \"\\f307\"\n}\n\n.fa-minus-octagon:before {\n    content: \"\\f308\"\n}\n\n.fa-minus-square:before {\n    content: \"\\f146\"\n}\n\n.fa-mix:before {\n    content: \"\\f3cb\"\n}\n\n.fa-mixcloud:before {\n    content: \"\\f289\"\n}\n\n.fa-mizuni:before {\n    content: \"\\f3cc\"\n}\n\n.fa-mobile:before {\n    content: \"\\f10b\"\n}\n\n.fa-mobile-alt:before {\n    content: \"\\f3cd\"\n}\n\n.fa-mobile-android:before {\n    content: \"\\f3ce\"\n}\n\n.fa-mobile-android-alt:before {\n    content: \"\\f3cf\"\n}\n\n.fa-modx:before {\n    content: \"\\f285\"\n}\n\n.fa-monero:before {\n    content: \"\\f3d0\"\n}\n\n.fa-money-bill:before {\n    content: \"\\f0d6\"\n}\n\n.fa-money-bill-alt:before {\n    content: \"\\f3d1\"\n}\n\n.fa-money-bill-wave:before {\n    content: \"\\f53a\"\n}\n\n.fa-money-bill-wave-alt:before {\n    content: \"\\f53b\"\n}\n\n.fa-money-check:before {\n    content: \"\\f53c\"\n}\n\n.fa-money-check-alt:before {\n    content: \"\\f53d\"\n}\n\n.fa-monitor-heart-rate:before {\n    content: \"\\f611\"\n}\n\n.fa-monkey:before {\n    content: \"\\f6fb\"\n}\n\n.fa-monument:before {\n    content: \"\\f5a6\"\n}\n\n.fa-moon:before {\n    content: \"\\f186\"\n}\n\n.fa-moon-cloud:before {\n    content: \"\\f754\"\n}\n\n.fa-moon-stars:before {\n    content: \"\\f755\"\n}\n\n.fa-mortar-pestle:before {\n    content: \"\\f5a7\"\n}\n\n.fa-mosque:before {\n    content: \"\\f678\"\n}\n\n.fa-motorcycle:before {\n    content: \"\\f21c\"\n}\n\n.fa-mountain:before {\n    content: \"\\f6fc\"\n}\n\n.fa-mountains:before {\n    content: \"\\f6fd\"\n}\n\n.fa-mouse-pointer:before {\n    content: \"\\f245\"\n}\n\n.fa-music:before {\n    content: \"\\f001\"\n}\n\n.fa-napster:before {\n    content: \"\\f3d2\"\n}\n\n.fa-narwhal:before {\n    content: \"\\f6fe\"\n}\n\n.fa-neos:before {\n    content: \"\\f612\"\n}\n\n.fa-network-wired:before {\n    content: \"\\f6ff\"\n}\n\n.fa-neuter:before {\n    content: \"\\f22c\"\n}\n\n.fa-newspaper:before {\n    content: \"\\f1ea\"\n}\n\n.fa-nimblr:before {\n    content: \"\\f5a8\"\n}\n\n.fa-nintendo-switch:before {\n    content: \"\\f418\"\n}\n\n.fa-node:before {\n    content: \"\\f419\"\n}\n\n.fa-node-js:before {\n    content: \"\\f3d3\"\n}\n\n.fa-not-equal:before {\n    content: \"\\f53e\"\n}\n\n.fa-notes-medical:before {\n    content: \"\\f481\"\n}\n\n.fa-npm:before {\n    content: \"\\f3d4\"\n}\n\n.fa-ns8:before {\n    content: \"\\f3d5\"\n}\n\n.fa-nutritionix:before {\n    content: \"\\f3d6\"\n}\n\n.fa-object-group:before {\n    content: \"\\f247\"\n}\n\n.fa-object-ungroup:before {\n    content: \"\\f248\"\n}\n\n.fa-octagon:before {\n    content: \"\\f306\"\n}\n\n.fa-odnoklassniki:before {\n    content: \"\\f263\"\n}\n\n.fa-odnoklassniki-square:before {\n    content: \"\\f264\"\n}\n\n.fa-oil-can:before {\n    content: \"\\f613\"\n}\n\n.fa-oil-temp:before {\n    content: \"\\f614\"\n}\n\n.fa-old-republic:before {\n    content: \"\\f510\"\n}\n\n.fa-om:before {\n    content: \"\\f679\"\n}\n\n.fa-omega:before {\n    content: \"\\f67a\"\n}\n\n.fa-opencart:before {\n    content: \"\\f23d\"\n}\n\n.fa-openid:before {\n    content: \"\\f19b\"\n}\n\n.fa-opera:before {\n    content: \"\\f26a\"\n}\n\n.fa-optin-monster:before {\n    content: \"\\f23c\"\n}\n\n.fa-osi:before {\n    content: \"\\f41a\"\n}\n\n.fa-otter:before {\n    content: \"\\f700\"\n}\n\n.fa-outdent:before {\n    content: \"\\f03b\"\n}\n\n.fa-page4:before {\n    content: \"\\f3d7\"\n}\n\n.fa-pagelines:before {\n    content: \"\\f18c\"\n}\n\n.fa-paint-brush:before {\n    content: \"\\f1fc\"\n}\n\n.fa-paint-brush-alt:before {\n    content: \"\\f5a9\"\n}\n\n.fa-paint-roller:before {\n    content: \"\\f5aa\"\n}\n\n.fa-palette:before {\n    content: \"\\f53f\"\n}\n\n.fa-palfed:before {\n    content: \"\\f3d8\"\n}\n\n.fa-pallet:before {\n    content: \"\\f482\"\n}\n\n.fa-pallet-alt:before {\n    content: \"\\f483\"\n}\n\n.fa-paper-plane:before {\n    content: \"\\f1d8\"\n}\n\n.fa-paperclip:before {\n    content: \"\\f0c6\"\n}\n\n.fa-parachute-box:before {\n    content: \"\\f4cd\"\n}\n\n.fa-paragraph:before {\n    content: \"\\f1dd\"\n}\n\n.fa-parking:before {\n    content: \"\\f540\"\n}\n\n.fa-parking-circle:before {\n    content: \"\\f615\"\n}\n\n.fa-parking-circle-slash:before {\n    content: \"\\f616\"\n}\n\n.fa-parking-slash:before {\n    content: \"\\f617\"\n}\n\n.fa-passport:before {\n    content: \"\\f5ab\"\n}\n\n.fa-pastafarianism:before {\n    content: \"\\f67b\"\n}\n\n.fa-paste:before {\n    content: \"\\f0ea\"\n}\n\n.fa-patreon:before {\n    content: \"\\f3d9\"\n}\n\n.fa-pause:before {\n    content: \"\\f04c\"\n}\n\n.fa-pause-circle:before {\n    content: \"\\f28b\"\n}\n\n.fa-paw:before {\n    content: \"\\f1b0\"\n}\n\n.fa-paw-alt:before {\n    content: \"\\f701\"\n}\n\n.fa-paw-claws:before {\n    content: \"\\f702\"\n}\n\n.fa-paypal:before {\n    content: \"\\f1ed\"\n}\n\n.fa-peace:before {\n    content: \"\\f67c\"\n}\n\n.fa-pegasus:before {\n    content: \"\\f703\"\n}\n\n.fa-pen:before {\n    content: \"\\f304\"\n}\n\n.fa-pen-alt:before {\n    content: \"\\f305\"\n}\n\n.fa-pen-fancy:before {\n    content: \"\\f5ac\"\n}\n\n.fa-pen-nib:before {\n    content: \"\\f5ad\"\n}\n\n.fa-pen-square:before {\n    content: \"\\f14b\"\n}\n\n.fa-pencil:before {\n    content: \"\\f040\"\n}\n\n.fa-pencil-alt:before {\n    content: \"\\f303\"\n}\n\n.fa-pencil-paintbrush:before {\n    content: \"\\f618\"\n}\n\n.fa-pencil-ruler:before {\n    content: \"\\f5ae\"\n}\n\n.fa-pennant:before {\n    content: \"\\f456\"\n}\n\n.fa-penny-arcade:before {\n    content: \"\\f704\"\n}\n\n.fa-people-carry:before {\n    content: \"\\f4ce\"\n}\n\n.fa-percent:before {\n    content: \"\\f295\"\n}\n\n.fa-percentage:before {\n    content: \"\\f541\"\n}\n\n.fa-periscope:before {\n    content: \"\\f3da\"\n}\n\n.fa-person-booth:before {\n    content: \"\\f756\"\n}\n\n.fa-person-carry:before {\n    content: \"\\f4cf\"\n}\n\n.fa-person-dolly:before {\n    content: \"\\f4d0\"\n}\n\n.fa-person-dolly-empty:before {\n    content: \"\\f4d1\"\n}\n\n.fa-person-sign:before {\n    content: \"\\f757\"\n}\n\n.fa-phabricator:before {\n    content: \"\\f3db\"\n}\n\n.fa-phoenix-framework:before {\n    content: \"\\f3dc\"\n}\n\n.fa-phoenix-squadron:before {\n    content: \"\\f511\"\n}\n\n.fa-phone:before {\n    content: \"\\f095\"\n}\n\n.fa-phone-office:before {\n    content: \"\\f67d\"\n}\n\n.fa-phone-plus:before {\n    content: \"\\f4d2\"\n}\n\n.fa-phone-slash:before {\n    content: \"\\f3dd\"\n}\n\n.fa-phone-square:before {\n    content: \"\\f098\"\n}\n\n.fa-phone-volume:before {\n    content: \"\\f2a0\"\n}\n\n.fa-php:before {\n    content: \"\\f457\"\n}\n\n.fa-pi:before {\n    content: \"\\f67e\"\n}\n\n.fa-pie:before {\n    content: \"\\f705\"\n}\n\n.fa-pied-piper:before {\n    content: \"\\f2ae\"\n}\n\n.fa-pied-piper-alt:before {\n    content: \"\\f1a8\"\n}\n\n.fa-pied-piper-hat:before {\n    content: \"\\f4e5\"\n}\n\n.fa-pied-piper-pp:before {\n    content: \"\\f1a7\"\n}\n\n.fa-pig:before {\n    content: \"\\f706\"\n}\n\n.fa-piggy-bank:before {\n    content: \"\\f4d3\"\n}\n\n.fa-pills:before {\n    content: \"\\f484\"\n}\n\n.fa-pinterest:before {\n    content: \"\\f0d2\"\n}\n\n.fa-pinterest-p:before {\n    content: \"\\f231\"\n}\n\n.fa-pinterest-square:before {\n    content: \"\\f0d3\"\n}\n\n.fa-place-of-worship:before {\n    content: \"\\f67f\"\n}\n\n.fa-plane:before {\n    content: \"\\f072\"\n}\n\n.fa-plane-alt:before {\n    content: \"\\f3de\"\n}\n\n.fa-plane-arrival:before {\n    content: \"\\f5af\"\n}\n\n.fa-plane-departure:before {\n    content: \"\\f5b0\"\n}\n\n.fa-play:before {\n    content: \"\\f04b\"\n}\n\n.fa-play-circle:before {\n    content: \"\\f144\"\n}\n\n.fa-playstation:before {\n    content: \"\\f3df\"\n}\n\n.fa-plug:before {\n    content: \"\\f1e6\"\n}\n\n.fa-plus:before {\n    content: \"\\f067\"\n}\n\n.fa-plus-circle:before {\n    content: \"\\f055\"\n}\n\n.fa-plus-hexagon:before {\n    content: \"\\f300\"\n}\n\n.fa-plus-octagon:before {\n    content: \"\\f301\"\n}\n\n.fa-plus-square:before {\n    content: \"\\f0fe\"\n}\n\n.fa-podcast:before {\n    content: \"\\f2ce\"\n}\n\n.fa-podium:before {\n    content: \"\\f680\"\n}\n\n.fa-podium-star:before {\n    content: \"\\f758\"\n}\n\n.fa-poll:before {\n    content: \"\\f681\"\n}\n\n.fa-poll-h:before {\n    content: \"\\f682\"\n}\n\n.fa-poll-people:before {\n    content: \"\\f759\"\n}\n\n.fa-poo:before {\n    content: \"\\f2fe\"\n}\n\n.fa-poo-storm:before {\n    content: \"\\f75a\"\n}\n\n.fa-poop:before {\n    content: \"\\f619\"\n}\n\n.fa-portrait:before {\n    content: \"\\f3e0\"\n}\n\n.fa-pound-sign:before {\n    content: \"\\f154\"\n}\n\n.fa-power-off:before {\n    content: \"\\f011\"\n}\n\n.fa-pray:before {\n    content: \"\\f683\"\n}\n\n.fa-praying-hands:before {\n    content: \"\\f684\"\n}\n\n.fa-prescription:before {\n    content: \"\\f5b1\"\n}\n\n.fa-prescription-bottle:before {\n    content: \"\\f485\"\n}\n\n.fa-prescription-bottle-alt:before {\n    content: \"\\f486\"\n}\n\n.fa-presentation:before {\n    content: \"\\f685\"\n}\n\n.fa-print:before {\n    content: \"\\f02f\"\n}\n\n.fa-print-slash:before {\n    content: \"\\f686\"\n}\n\n.fa-procedures:before {\n    content: \"\\f487\"\n}\n\n.fa-product-hunt:before {\n    content: \"\\f288\"\n}\n\n.fa-project-diagram:before {\n    content: \"\\f542\"\n}\n\n.fa-pumpkin:before {\n    content: \"\\f707\"\n}\n\n.fa-pushed:before {\n    content: \"\\f3e1\"\n}\n\n.fa-puzzle-piece:before {\n    content: \"\\f12e\"\n}\n\n.fa-python:before {\n    content: \"\\f3e2\"\n}\n\n.fa-qq:before {\n    content: \"\\f1d6\"\n}\n\n.fa-qrcode:before {\n    content: \"\\f029\"\n}\n\n.fa-question:before {\n    content: \"\\f128\"\n}\n\n.fa-question-circle:before {\n    content: \"\\f059\"\n}\n\n.fa-question-square:before {\n    content: \"\\f2fd\"\n}\n\n.fa-quidditch:before {\n    content: \"\\f458\"\n}\n\n.fa-quinscape:before {\n    content: \"\\f459\"\n}\n\n.fa-quora:before {\n    content: \"\\f2c4\"\n}\n\n.fa-quote-left:before {\n    content: \"\\f10d\"\n}\n\n.fa-quote-right:before {\n    content: \"\\f10e\"\n}\n\n.fa-quran:before {\n    content: \"\\f687\"\n}\n\n.fa-r-project:before {\n    content: \"\\f4f7\"\n}\n\n.fa-rabbit:before {\n    content: \"\\f708\"\n}\n\n.fa-rabbit-fast:before {\n    content: \"\\f709\"\n}\n\n.fa-racquet:before {\n    content: \"\\f45a\"\n}\n\n.fa-rainbow:before {\n    content: \"\\f75b\"\n}\n\n.fa-raindrops:before {\n    content: \"\\f75c\"\n}\n\n.fa-ram:before {\n    content: \"\\f70a\"\n}\n\n.fa-ramp-loading:before {\n    content: \"\\f4d4\"\n}\n\n.fa-random:before {\n    content: \"\\f074\"\n}\n\n.fa-ravelry:before {\n    content: \"\\f2d9\"\n}\n\n.fa-react:before {\n    content: \"\\f41b\"\n}\n\n.fa-reacteurope:before {\n    content: \"\\f75d\"\n}\n\n.fa-readme:before {\n    content: \"\\f4d5\"\n}\n\n.fa-rebel:before {\n    content: \"\\f1d0\"\n}\n\n.fa-receipt:before {\n    content: \"\\f543\"\n}\n\n.fa-rectangle-landscape:before {\n    content: \"\\f2fa\"\n}\n\n.fa-rectangle-portrait:before {\n    content: \"\\f2fb\"\n}\n\n.fa-rectangle-wide:before {\n    content: \"\\f2fc\"\n}\n\n.fa-recycle:before {\n    content: \"\\f1b8\"\n}\n\n.fa-red-river:before {\n    content: \"\\f3e3\"\n}\n\n.fa-reddit:before {\n    content: \"\\f1a1\"\n}\n\n.fa-reddit-alien:before {\n    content: \"\\f281\"\n}\n\n.fa-reddit-square:before {\n    content: \"\\f1a2\"\n}\n\n.fa-redo:before {\n    content: \"\\f01e\"\n}\n\n.fa-redo-alt:before {\n    content: \"\\f2f9\"\n}\n\n.fa-registered:before {\n    content: \"\\f25d\"\n}\n\n.fa-renren:before {\n    content: \"\\f18b\"\n}\n\n.fa-repeat:before {\n    content: \"\\f363\"\n}\n\n.fa-repeat-1:before {\n    content: \"\\f365\"\n}\n\n.fa-repeat-1-alt:before {\n    content: \"\\f366\"\n}\n\n.fa-repeat-alt:before {\n    content: \"\\f364\"\n}\n\n.fa-reply:before {\n    content: \"\\f3e5\"\n}\n\n.fa-reply-all:before {\n    content: \"\\f122\"\n}\n\n.fa-replyd:before {\n    content: \"\\f3e6\"\n}\n\n.fa-republican:before {\n    content: \"\\f75e\"\n}\n\n.fa-researchgate:before {\n    content: \"\\f4f8\"\n}\n\n.fa-resolving:before {\n    content: \"\\f3e7\"\n}\n\n.fa-retweet:before {\n    content: \"\\f079\"\n}\n\n.fa-retweet-alt:before {\n    content: \"\\f361\"\n}\n\n.fa-rev:before {\n    content: \"\\f5b2\"\n}\n\n.fa-ribbon:before {\n    content: \"\\f4d6\"\n}\n\n.fa-ring:before {\n    content: \"\\f70b\"\n}\n\n.fa-road:before {\n    content: \"\\f018\"\n}\n\n.fa-robot:before {\n    content: \"\\f544\"\n}\n\n.fa-rocket:before {\n    content: \"\\f135\"\n}\n\n.fa-rocketchat:before {\n    content: \"\\f3e8\"\n}\n\n.fa-rockrms:before {\n    content: \"\\f3e9\"\n}\n\n.fa-route:before {\n    content: \"\\f4d7\"\n}\n\n.fa-route-highway:before {\n    content: \"\\f61a\"\n}\n\n.fa-route-interstate:before {\n    content: \"\\f61b\"\n}\n\n.fa-rss:before {\n    content: \"\\f09e\"\n}\n\n.fa-rss-square:before {\n    content: \"\\f143\"\n}\n\n.fa-ruble-sign:before {\n    content: \"\\f158\"\n}\n\n.fa-ruler:before {\n    content: \"\\f545\"\n}\n\n.fa-ruler-combined:before {\n    content: \"\\f546\"\n}\n\n.fa-ruler-horizontal:before {\n    content: \"\\f547\"\n}\n\n.fa-ruler-triangle:before {\n    content: \"\\f61c\"\n}\n\n.fa-ruler-vertical:before {\n    content: \"\\f548\"\n}\n\n.fa-running:before {\n    content: \"\\f70c\"\n}\n\n.fa-rupee-sign:before {\n    content: \"\\f156\"\n}\n\n.fa-sad-cry:before {\n    content: \"\\f5b3\"\n}\n\n.fa-sad-tear:before {\n    content: \"\\f5b4\"\n}\n\n.fa-safari:before {\n    content: \"\\f267\"\n}\n\n.fa-sass:before {\n    content: \"\\f41e\"\n}\n\n.fa-save:before {\n    content: \"\\f0c7\"\n}\n\n.fa-scalpel:before {\n    content: \"\\f61d\"\n}\n\n.fa-scalpel-path:before {\n    content: \"\\f61e\"\n}\n\n.fa-scanner:before {\n    content: \"\\f488\"\n}\n\n.fa-scanner-keyboard:before {\n    content: \"\\f489\"\n}\n\n.fa-scanner-touchscreen:before {\n    content: \"\\f48a\"\n}\n\n.fa-scarecrow:before {\n    content: \"\\f70d\"\n}\n\n.fa-schlix:before {\n    content: \"\\f3ea\"\n}\n\n.fa-school:before {\n    content: \"\\f549\"\n}\n\n.fa-screwdriver:before {\n    content: \"\\f54a\"\n}\n\n.fa-scribd:before {\n    content: \"\\f28a\"\n}\n\n.fa-scroll:before {\n    content: \"\\f70e\"\n}\n\n.fa-scroll-old:before {\n    content: \"\\f70f\"\n}\n\n.fa-scrubber:before {\n    content: \"\\f2f8\"\n}\n\n.fa-scythe:before {\n    content: \"\\f710\"\n}\n\n.fa-search:before {\n    content: \"\\f002\"\n}\n\n.fa-search-dollar:before {\n    content: \"\\f688\"\n}\n\n.fa-search-location:before {\n    content: \"\\f689\"\n}\n\n.fa-search-minus:before {\n    content: \"\\f010\"\n}\n\n.fa-search-plus:before {\n    content: \"\\f00e\"\n}\n\n.fa-searchengin:before {\n    content: \"\\f3eb\"\n}\n\n.fa-seedling:before {\n    content: \"\\f4d8\"\n}\n\n.fa-sellcast:before {\n    content: \"\\f2da\"\n}\n\n.fa-sellsy:before {\n    content: \"\\f213\"\n}\n\n.fa-server:before {\n    content: \"\\f233\"\n}\n\n.fa-servicestack:before {\n    content: \"\\f3ec\"\n}\n\n.fa-shapes:before {\n    content: \"\\f61f\"\n}\n\n.fa-share:before {\n    content: \"\\f064\"\n}\n\n.fa-share-all:before {\n    content: \"\\f367\"\n}\n\n.fa-share-alt:before {\n    content: \"\\f1e0\"\n}\n\n.fa-share-alt-square:before {\n    content: \"\\f1e1\"\n}\n\n.fa-share-square:before {\n    content: \"\\f14d\"\n}\n\n.fa-sheep:before {\n    content: \"\\f711\"\n}\n\n.fa-shekel-sign:before {\n    content: \"\\f20b\"\n}\n\n.fa-shield:before {\n    content: \"\\f132\"\n}\n\n.fa-shield-alt:before {\n    content: \"\\f3ed\"\n}\n\n.fa-shield-check:before {\n    content: \"\\f2f7\"\n}\n\n.fa-shield-cross:before {\n    content: \"\\f712\"\n}\n\n.fa-ship:before {\n    content: \"\\f21a\"\n}\n\n.fa-shipping-fast:before {\n    content: \"\\f48b\"\n}\n\n.fa-shipping-timed:before {\n    content: \"\\f48c\"\n}\n\n.fa-shirtsinbulk:before {\n    content: \"\\f214\"\n}\n\n.fa-shoe-prints:before {\n    content: \"\\f54b\"\n}\n\n.fa-shopping-bag:before {\n    content: \"\\f290\"\n}\n\n.fa-shopping-basket:before {\n    content: \"\\f291\"\n}\n\n.fa-shopping-cart:before {\n    content: \"\\f07a\"\n}\n\n.fa-shopware:before {\n    content: \"\\f5b5\"\n}\n\n.fa-shovel:before {\n    content: \"\\f713\"\n}\n\n.fa-shower:before {\n    content: \"\\f2cc\"\n}\n\n.fa-shredder:before {\n    content: \"\\f68a\"\n}\n\n.fa-shuttle-van:before {\n    content: \"\\f5b6\"\n}\n\n.fa-shuttlecock:before {\n    content: \"\\f45b\"\n}\n\n.fa-sigma:before {\n    content: \"\\f68b\"\n}\n\n.fa-sign:before {\n    content: \"\\f4d9\"\n}\n\n.fa-sign-in:before {\n    content: \"\\f090\"\n}\n\n.fa-sign-in-alt:before {\n    content: \"\\f2f6\"\n}\n\n.fa-sign-language:before {\n    content: \"\\f2a7\"\n}\n\n.fa-sign-out:before {\n    content: \"\\f08b\"\n}\n\n.fa-sign-out-alt:before {\n    content: \"\\f2f5\"\n}\n\n.fa-signal:before {\n    content: \"\\f012\"\n}\n\n.fa-signal-1:before {\n    content: \"\\f68c\"\n}\n\n.fa-signal-2:before {\n    content: \"\\f68d\"\n}\n\n.fa-signal-3:before {\n    content: \"\\f68e\"\n}\n\n.fa-signal-4:before {\n    content: \"\\f68f\"\n}\n\n.fa-signal-alt:before {\n    content: \"\\f690\"\n}\n\n.fa-signal-alt-1:before {\n    content: \"\\f691\"\n}\n\n.fa-signal-alt-2:before {\n    content: \"\\f692\"\n}\n\n.fa-signal-alt-3:before {\n    content: \"\\f693\"\n}\n\n.fa-signal-alt-slash:before {\n    content: \"\\f694\"\n}\n\n.fa-signal-slash:before {\n    content: \"\\f695\"\n}\n\n.fa-signature:before {\n    content: \"\\f5b7\"\n}\n\n.fa-simplybuilt:before {\n    content: \"\\f215\"\n}\n\n.fa-sistrix:before {\n    content: \"\\f3ee\"\n}\n\n.fa-sitemap:before {\n    content: \"\\f0e8\"\n}\n\n.fa-sith:before {\n    content: \"\\f512\"\n}\n\n.fa-skeleton:before {\n    content: \"\\f620\"\n}\n\n.fa-skull:before {\n    content: \"\\f54c\"\n}\n\n.fa-skull-crossbones:before {\n    content: \"\\f714\"\n}\n\n.fa-skyatlas:before {\n    content: \"\\f216\"\n}\n\n.fa-skype:before {\n    content: \"\\f17e\"\n}\n\n.fa-slack:before {\n    content: \"\\f198\"\n}\n\n.fa-slack-hash:before {\n    content: \"\\f3ef\"\n}\n\n.fa-slash:before {\n    content: \"\\f715\"\n}\n\n.fa-sliders-h:before {\n    content: \"\\f1de\"\n}\n\n.fa-sliders-h-square:before {\n    content: \"\\f3f0\"\n}\n\n.fa-sliders-v:before {\n    content: \"\\f3f1\"\n}\n\n.fa-sliders-v-square:before {\n    content: \"\\f3f2\"\n}\n\n.fa-slideshare:before {\n    content: \"\\f1e7\"\n}\n\n.fa-smile:before {\n    content: \"\\f118\"\n}\n\n.fa-smile-beam:before {\n    content: \"\\f5b8\"\n}\n\n.fa-smile-plus:before {\n    content: \"\\f5b9\"\n}\n\n.fa-smile-wink:before {\n    content: \"\\f4da\"\n}\n\n.fa-smog:before {\n    content: \"\\f75f\"\n}\n\n.fa-smoke:before {\n    content: \"\\f760\"\n}\n\n.fa-smoking:before {\n    content: \"\\f48d\"\n}\n\n.fa-smoking-ban:before {\n    content: \"\\f54d\"\n}\n\n.fa-snake:before {\n    content: \"\\f716\"\n}\n\n.fa-snapchat:before {\n    content: \"\\f2ab\"\n}\n\n.fa-snapchat-ghost:before {\n    content: \"\\f2ac\"\n}\n\n.fa-snapchat-square:before {\n    content: \"\\f2ad\"\n}\n\n.fa-snow-blowing:before {\n    content: \"\\f761\"\n}\n\n.fa-snowflake:before {\n    content: \"\\f2dc\"\n}\n\n.fa-socks:before {\n    content: \"\\f696\"\n}\n\n.fa-solar-panel:before {\n    content: \"\\f5ba\"\n}\n\n.fa-sort:before {\n    content: \"\\f0dc\"\n}\n\n.fa-sort-alpha-down:before {\n    content: \"\\f15d\"\n}\n\n.fa-sort-alpha-up:before {\n    content: \"\\f15e\"\n}\n\n.fa-sort-amount-down:before {\n    content: \"\\f160\"\n}\n\n.fa-sort-amount-up:before {\n    content: \"\\f161\"\n}\n\n.fa-sort-down:before {\n    content: \"\\f0dd\"\n}\n\n.fa-sort-numeric-down:before {\n    content: \"\\f162\"\n}\n\n.fa-sort-numeric-up:before {\n    content: \"\\f163\"\n}\n\n.fa-sort-up:before {\n    content: \"\\f0de\"\n}\n\n.fa-soundcloud:before {\n    content: \"\\f1be\"\n}\n\n.fa-spa:before {\n    content: \"\\f5bb\"\n}\n\n.fa-space-shuttle:before {\n    content: \"\\f197\"\n}\n\n.fa-spade:before {\n    content: \"\\f2f4\"\n}\n\n.fa-speakap:before {\n    content: \"\\f3f3\"\n}\n\n.fa-spider:before {\n    content: \"\\f717\"\n}\n\n.fa-spider-black-widow:before {\n    content: \"\\f718\"\n}\n\n.fa-spider-web:before {\n    content: \"\\f719\"\n}\n\n.fa-spinner:before {\n    content: \"\\f110\"\n}\n\n.fa-spinner-third:before {\n    content: \"\\f3f4\"\n}\n\n.fa-splotch:before {\n    content: \"\\f5bc\"\n}\n\n.fa-spotify:before {\n    content: \"\\f1bc\"\n}\n\n.fa-spray-can:before {\n    content: \"\\f5bd\"\n}\n\n.fa-square:before {\n    content: \"\\f0c8\"\n}\n\n.fa-square-full:before {\n    content: \"\\f45c\"\n}\n\n.fa-square-root:before {\n    content: \"\\f697\"\n}\n\n.fa-square-root-alt:before {\n    content: \"\\f698\"\n}\n\n.fa-squarespace:before {\n    content: \"\\f5be\"\n}\n\n.fa-squirrel:before {\n    content: \"\\f71a\"\n}\n\n.fa-stack-exchange:before {\n    content: \"\\f18d\"\n}\n\n.fa-stack-overflow:before {\n    content: \"\\f16c\"\n}\n\n.fa-staff:before {\n    content: \"\\f71b\"\n}\n\n.fa-stamp:before {\n    content: \"\\f5bf\"\n}\n\n.fa-star:before {\n    content: \"\\f005\"\n}\n\n.fa-star-and-crescent:before {\n    content: \"\\f699\"\n}\n\n.fa-star-exclamation:before {\n    content: \"\\f2f3\"\n}\n\n.fa-star-half:before {\n    content: \"\\f089\"\n}\n\n.fa-star-half-alt:before {\n    content: \"\\f5c0\"\n}\n\n.fa-star-of-david:before {\n    content: \"\\f69a\"\n}\n\n.fa-star-of-life:before {\n    content: \"\\f621\"\n}\n\n.fa-stars:before {\n    content: \"\\f762\"\n}\n\n.fa-staylinked:before {\n    content: \"\\f3f5\"\n}\n\n.fa-steam:before {\n    content: \"\\f1b6\"\n}\n\n.fa-steam-square:before {\n    content: \"\\f1b7\"\n}\n\n.fa-steam-symbol:before {\n    content: \"\\f3f6\"\n}\n\n.fa-steering-wheel:before {\n    content: \"\\f622\"\n}\n\n.fa-step-backward:before {\n    content: \"\\f048\"\n}\n\n.fa-step-forward:before {\n    content: \"\\f051\"\n}\n\n.fa-stethoscope:before {\n    content: \"\\f0f1\"\n}\n\n.fa-sticker-mule:before {\n    content: \"\\f3f7\"\n}\n\n.fa-sticky-note:before {\n    content: \"\\f249\"\n}\n\n.fa-stomach:before {\n    content: \"\\f623\"\n}\n\n.fa-stop:before {\n    content: \"\\f04d\"\n}\n\n.fa-stop-circle:before {\n    content: \"\\f28d\"\n}\n\n.fa-stopwatch:before {\n    content: \"\\f2f2\"\n}\n\n.fa-store:before {\n    content: \"\\f54e\"\n}\n\n.fa-store-alt:before {\n    content: \"\\f54f\"\n}\n\n.fa-strava:before {\n    content: \"\\f428\"\n}\n\n.fa-stream:before {\n    content: \"\\f550\"\n}\n\n.fa-street-view:before {\n    content: \"\\f21d\"\n}\n\n.fa-strikethrough:before {\n    content: \"\\f0cc\"\n}\n\n.fa-stripe:before {\n    content: \"\\f429\"\n}\n\n.fa-stripe-s:before {\n    content: \"\\f42a\"\n}\n\n.fa-stroopwafel:before {\n    content: \"\\f551\"\n}\n\n.fa-studiovinari:before {\n    content: \"\\f3f8\"\n}\n\n.fa-stumbleupon:before {\n    content: \"\\f1a4\"\n}\n\n.fa-stumbleupon-circle:before {\n    content: \"\\f1a3\"\n}\n\n.fa-subscript:before {\n    content: \"\\f12c\"\n}\n\n.fa-subway:before {\n    content: \"\\f239\"\n}\n\n.fa-suitcase:before {\n    content: \"\\f0f2\"\n}\n\n.fa-suitcase-rolling:before {\n    content: \"\\f5c1\"\n}\n\n.fa-sun:before {\n    content: \"\\f185\"\n}\n\n.fa-sun-cloud:before {\n    content: \"\\f763\"\n}\n\n.fa-sun-dust:before {\n    content: \"\\f764\"\n}\n\n.fa-sun-haze:before {\n    content: \"\\f765\"\n}\n\n.fa-sunrise:before {\n    content: \"\\f766\"\n}\n\n.fa-sunset:before {\n    content: \"\\f767\"\n}\n\n.fa-superpowers:before {\n    content: \"\\f2dd\"\n}\n\n.fa-superscript:before {\n    content: \"\\f12b\"\n}\n\n.fa-supple:before {\n    content: \"\\f3f9\"\n}\n\n.fa-surprise:before {\n    content: \"\\f5c2\"\n}\n\n.fa-swatchbook:before {\n    content: \"\\f5c3\"\n}\n\n.fa-swimmer:before {\n    content: \"\\f5c4\"\n}\n\n.fa-swimming-pool:before {\n    content: \"\\f5c5\"\n}\n\n.fa-sword:before {\n    content: \"\\f71c\"\n}\n\n.fa-swords:before {\n    content: \"\\f71d\"\n}\n\n.fa-synagogue:before {\n    content: \"\\f69b\"\n}\n\n.fa-sync:before {\n    content: \"\\f021\"\n}\n\n.fa-sync-alt:before {\n    content: \"\\f2f1\"\n}\n\n.fa-syringe:before {\n    content: \"\\f48e\"\n}\n\n.fa-table:before {\n    content: \"\\f0ce\"\n}\n\n.fa-table-tennis:before {\n    content: \"\\f45d\"\n}\n\n.fa-tablet:before {\n    content: \"\\f10a\"\n}\n\n.fa-tablet-alt:before {\n    content: \"\\f3fa\"\n}\n\n.fa-tablet-android:before {\n    content: \"\\f3fb\"\n}\n\n.fa-tablet-android-alt:before {\n    content: \"\\f3fc\"\n}\n\n.fa-tablet-rugged:before {\n    content: \"\\f48f\"\n}\n\n.fa-tablets:before {\n    content: \"\\f490\"\n}\n\n.fa-tachometer:before {\n    content: \"\\f0e4\"\n}\n\n.fa-tachometer-alt:before {\n    content: \"\\f3fd\"\n}\n\n.fa-tachometer-alt-average:before {\n    content: \"\\f624\"\n}\n\n.fa-tachometer-alt-fast:before {\n    content: \"\\f625\"\n}\n\n.fa-tachometer-alt-fastest:before {\n    content: \"\\f626\"\n}\n\n.fa-tachometer-alt-slow:before {\n    content: \"\\f627\"\n}\n\n.fa-tachometer-alt-slowest:before {\n    content: \"\\f628\"\n}\n\n.fa-tachometer-average:before {\n    content: \"\\f629\"\n}\n\n.fa-tachometer-fast:before {\n    content: \"\\f62a\"\n}\n\n.fa-tachometer-fastest:before {\n    content: \"\\f62b\"\n}\n\n.fa-tachometer-slow:before {\n    content: \"\\f62c\"\n}\n\n.fa-tachometer-slowest:before {\n    content: \"\\f62d\"\n}\n\n.fa-tag:before {\n    content: \"\\f02b\"\n}\n\n.fa-tags:before {\n    content: \"\\f02c\"\n}\n\n.fa-tally:before {\n    content: \"\\f69c\"\n}\n\n.fa-tape:before {\n    content: \"\\f4db\"\n}\n\n.fa-tasks:before {\n    content: \"\\f0ae\"\n}\n\n.fa-taxi:before {\n    content: \"\\f1ba\"\n}\n\n.fa-teamspeak:before {\n    content: \"\\f4f9\"\n}\n\n.fa-teeth:before {\n    content: \"\\f62e\"\n}\n\n.fa-teeth-open:before {\n    content: \"\\f62f\"\n}\n\n.fa-telegram:before {\n    content: \"\\f2c6\"\n}\n\n.fa-telegram-plane:before {\n    content: \"\\f3fe\"\n}\n\n.fa-temperature-frigid:before {\n    content: \"\\f768\"\n}\n\n.fa-temperature-high:before {\n    content: \"\\f769\"\n}\n\n.fa-temperature-hot:before {\n    content: \"\\f76a\"\n}\n\n.fa-temperature-low:before {\n    content: \"\\f76b\"\n}\n\n.fa-tencent-weibo:before {\n    content: \"\\f1d5\"\n}\n\n.fa-tennis-ball:before {\n    content: \"\\f45e\"\n}\n\n.fa-terminal:before {\n    content: \"\\f120\"\n}\n\n.fa-text-height:before {\n    content: \"\\f034\"\n}\n\n.fa-text-width:before {\n    content: \"\\f035\"\n}\n\n.fa-th:before {\n    content: \"\\f00a\"\n}\n\n.fa-th-large:before {\n    content: \"\\f009\"\n}\n\n.fa-th-list:before {\n    content: \"\\f00b\"\n}\n\n.fa-the-red-yeti:before {\n    content: \"\\f69d\"\n}\n\n.fa-theater-masks:before {\n    content: \"\\f630\"\n}\n\n.fa-themeco:before {\n    content: \"\\f5c6\"\n}\n\n.fa-themeisle:before {\n    content: \"\\f2b2\"\n}\n\n.fa-thermometer:before {\n    content: \"\\f491\"\n}\n\n.fa-thermometer-empty:before {\n    content: \"\\f2cb\"\n}\n\n.fa-thermometer-full:before {\n    content: \"\\f2c7\"\n}\n\n.fa-thermometer-half:before {\n    content: \"\\f2c9\"\n}\n\n.fa-thermometer-quarter:before {\n    content: \"\\f2ca\"\n}\n\n.fa-thermometer-three-quarters:before {\n    content: \"\\f2c8\"\n}\n\n.fa-theta:before {\n    content: \"\\f69e\"\n}\n\n.fa-think-peaks:before {\n    content: \"\\f731\"\n}\n\n.fa-thumbs-down:before {\n    content: \"\\f165\"\n}\n\n.fa-thumbs-up:before {\n    content: \"\\f164\"\n}\n\n.fa-thumbtack:before {\n    content: \"\\f08d\"\n}\n\n.fa-thunderstorm:before {\n    content: \"\\f76c\"\n}\n\n.fa-thunderstorm-moon:before {\n    content: \"\\f76d\"\n}\n\n.fa-thunderstorm-sun:before {\n    content: \"\\f76e\"\n}\n\n.fa-ticket:before {\n    content: \"\\f145\"\n}\n\n.fa-ticket-alt:before {\n    content: \"\\f3ff\"\n}\n\n.fa-tilde:before {\n    content: \"\\f69f\"\n}\n\n.fa-times:before {\n    content: \"\\f00d\"\n}\n\n.fa-times-circle:before {\n    content: \"\\f057\"\n}\n\n.fa-times-hexagon:before {\n    content: \"\\f2ee\"\n}\n\n.fa-times-octagon:before {\n    content: \"\\f2f0\"\n}\n\n.fa-times-square:before {\n    content: \"\\f2d3\"\n}\n\n.fa-tint:before {\n    content: \"\\f043\"\n}\n\n.fa-tint-slash:before {\n    content: \"\\f5c7\"\n}\n\n.fa-tire:before {\n    content: \"\\f631\"\n}\n\n.fa-tire-flat:before {\n    content: \"\\f632\"\n}\n\n.fa-tire-pressure-warning:before {\n    content: \"\\f633\"\n}\n\n.fa-tire-rugged:before {\n    content: \"\\f634\"\n}\n\n.fa-tired:before {\n    content: \"\\f5c8\"\n}\n\n.fa-toggle-off:before {\n    content: \"\\f204\"\n}\n\n.fa-toggle-on:before {\n    content: \"\\f205\"\n}\n\n.fa-toilet-paper:before {\n    content: \"\\f71e\"\n}\n\n.fa-toilet-paper-alt:before {\n    content: \"\\f71f\"\n}\n\n.fa-tombstone:before {\n    content: \"\\f720\"\n}\n\n.fa-tombstone-alt:before {\n    content: \"\\f721\"\n}\n\n.fa-toolbox:before {\n    content: \"\\f552\"\n}\n\n.fa-tooth:before {\n    content: \"\\f5c9\"\n}\n\n.fa-toothbrush:before {\n    content: \"\\f635\"\n}\n\n.fa-torah:before {\n    content: \"\\f6a0\"\n}\n\n.fa-torii-gate:before {\n    content: \"\\f6a1\"\n}\n\n.fa-tornado:before {\n    content: \"\\f76f\"\n}\n\n.fa-tractor:before {\n    content: \"\\f722\"\n}\n\n.fa-trade-federation:before {\n    content: \"\\f513\"\n}\n\n.fa-trademark:before {\n    content: \"\\f25c\"\n}\n\n.fa-traffic-cone:before {\n    content: \"\\f636\"\n}\n\n.fa-traffic-light:before {\n    content: \"\\f637\"\n}\n\n.fa-traffic-light-go:before {\n    content: \"\\f638\"\n}\n\n.fa-traffic-light-slow:before {\n    content: \"\\f639\"\n}\n\n.fa-traffic-light-stop:before {\n    content: \"\\f63a\"\n}\n\n.fa-train:before {\n    content: \"\\f238\"\n}\n\n.fa-transgender:before {\n    content: \"\\f224\"\n}\n\n.fa-transgender-alt:before {\n    content: \"\\f225\"\n}\n\n.fa-trash:before {\n    content: \"\\f1f8\"\n}\n\n.fa-trash-alt:before {\n    content: \"\\f2ed\"\n}\n\n.fa-treasure-chest:before {\n    content: \"\\f723\"\n}\n\n.fa-tree:before {\n    content: \"\\f1bb\"\n}\n\n.fa-tree-alt:before {\n    content: \"\\f400\"\n}\n\n.fa-trees:before {\n    content: \"\\f724\"\n}\n\n.fa-trello:before {\n    content: \"\\f181\"\n}\n\n.fa-triangle:before {\n    content: \"\\f2ec\"\n}\n\n.fa-tripadvisor:before {\n    content: \"\\f262\"\n}\n\n.fa-trophy:before {\n    content: \"\\f091\"\n}\n\n.fa-trophy-alt:before {\n    content: \"\\f2eb\"\n}\n\n.fa-truck:before {\n    content: \"\\f0d1\"\n}\n\n.fa-truck-container:before {\n    content: \"\\f4dc\"\n}\n\n.fa-truck-couch:before {\n    content: \"\\f4dd\"\n}\n\n.fa-truck-loading:before {\n    content: \"\\f4de\"\n}\n\n.fa-truck-monster:before {\n    content: \"\\f63b\"\n}\n\n.fa-truck-moving:before {\n    content: \"\\f4df\"\n}\n\n.fa-truck-pickup:before {\n    content: \"\\f63c\"\n}\n\n.fa-truck-ramp:before {\n    content: \"\\f4e0\"\n}\n\n.fa-tshirt:before {\n    content: \"\\f553\"\n}\n\n.fa-tty:before {\n    content: \"\\f1e4\"\n}\n\n.fa-tumblr:before {\n    content: \"\\f173\"\n}\n\n.fa-tumblr-square:before {\n    content: \"\\f174\"\n}\n\n.fa-turkey:before {\n    content: \"\\f725\"\n}\n\n.fa-turtle:before {\n    content: \"\\f726\"\n}\n\n.fa-tv:before {\n    content: \"\\f26c\"\n}\n\n.fa-tv-retro:before {\n    content: \"\\f401\"\n}\n\n.fa-twitch:before {\n    content: \"\\f1e8\"\n}\n\n.fa-twitter:before {\n    content: \"\\f099\"\n}\n\n.fa-twitter-square:before {\n    content: \"\\f081\"\n}\n\n.fa-typo3:before {\n    content: \"\\f42b\"\n}\n\n.fa-uber:before {\n    content: \"\\f402\"\n}\n\n.fa-uikit:before {\n    content: \"\\f403\"\n}\n\n.fa-umbrella:before {\n    content: \"\\f0e9\"\n}\n\n.fa-umbrella-beach:before {\n    content: \"\\f5ca\"\n}\n\n.fa-underline:before {\n    content: \"\\f0cd\"\n}\n\n.fa-undo:before {\n    content: \"\\f0e2\"\n}\n\n.fa-undo-alt:before {\n    content: \"\\f2ea\"\n}\n\n.fa-unicorn:before {\n    content: \"\\f727\"\n}\n\n.fa-union:before {\n    content: \"\\f6a2\"\n}\n\n.fa-uniregistry:before {\n    content: \"\\f404\"\n}\n\n.fa-universal-access:before {\n    content: \"\\f29a\"\n}\n\n.fa-university:before {\n    content: \"\\f19c\"\n}\n\n.fa-unlink:before {\n    content: \"\\f127\"\n}\n\n.fa-unlock:before {\n    content: \"\\f09c\"\n}\n\n.fa-unlock-alt:before {\n    content: \"\\f13e\"\n}\n\n.fa-untappd:before {\n    content: \"\\f405\"\n}\n\n.fa-upload:before {\n    content: \"\\f093\"\n}\n\n.fa-usb:before {\n    content: \"\\f287\"\n}\n\n.fa-usd-circle:before {\n    content: \"\\f2e8\"\n}\n\n.fa-usd-square:before {\n    content: \"\\f2e9\"\n}\n\n.fa-user:before {\n    content: \"\\f007\"\n}\n\n.fa-user-alt:before {\n    content: \"\\f406\"\n}\n\n.fa-user-alt-slash:before {\n    content: \"\\f4fa\"\n}\n\n.fa-user-astronaut:before {\n    content: \"\\f4fb\"\n}\n\n.fa-user-chart:before {\n    content: \"\\f6a3\"\n}\n\n.fa-user-check:before {\n    content: \"\\f4fc\"\n}\n\n.fa-user-circle:before {\n    content: \"\\f2bd\"\n}\n\n.fa-user-clock:before {\n    content: \"\\f4fd\"\n}\n\n.fa-user-cog:before {\n    content: \"\\f4fe\"\n}\n\n.fa-user-crown:before {\n    content: \"\\f6a4\"\n}\n\n.fa-user-edit:before {\n    content: \"\\f4ff\"\n}\n\n.fa-user-friends:before {\n    content: \"\\f500\"\n}\n\n.fa-user-graduate:before {\n    content: \"\\f501\"\n}\n\n.fa-user-injured:before {\n    content: \"\\f728\"\n}\n\n.fa-user-lock:before {\n    content: \"\\f502\"\n}\n\n.fa-user-md:before {\n    content: \"\\f0f0\"\n}\n\n.fa-user-minus:before {\n    content: \"\\f503\"\n}\n\n.fa-user-ninja:before {\n    content: \"\\f504\"\n}\n\n.fa-user-plus:before {\n    content: \"\\f234\"\n}\n\n.fa-user-secret:before {\n    content: \"\\f21b\"\n}\n\n.fa-user-shield:before {\n    content: \"\\f505\"\n}\n\n.fa-user-slash:before {\n    content: \"\\f506\"\n}\n\n.fa-user-tag:before {\n    content: \"\\f507\"\n}\n\n.fa-user-tie:before {\n    content: \"\\f508\"\n}\n\n.fa-user-times:before {\n    content: \"\\f235\"\n}\n\n.fa-users:before {\n    content: \"\\f0c0\"\n}\n\n.fa-users-class:before {\n    content: \"\\f63d\"\n}\n\n.fa-users-cog:before {\n    content: \"\\f509\"\n}\n\n.fa-users-crown:before {\n    content: \"\\f6a5\"\n}\n\n.fa-ussunnah:before {\n    content: \"\\f407\"\n}\n\n.fa-utensil-fork:before {\n    content: \"\\f2e3\"\n}\n\n.fa-utensil-knife:before {\n    content: \"\\f2e4\"\n}\n\n.fa-utensil-spoon:before {\n    content: \"\\f2e5\"\n}\n\n.fa-utensils:before {\n    content: \"\\f2e7\"\n}\n\n.fa-utensils-alt:before {\n    content: \"\\f2e6\"\n}\n\n.fa-vaadin:before {\n    content: \"\\f408\"\n}\n\n.fa-value-absolute:before {\n    content: \"\\f6a6\"\n}\n\n.fa-vector-square:before {\n    content: \"\\f5cb\"\n}\n\n.fa-venus:before {\n    content: \"\\f221\"\n}\n\n.fa-venus-double:before {\n    content: \"\\f226\"\n}\n\n.fa-venus-mars:before {\n    content: \"\\f228\"\n}\n\n.fa-viacoin:before {\n    content: \"\\f237\"\n}\n\n.fa-viadeo:before {\n    content: \"\\f2a9\"\n}\n\n.fa-viadeo-square:before {\n    content: \"\\f2aa\"\n}\n\n.fa-vial:before {\n    content: \"\\f492\"\n}\n\n.fa-vials:before {\n    content: \"\\f493\"\n}\n\n.fa-viber:before {\n    content: \"\\f409\"\n}\n\n.fa-video:before {\n    content: \"\\f03d\"\n}\n\n.fa-video-plus:before {\n    content: \"\\f4e1\"\n}\n\n.fa-video-slash:before {\n    content: \"\\f4e2\"\n}\n\n.fa-vihara:before {\n    content: \"\\f6a7\"\n}\n\n.fa-vimeo:before {\n    content: \"\\f40a\"\n}\n\n.fa-vimeo-square:before {\n    content: \"\\f194\"\n}\n\n.fa-vimeo-v:before {\n    content: \"\\f27d\"\n}\n\n.fa-vine:before {\n    content: \"\\f1ca\"\n}\n\n.fa-vk:before {\n    content: \"\\f189\"\n}\n\n.fa-vnv:before {\n    content: \"\\f40b\"\n}\n\n.fa-volcano:before {\n    content: \"\\f770\"\n}\n\n.fa-volleyball-ball:before {\n    content: \"\\f45f\"\n}\n\n.fa-volume:before {\n    content: \"\\f6a8\"\n}\n\n.fa-volume-down:before {\n    content: \"\\f027\"\n}\n\n.fa-volume-mute:before {\n    content: \"\\f6a9\"\n}\n\n.fa-volume-off:before {\n    content: \"\\f026\"\n}\n\n.fa-volume-slash:before {\n    content: \"\\f2e2\"\n}\n\n.fa-volume-up:before {\n    content: \"\\f028\"\n}\n\n.fa-vote-nay:before {\n    content: \"\\f771\"\n}\n\n.fa-vote-yea:before {\n    content: \"\\f772\"\n}\n\n.fa-vr-cardboard:before {\n    content: \"\\f729\"\n}\n\n.fa-vuejs:before {\n    content: \"\\f41f\"\n}\n\n.fa-walking:before {\n    content: \"\\f554\"\n}\n\n.fa-wallet:before {\n    content: \"\\f555\"\n}\n\n.fa-wand:before {\n    content: \"\\f72a\"\n}\n\n.fa-wand-magic:before {\n    content: \"\\f72b\"\n}\n\n.fa-warehouse:before {\n    content: \"\\f494\"\n}\n\n.fa-warehouse-alt:before {\n    content: \"\\f495\"\n}\n\n.fa-watch:before {\n    content: \"\\f2e1\"\n}\n\n.fa-watch-fitness:before {\n    content: \"\\f63e\"\n}\n\n.fa-water:before {\n    content: \"\\f773\"\n}\n\n.fa-water-lower:before {\n    content: \"\\f774\"\n}\n\n.fa-water-rise:before {\n    content: \"\\f775\"\n}\n\n.fa-weebly:before {\n    content: \"\\f5cc\"\n}\n\n.fa-weibo:before {\n    content: \"\\f18a\"\n}\n\n.fa-weight:before {\n    content: \"\\f496\"\n}\n\n.fa-weight-hanging:before {\n    content: \"\\f5cd\"\n}\n\n.fa-weixin:before {\n    content: \"\\f1d7\"\n}\n\n.fa-whale:before {\n    content: \"\\f72c\"\n}\n\n.fa-whatsapp:before {\n    content: \"\\f232\"\n}\n\n.fa-whatsapp-square:before {\n    content: \"\\f40c\"\n}\n\n.fa-wheat:before {\n    content: \"\\f72d\"\n}\n\n.fa-wheelchair:before {\n    content: \"\\f193\"\n}\n\n.fa-whistle:before {\n    content: \"\\f460\"\n}\n\n.fa-whmcs:before {\n    content: \"\\f40d\"\n}\n\n.fa-wifi:before {\n    content: \"\\f1eb\"\n}\n\n.fa-wifi-1:before {\n    content: \"\\f6aa\"\n}\n\n.fa-wifi-2:before {\n    content: \"\\f6ab\"\n}\n\n.fa-wifi-slash:before {\n    content: \"\\f6ac\"\n}\n\n.fa-wikipedia-w:before {\n    content: \"\\f266\"\n}\n\n.fa-wind:before {\n    content: \"\\f72e\"\n}\n\n.fa-wind-warning:before {\n    content: \"\\f776\"\n}\n\n.fa-window:before {\n    content: \"\\f40e\"\n}\n\n.fa-window-alt:before {\n    content: \"\\f40f\"\n}\n\n.fa-window-close:before {\n    content: \"\\f410\"\n}\n\n.fa-window-maximize:before {\n    content: \"\\f2d0\"\n}\n\n.fa-window-minimize:before {\n    content: \"\\f2d1\"\n}\n\n.fa-window-restore:before {\n    content: \"\\f2d2\"\n}\n\n.fa-windows:before {\n    content: \"\\f17a\"\n}\n\n.fa-windsock:before {\n    content: \"\\f777\"\n}\n\n.fa-wine-bottle:before {\n    content: \"\\f72f\"\n}\n\n.fa-wine-glass:before {\n    content: \"\\f4e3\"\n}\n\n.fa-wine-glass-alt:before {\n    content: \"\\f5ce\"\n}\n\n.fa-wix:before {\n    content: \"\\f5cf\"\n}\n\n.fa-wizards-of-the-coast:before {\n    content: \"\\f730\"\n}\n\n.fa-wolf-pack-battalion:before {\n    content: \"\\f514\"\n}\n\n.fa-won-sign:before {\n    content: \"\\f159\"\n}\n\n.fa-wordpress:before {\n    content: \"\\f19a\"\n}\n\n.fa-wordpress-simple:before {\n    content: \"\\f411\"\n}\n\n.fa-wpbeginner:before {\n    content: \"\\f297\"\n}\n\n.fa-wpexplorer:before {\n    content: \"\\f2de\"\n}\n\n.fa-wpforms:before {\n    content: \"\\f298\"\n}\n\n.fa-wpressr:before {\n    content: \"\\f3e4\"\n}\n\n.fa-wrench:before {\n    content: \"\\f0ad\"\n}\n\n.fa-x-ray:before {\n    content: \"\\f497\"\n}\n\n.fa-xbox:before {\n    content: \"\\f412\"\n}\n\n.fa-xing:before {\n    content: \"\\f168\"\n}\n\n.fa-xing-square:before {\n    content: \"\\f169\"\n}\n\n.fa-y-combinator:before {\n    content: \"\\f23b\"\n}\n\n.fa-yahoo:before {\n    content: \"\\f19e\"\n}\n\n.fa-yandex:before {\n    content: \"\\f413\"\n}\n\n.fa-yandex-international:before {\n    content: \"\\f414\"\n}\n\n.fa-yelp:before {\n    content: \"\\f1e9\"\n}\n\n.fa-yen-sign:before {\n    content: \"\\f157\"\n}\n\n.fa-yin-yang:before {\n    content: \"\\f6ad\"\n}\n\n.fa-yoast:before {\n    content: \"\\f2b1\"\n}\n\n.fa-youtube:before {\n    content: \"\\f167\"\n}\n\n.fa-youtube-square:before {\n    content: \"\\f431\"\n}\n\n.fa-zhihu:before {\n    content: \"\\f63f\"\n}\n\n.sr-only {\n    border: 0;\n    clip: rect(0, 0, 0, 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n    clip: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    position: static;\n    width: auto\n}\n";
styleInject(css_248z$4);
var css_248z$3 = "/*!\n * Font Awesome Pro 5.5.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@font-face {\n    font-family: \"Font Awesome 5 Brands\";\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-brands-400.eot);\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-brands-400.eot?#iefix) format(\"embedded-opentype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-brands-400.woff2) format(\"woff2\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-brands-400.woff) format(\"woff\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-brands-400.ttf) format(\"truetype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-brands-400.svg#fontawesome) format(\"svg\")\n}\n\n.fab {\n    font-family: \"Font Awesome 5 Brands\"\n}\n";
styleInject(css_248z$3);
var css_248z$2 = "/*!\n * Font Awesome Pro 5.5.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@font-face {\n    font-family: \"Font Awesome 5 Pro\";\n    font-style: normal;\n    font-weight: 300;\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-light-300.eot);\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-light-300.eot?#iefix) format(\"embedded-opentype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-light-300.woff2) format(\"woff2\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-light-300.woff) format(\"woff\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-light-300.ttf) format(\"truetype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-light-300.svg#fontawesome) format(\"svg\")\n}\n\n.fal {\n    font-family: \"Font Awesome 5 Pro\";\n    font-weight: 300\n}\n";
styleInject(css_248z$2);
var css_248z$1 = "/*!\n * Font Awesome Pro 5.5.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@font-face {\n    font-family: \"Font Awesome 5 Pro\";\n    font-style: normal;\n    font-weight: 400;\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-regular-400.eot);\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-regular-400.eot?#iefix) format(\"embedded-opentype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-regular-400.woff2) format(\"woff2\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-regular-400.woff) format(\"woff\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-regular-400.ttf) format(\"truetype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-regular-400.svg#fontawesome) format(\"svg\")\n}\n\n.far {\n    font-family: \"Font Awesome 5 Pro\";\n    font-weight: 400\n}\n";
styleInject(css_248z$1);
var css_248z = "/*!\n * Font Awesome Pro 5.5.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@font-face {\n    font-family: \"Font Awesome 5 Pro\";\n    font-style: normal;\n    font-weight: 900;\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-solid-900.eot);\n    src: url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-solid-900.eot?#iefix) format(\"embedded-opentype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-solid-900.woff2) format(\"woff2\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-solid-900.woff) format(\"woff\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-solid-900.ttf) format(\"truetype\"), url(https://scontent01.fabfitfun.com/shared/font-awesome-collection/webfonts/fa-solid-900.svg#fontawesome) format(\"svg\")\n}\n\n.fa, .fas {\n    font-family: \"Font Awesome 5 Pro\";\n    font-weight: 900\n}\n";
styleInject(css_248z);
createCommonjsModule$1(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FontAwesomeCollection = function FontAwesomeCollection() {
    return _react2.default.createElement("div", null);
  };

  exports.default = FontAwesomeCollection;
});
var boxStateKey = 'box-state';
var cacheDurationInMs$2 = 15 * 60 * 1000; //15 minutes

var HIDE_SWAP_FOR = ['SKIPPED_INTRO']; // In case more than one state makes the Swap for Credit link to go away

var useBoxState = function useBoxState(isLogin) {
  var _useState13 = useState(storage.getFromStorage({
    key: boxStateKey
  })),
      _useState14 = _slicedToArray2(_useState13, 2),
      boxState = _useState14[0],
      setBoxState = _useState14[1];

  useEffect(function () {
    if (isLogin) {
      var boxStateCache = storage.getFromStorage({
        key: boxStateKey
      });

      if (boxStateCache) {
        if (!compare.isEqualObject(boxState, boxStateCache)) {
          setBoxState(boxStateCache);
        }
      } else {
        getBoxState().then(function (content) {
          setBoxState(content);
          storage.setToStorage({
            key: boxStateKey,
            value: content,
            durationInMs: cacheDurationInMs$2
          });
        });
      }
    }
  }, [boxState, isLogin]);
  var hideSwap = HIDE_SWAP_FOR.includes(boxState);
  return {
    boxState: boxState,
    hideSwap: hideSwap
  };
};

var chatConfigurationContentKey = 'footer-chat-configuration';
var cacheDurationInMs$1 = 30 * 60 * 1000; //15 minutes

var useChatConfiguration = function useChatConfiguration() {
  var _useState15 = useState(storage.getFromStorage({
    key: chatConfigurationContentKey
  })),
      _useState16 = _slicedToArray2(_useState15, 2),
      chatConfiguration = _useState16[0],
      setChatConfiguration = _useState16[1];

  useEffect(function () {
    var chatConfigurationCache = storage.getFromStorage({
      key: chatConfigurationContentKey
    });

    if (chatConfigurationCache) {
      if (!compare.isEqualObject(chatConfiguration, chatConfigurationCache)) {
        setChatConfiguration(chatConfigurationCache);
      }
    } else {
      getContent('global-footer-chat', 'default').then(function (content) {
        setChatConfiguration(content);
        storage.setToStorage({
          key: chatConfigurationContentKey,
          value: content,
          durationInMs: cacheDurationInMs$1
        });
      });
    }
  }, [chatConfiguration]);
  return chatConfiguration;
};

var subscriptionPlansKey = 'subscription-plans';
var cacheDurationInMs = 15 * 60 * 1000; //15 minutes

var useSubscriptionPlans = function useSubscriptionPlans() {
  var _useState17 = useState(storage.getFromStorage({
    key: subscriptionPlansKey
  }) || {}),
      _useState18 = _slicedToArray2(_useState17, 2),
      subscriptionPlans = _useState18[0],
      setSubscriptionPlans = _useState18[1];

  useEffect(function () {
    var subscriptionPlansCache = storage.getFromStorage({
      key: subscriptionPlans
    });

    if (subscriptionPlansCache) {
      if (!compare.isEqualObject(subscriptionPlans, subscriptionPlansCache)) {
        setSubscriptionPlans(subscriptionPlansCache);
      }
    } else {
      getSubscriptionPlans().then(function (content) {
        setSubscriptionPlans(content);
        storage.setToStorage({
          key: subscriptionPlans,
          value: content,
          durationInMs: cacheDurationInMs
        });
      });
    }
  }, [subscriptionPlans]);
  return {
    subscriptionPlans: subscriptionPlans
  };
};

var useUserWay = function useUserWay() {
  useEffect(function () {
    var s = document.createElement('script');
    s.setAttribute('data-account', 'jcEETxr6Cv');
    s.setAttribute('src', 'https://accessibilityserver.org/widget.js');
    (document.body || document.head).appendChild(s);
  }, []);
  return null;
};

var mobileBreakpoint$1 = 767;
var tabletBreakpoint$1 = 1080;

var Footer$1 = function Footer(_ref) {
  var _ref$minimalFooter = _ref.minimalFooter,
      minimalFooter = _ref$minimalFooter === void 0 ? false : _ref$minimalFooter,
      _ref$hideChatWidget = _ref.hideChatWidget,
      hideChatWidget = _ref$hideChatWidget === void 0 ? false : _ref$hideChatWidget,
      _ref$isUseAnalytic = _ref.isUseAnalytic,
      isUseAnalytic = _ref$isUseAnalytic === void 0 ? true : _ref$isUseAnalytic;

  var _useFooterContent = useFooterContent(),
      footerContent = _useFooterContent.footerContent;

  var _useUserContext = useUserContext(),
      userInfo = _useUserContext.userInfo;

  var _useSubscriptionPlans = useSubscriptionPlans(),
      subscriptionPlans = _useSubscriptionPlans.subscriptionPlans;

  var chatConfig = useChatConfiguration();
  var data = footerContent;

  var _useFlags = lib.useFlags(),
      ccpaFooterLink = _useFlags.ccpaFooterLink;

  var _useShippingAddress = useShippingAddress(ccpaFooterLink || {}),
      state = _useShippingAddress.state,
      isLogin = _useShippingAddress.isLogin;

  var _useState = useState({
    width: isBrowser() ? window.innerWidth : 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  var isMobile = isBrowser() ? windowSize.width <= mobileBreakpoint$1 : 0;
  var isTablet = isBrowser() ? windowSize.width < tabletBreakpoint$1 && windowSize.width > mobileBreakpoint$1 : 0;

  var _useBoxState = useBoxState(isLogin),
      hideSwap = _useBoxState.hideSwap;

  var handleResize = function handleResize() {
    return setWindowSize({
      width: isBrowser() ? window.innerWidth : 0
    });
  };

  useUserWay();
  useEffect(function () {
    if (isBrowser()) {
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }

    return null;
  }, []);
  useEffect(function () {
    if (isUseAnalytic) {
      initialize();
    }

    loadPactSafe();
    loadOneTrust();
  }, []);
  useEffect(function () {
    !hideChatWidget && loadChat(chatConfig);
  }, [chatConfig, hideChatWidget]);
  var footerContainer = classnames({
    'fff-shared-footer-container-mobile': isMobile
  });
  var footerTop = classnames({
    'fff-shared-footer-container-top': true,
    'fff-shared-footer-container-top-logged': isLogin
  });

  var getLinks = function getLinks() {
    if (isLogin) {
      return data.mainFooter.loginState;
    }

    if (isMobile) {
      return data.mainFooter.logoutState.reduce(function (linksArray, _ref2) {
        var links = _ref2.links;
        return linksArray.concat(links);
      }, []);
    }

    return data.mainFooter.logoutState;
  };

  return data ? /*#__PURE__*/React.createElement("div", {
    className: classnames('fff-shared-footer-container', footerContainer, {
      'is-not-login': !isLogin
    })
  }, !minimalFooter && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fff-shared-footer-top-border"
  }), /*#__PURE__*/React.createElement("div", {
    className: footerTop
  }, !isLogin ? /*#__PURE__*/React.createElement(EmailCapture, {
    isTablet: isTablet,
    isMobile: isMobile
  }) : /*#__PURE__*/React.createElement("div", {
    className: "fff-logo-container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "logo",
    src: img,
    className: "fff-logo"
  }), !isMobile && isTablet && /*#__PURE__*/React.createElement(UserWay, null)), /*#__PURE__*/React.createElement(LinkFooter, {
    buildPath: buildPath,
    categories: getLinks(),
    isMobile: isMobile,
    isLogin: isLogin,
    userInfo: userInfo,
    hideSwap: hideSwap,
    subscriptionPlans: subscriptionPlans
  }), !isTablet && /*#__PURE__*/React.createElement(SMFooter, {
    socialMedias: data.socialMedias,
    isMobile: isMobile,
    isLogin: isLogin
  })), isTablet && /*#__PURE__*/React.createElement(SMFooter, {
    socialMedias: data.socialMedias,
    isMobile: isMobile,
    isTablet: true,
    isLogin: isLogin
  })), /*#__PURE__*/React.createElement(LegalFooter, {
    buildPath: buildPath,
    legals: data.legal,
    isMobile: isMobile,
    isTablet: isTablet,
    shippingState: state,
    isLogin: isLogin
  })) : null;
};

var GlobalFooterDefault = lib.withLDProvider({
  clientSideID: getLDClientId(),
  user: {
    key: 'anonymous',
    anonymous: true
  }
})(Footer$1);

var GlobalFooter = function GlobalFooter(props) {
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(UserProvider, null, /*#__PURE__*/React.createElement(GlobalFooterDefault, props)));
};

var mobileBreakpoint = 767;
var tabletBreakpoint = 1080;

var Footer = function Footer() {
  var _useFooterContent = useFooterContent(),
      footerContent = _useFooterContent.footerContent;

  var data = footerContent;

  var _useState = useState({
    width: isBrowser() ? window.innerWidth : 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  var isMobile = isBrowser() ? windowSize.width <= mobileBreakpoint : 0;
  var isTablet = isBrowser() ? windowSize.width < tabletBreakpoint && windowSize.width > mobileBreakpoint : 0;

  var handleResize = function handleResize() {
    return setWindowSize({
      width: isBrowser() ? window.innerWidth : 0
    });
  };

  useUserWay();
  useEffect(function () {
    if (isBrowser()) {
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }

    return null;
  }, []);
  useEffect(function () {
    initialize();
    loadPactSafe();
    loadOneTrust();
  }, []);
  var footerContainer = classnames({
    'fff-shared-footer-container-mobile': isMobile
  });
  var footerTop = classnames({
    'fff-shared-footer-container-top': true,
    'fff-shared-footer-container-top-logged': false
  });

  var getLinks = function getLinks() {
    if (isMobile) {
      return data.mainFooter.logoutState.reduce(function (linksArray, _ref) {
        var links = _ref.links;
        return linksArray.concat(links);
      }, []);
    }

    return data.mainFooter.logoutState;
  };

  if (!data) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('fff-shared-footer-container', footerContainer, {
      'is-not-login': true
    })
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fff-shared-footer-top-border"
  }), /*#__PURE__*/React.createElement("div", {
    className: footerTop
  }, /*#__PURE__*/React.createElement(EmailCapture, {
    isMobile: isMobile,
    isTablet: isTablet
  }), /*#__PURE__*/React.createElement(LinkFooter, {
    buildPath: buildPath,
    categories: getLinks(),
    isMobile: isMobile,
    isLogin: false
  }), !isTablet && /*#__PURE__*/React.createElement(SMFooter, {
    socialMedias: data.socialMedias,
    isMobile: isMobile,
    isLogin: false
  })), isTablet && /*#__PURE__*/React.createElement(SMFooter, {
    socialMedias: data.socialMedias,
    isMobile: isMobile,
    isTablet: true,
    isLogin: false
  })), /*#__PURE__*/React.createElement(LegalFooter, {
    buildPath: buildPath,
    legals: data.legal,
    isMobile: isMobile,
    isTablet: isTablet,
    shippingState: "",
    isLogin: false
  }));
};

var ProspectFooterDefault = lib.withLDProvider({
  clientSideID: getLDClientId(),
  user: {
    key: 'anonymous',
    anonymous: true
  }
})(Footer);

var ProspectFooter = function ProspectFooter(props) {
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ProspectFooterDefault, props));
};

export { GlobalFooter, ProspectFooter };